import * as React from "react"
import { SVGProps } from "react"
import "../css/svg.css"
const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    xmlSpace="preserve"
    id="Ebene_1"
    x={0}
    y={0}
    style={{
    // enableBackground: "new 0 0 841.9 595.3",
    }}
    viewBox="0 0 841.9 595.3"
    {...props}
  >
    <style>
      {
        ".st1{fill:#1268b3}.st2{enable-background:new}.st3{fill:#fff}.st5{fill:#d1d3d4}.st6{fill:#b1b3b6}.st8{fill:#9d9fa2}.st10{fill:#05437a}.st11{fill:#4d4d4f}.st12{fill:#77787b}.st14,.st34{fill:none;stroke:#05437a;stroke-width:2.5}.st34{stroke:#77787b;stroke-miterlimit:10}"
      }
    </style>
    <title>{"Kreisgrafik"}</title>
    <defs>
      <path id="SVGID_1_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_2_">
      <use
        xlinkHref="#SVGID_1_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_2_)",
      }}
    >
      <path
        d="m579.9 541.4 37.5-51.6c-23.9-17.5-34.1-48.2-25.5-76.6L532.7 394c-17.1 54.2 1.8 113.2 47.2 147.4M620.2 491.7l-37.5 51.7c47.1 33.3 107.3 33.3 154.3 0l-38.4-52.8c-23.4 16.4-54.5 16.9-78.4 1.1M787.8 394.3l-62.1 20.2c7.7 27.2-1.8 56.3-24 73.8l38.4 52.8c22.7-17 39.1-39.6 47.6-65.7s8.5-54 .1-81.1M786.6 390.7c-18.5-54.6-67.2-90-124.9-90.7v63.9c28.6 1.3 53.5 19.9 62.8 47l62.1-20.2zM657.5 363.8v-63.4c-57.2.8-105.6 35.9-124 90.1l59.5 19.3c9.9-27.2 35.6-45.5 64.5-46"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="m631.8 541.2 1.5-6.8 4.3 1-.2 1-3.1-.7-.4 1.7 2.8.6-.2 1-2.8-.6-.4 2 3.3.7-.2 1-4.6-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M640.7 535.9c1 .2 1.7.5 2.2.9.5.4.6 1 .5 1.8-.1.9-.7 1.5-1.7 1.7l.3.6c.1.2.2.5.4.8s.2.6.4.9c.1.3.2.6.3.8l-1.4-.2c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.7l-.3-.6h-.4l-.6-.1-.4 2.6-1.2-.2 1.1-6.7h1c.4 0 .4-.1.7 0zm-.1 1.1c-.3 0-.5-.1-.7-.1l-.4 2.2.5.1c.3 0 .6.1.8.1.2 0 .4 0 .6-.1.2-.1.3-.2.4-.3.1-.1.2-.3.2-.5v-.6c-.1-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.3-.1 0-.4-.1-.6-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m644.2 543.5.7-6.9 4.4.4-.1 1.1-3.1-.3-.2 1.8 2.8.3-.1 1.1-2.8-.3-.3 3-1.3-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M654 544.2c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8l-2.9-.1c-.1.3-.2.5-.3.8-.1.3-.2.5-.3.8l-1.3-.1c.3-.7.6-1.4.8-2 .3-.6.5-1.2.8-1.8.2-.5.5-1.1.7-1.6.2-.5.5-1 .7-1.5h1.2l.6 1.5c.2.5.4 1.1.6 1.6l.6 1.8c.2.6.4 1.3.7 2.1l-1.3.1zm-1.8-5.7c-.2.3-.4.8-.6 1.3-.2.5-.4 1-.7 1.6l2.3.1c-.2-.6-.4-1.2-.6-1.7-.2-.5-.3-.9-.4-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M658.4 543.3c.5 0 .8-.1 1-.2.2-.2.3-.4.3-.7 0-.2 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.5-.3-.2-.1-.4-.2-.6-.2-.2-.1-.5-.2-.7-.3-.2-.1-.4-.2-.6-.4-.2-.2-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.8-.6.4 0 .8 0 1.2.1.3.1.6.2.8.3l-.4 1c-.2-.1-.5-.2-.8-.3-.3-.1-.5-.1-.8-.1-.3 0-.6.1-.8.2s-.3.3-.3.6c0 .2 0 .3.1.4l.3.3c.1.1.3.2.4.2.2.1.3.1.5.2l.9.3c.3.1.5.3.7.4.2.2.3.4.4.6.1.2.1.5.2.8 0 .6-.2 1.1-.6 1.5-.4.4-1.1.5-1.9.5h-.8c-.2 0-.4-.1-.6-.1-.2-.1-.3-.1-.5-.2-.1-.1-.2-.1-.3-.1l.4-1c.2.1.4.2.7.3s.4.3.9.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M664.1 543.2c.5 0 .8-.1 1-.3.2-.2.3-.4.3-.7 0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.5-.2-.2-.1-.4-.1-.7-.2-.2-.1-.5-.2-.7-.2s-.4-.2-.6-.3c-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.7-.6.4 0 .8 0 1.2.1.3.1.6.2.8.3l-.3 1c-.2-.1-.5-.2-.8-.2s-.6-.1-.8 0c-.3 0-.6.1-.8.3-.2.2-.3.4-.2.6 0 .2 0 .3.1.4l.3.3c.1.1.3.2.4.2.2.1.3.1.5.2l.9.3c.3.1.5.2.7.4.2.2.3.4.4.6.1.2.2.5.2.8 0 .6-.2 1.1-.6 1.5-.4.4-1.1.6-1.9.6h-.8c-.2 0-.5-.1-.6-.1s-.3-.1-.5-.1c-.1 0-.2-.1-.3-.1l.3-1.1c.2.1.4.2.7.3.2-.4.5-.3 1-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M670.9 543.6c-.5.1-.9 0-1.2-.1-.4-.1-.7-.3-.9-.5-.3-.2-.4-.5-.6-.8-.1-.3-.2-.7-.3-1.1l-.5-4.3 1.3-.2.5 4.2c0 .3.1.6.2.8.1.2.2.4.4.5.1.1.3.2.5.3.2 0 .4.1.6 0 .2 0 .4-.1.6-.2.2-.1.3-.2.4-.4s.2-.3.2-.6v-.8l-.5-4.2 1.3-.2.5 4.3v1.1c-.1.3-.2.7-.4.9-.2.3-.5.5-.8.7s-.9.6-1.3.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M679.7 542c-.3-.3-.6-.7-1-1.1-.4-.4-.7-.8-1.1-1.1-.4-.4-.8-.7-1.1-1.1s-.7-.7-1.1-.9l.9 4.9-1.2.2-1.3-6.8 1-.2c.3.2.7.5 1 .8.4.3.8.7 1.1 1 .4.3.8.7 1.1 1.1l1 1-.9-4.5 1.2-.2 1.3 6.8-.9.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M684.1 534.9c-.7.2-1.2.5-1.4 1-.3.5-.3 1.2-.1 1.9.1.4.2.7.4 1 .2.3.4.5.6.7.2.2.5.3.8.3h.9c.2-.1.4-.1.5-.2.2-.1.3-.1.4-.2l-.6-2.4 1.2-.3.8 3.2c-.2.1-.4.3-.8.4-.4.2-.8.3-1.4.5-.5.1-.9.2-1.4.1-.4-.1-.8-.2-1.2-.4-.4-.2-.7-.5-.9-.9-.3-.4-.5-.9-.6-1.4s-.2-1.1-.1-1.6.2-.9.4-1.3.5-.7.9-.9c.4-.3.8-.4 1.2-.6.3-.1.6-.1.8-.1h.7c.2 0 .3 0 .5.1.1 0 .2.1.3.1l-.1 1.1c-.2-.1-.5-.1-.8-.1-.3-.1-.6-.1-1 0z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M560.8 379.7h1.1c.4 0 .8.1 1.3.1.4 0 .9.1 1.3.1.5 0 .9.1 1.3.1-.2-.3-.5-.6-.8-1-.3-.4-.5-.7-.8-1.1s-.5-.7-.7-1.1l-.6-.9.6-1c.5.2 1 .4 1.5.7s1.1.5 1.6.7c.5.3 1.1.5 1.6.8.5.3 1.1.5 1.6.8l-.6 1.1c-.7-.4-1.5-.8-2.2-1.2s-1.5-.8-2.2-1.1c.1.1.2.3.3.5s.3.4.4.6c.2.2.3.5.5.7s.3.5.5.7c.2.2.3.4.5.6.1.2.3.3.4.5l-.5.8c-.2 0-.4 0-.6-.1-.2 0-.5-.1-.8-.1s-.6-.1-.8-.1c-.3 0-.6-.1-.8-.1-.3 0-.5 0-.8-.1s-.4 0-.6 0c.7.5 1.3.9 2.1 1.4.7.5 1.4.9 2.1 1.3l-.6 1.1c-.5-.3-1-.6-1.5-1-.5-.3-1-.7-1.5-1-.5-.3-1-.7-1.5-1-.5-.3-.9-.6-1.3-.9l.5-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M572.8 373.5c-.3-.1-.6-.1-.8-.2-.3-.1-.6-.1-.8-.2l-1.6 2.4c.2.2.4.5.5.7.2.2.3.5.5.7l-.7 1.1c-.5-.6-.9-1.2-1.3-1.8s-.7-1.1-1.1-1.6c-.3-.5-.7-1-1-1.4-.3-.5-.6-.9-.9-1.4l.7-1c.5.1 1.1.2 1.6.3.5.1 1.1.2 1.7.3.6.1 1.2.3 1.9.4s1.4.3 2.1.5l-.8 1.2zm-5.7-1.5c.2.3.5.7.8 1.2.3.4.6.9 1 1.4l1.3-1.9c-.6-.2-1.2-.3-1.7-.4-.6-.1-1.1-.2-1.4-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m571 364.4.9.7-1.3 1.7 4.6 3.6-.8 1-4.6-3.6-1.3 1.7-.9-.7 3.4-4.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m577.1 367.8-5.3-4.4 2.8-3.4.8.7-2 2.5 1.3 1.1 1.8-2.2.8.7-1.8 2.2 1.6 1.3 2.2-2.6.8.7-3 3.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M576.9 357.5c.7-.7 1.3-1.2 2-1.3.6-.1 1.2 0 1.8.6.7.6.8 1.4.4 2.3.2 0 .4 0 .7.1.3 0 .6.1.9.1s.6.1.9.2c.3.1.6.2.9.2l-1 1c-.3-.1-.5-.1-.8-.2s-.6-.1-.8-.2c-.3 0-.5-.1-.8-.1-.2 0-.5-.1-.7-.1l-.2.2-.1.1-.4.4 1.9 1.8-.9.9-5-4.6c.2-.3.3-.5.6-.8l.6-.6zm.9.6c-.2.2-.3.4-.5.6l1.6 1.5.4-.4c.2-.2.4-.4.5-.6.1-.2.2-.4.3-.5s0-.3 0-.5c-.1-.2-.2-.3-.3-.5-.2-.1-.3-.2-.5-.3h-.5c-.2 0-.3.1-.5.3-.2.1-.4.3-.5.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m580.2 354.2.9-.9 4.8 5-.9.9-4.8-5z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M590.5 354.2c-.3-.1-.5-.3-.8-.4-.3-.1-.5-.3-.8-.4l-2.2 1.9c.1.3.2.5.3.8.1.3.2.5.3.8l-1 .9c-.3-.7-.6-1.4-.8-2-.2-.6-.5-1.2-.7-1.8-.2-.6-.4-1.1-.6-1.6-.2-.5-.3-1.1-.5-1.6l.9-.8c.5.2 1 .4 1.5.7.5.2 1 .5 1.6.8.5.3 1.1.6 1.7.9.6.3 1.2.7 1.9 1l-.8.8zm-5.2-2.9c.1.4.3.8.5 1.3s.4 1.1.6 1.6l1.7-1.5c-.6-.3-1.1-.6-1.6-.8-.5-.2-.9-.4-1.2-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m594.9 349.2.7.9-3.4 2.7-4.3-5.4 1-.8 3.6 4.6 2.4-2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m596.2 349.7-4-5.7 3.6-2.5.6.9-2.6 1.8 1 1.4 2.3-1.6.6.9-2.3 1.6 1.2 1.7 2.8-2 .6.9-3.8 2.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m597.1 340.6 1.1-.7 3.7 5.8-1.1.7-3.7-5.8z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M607.3 342.5c-.4-.2-.8-.4-1.3-.7-.5-.2-.9-.5-1.4-.7-.5-.2-1-.4-1.4-.6-.5-.2-.9-.4-1.3-.5l2.5 4.3-1.1.6-3.5-6 .9-.5c.4.1.8.2 1.2.4.5.2.9.4 1.4.6.5.2.9.4 1.4.6s.9.4 1.3.6l-2.3-4 1.1-.6 3.5 6-1 .5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M609.5 334.7c-.6.3-1 .8-1.2 1.3-.1.6 0 1.2.3 1.9l.6.9c.2.2.5.4.7.5.3.1.5.2.8.2.3 0 .6-.1.9-.2.2-.1.4-.2.5-.3.1-.1.2-.2.3-.2l-1.1-2.2 1.1-.6 1.5 3c-.1.1-.4.3-.7.6-.3.3-.7.5-1.2.7-.4.2-.9.3-1.3.4-.4 0-.9 0-1.3-.2-.4-.1-.8-.4-1.1-.7-.3-.3-.6-.8-.9-1.3-.3-.5-.4-1-.4-1.5s0-.9.2-1.3c.1-.4.4-.8.7-1.1.3-.3.7-.6 1.1-.8.3-.1.6-.2.8-.3.2-.1.5-.1.6-.2s.3 0 .5 0h.3l.1 1.1c-.2 0-.5 0-.8.1-.4-.1-.7 0-1 .2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m619.3 336.8-.6-.6-.6-.6-2.7 1.1c0 .3 0 .6.1.9 0 .3 0 .6.1.9l-1.2.5c0-.8-.1-1.5-.1-2.2 0-.7-.1-1.3-.1-1.9v-3.3l1.1-.5c.4.4.8.7 1.2 1.1l1.2 1.2c.4.4.9.9 1.3 1.4.5.5 1 1 1.5 1.6l-1.2.4zm-4-4.3v1.4c0 .5 0 1.1.1 1.8l2.1-.9c-.4-.5-.8-.9-1.2-1.3-.4-.5-.7-.8-1-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M625.6 334.6c-.3-.3-.7-.6-1.1-.9s-.8-.7-1.2-1-.8-.6-1.3-.9-.8-.6-1.2-.8l1.6 4.7-1.2.4-2.2-6.6 1-.3c.3.2.7.4 1.1.7.4.3.8.5 1.3.8l1.2.9c.4.3.8.6 1.1.9l-1.5-4.4 1.2-.4 2.2 6.6-1 .3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M629.4 327.2c-.7.2-1.2.5-1.4 1.1-.3.5-.3 1.2-.1 1.9.1.4.2.7.4 1 .2.3.4.5.6.7s.5.3.8.3.6 0 .9-.1c.2-.1.4-.1.5-.2.2-.1.3-.1.4-.2l-.6-2.4 1.2-.3.9 3.2c-.2.1-.4.3-.8.4-.4.2-.8.3-1.4.5-.5.1-.9.2-1.4.1-.4 0-.8-.2-1.2-.4-.4-.2-.7-.5-.9-.9s-.5-.9-.6-1.4c-.2-.6-.2-1.1-.1-1.6s.2-.9.4-1.3.5-.7.9-1c.4-.3.8-.5 1.2-.6.3-.1.6-.1.8-.2h1.2c.1 0 .2 0 .3.1l-.1 1.1c-.2-.1-.5-.1-.8-.1-.5.2-.8.2-1.1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M635.6 330.9c.4-.1.8-.2.9-.4.2-.2.2-.4.2-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.4-.3-.1-.1-.3-.1-.5-.2-.2 0-.4-.1-.7-.1-.3 0-.5-.1-.7-.1s-.5-.1-.7-.3c-.2-.1-.4-.3-.5-.5-.1-.2-.2-.4-.3-.7-.1-.6 0-1.1.3-1.6.4-.4.9-.7 1.6-.9.4-.1.8-.1 1.2-.1s.6.1.8.1l-.2 1.1c-.2-.1-.5-.1-.8-.1-.3 0-.6 0-.8.1-.3.1-.6.2-.7.4s-.2.4-.2.6c0 .2.1.3.2.4.1.1.2.2.3.2s.3.1.5.2c.2 0 .4.1.5.1.3.1.7.1.9.2.3.1.5.2.7.3.2.1.4.3.5.5.1.2.2.5.3.8.1.6 0 1.1-.4 1.6-.4.4-1 .7-1.8.9-.3.1-.5.1-.8.1h-.6c-.1 0-.4 0-.5-.1-.1 0-.3-.1-.3-.1l.2-1.1c.2.1.5.1.8.1.4.1.7.1 1.2 0z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m638.6 327.8 2.7-.4.2 1.1-2.7.4-.2-1.1z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M749.9 495.3c-.3.4-.5.7-.8.9-.3.2-.6.3-.9.4-.3 0-.7 0-1-.1-.3-.1-.7-.3-1-.5l-3.6-2.4.7-1.1 3.5 2.3c.3.2.5.3.7.4.2.1.4.1.6.1.2 0 .4-.1.5-.2.2-.1.3-.3.4-.4s.2-.4.2-.6v-.6c0-.2-.1-.4-.3-.5-.1-.2-.4-.4-.6-.5l-3.5-2.3.7-1.1 3.6 2.4c.3.2.6.5.8.7.2.3.4.6.4.9.1.3.1.7 0 1s-.2.8-.4 1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M746.9 486.8h1c.4 0 .8.1 1.3.1.4 0 .9.1 1.3.1s.9.1 1.2.1c-.2-.3-.5-.6-.7-1-.3-.4-.5-.7-.8-1.1-.3-.4-.5-.7-.7-1.1l-.6-.9.6-1c.5.2 1 .4 1.5.7.5.2 1 .5 1.6.7.5.3 1.1.5 1.6.8.5.3 1.1.5 1.6.8l-.6 1.1c-.7-.4-1.4-.8-2.2-1.2-.8-.4-1.5-.8-2.2-1.1.1.1.2.3.3.5.1.2.3.4.4.6.2.2.3.5.5.7.2.2.3.5.5.7.2.2.3.4.4.6.1.2.3.4.4.5l-.5.8c-.2 0-.4 0-.6-.1-.2 0-.5-.1-.8-.1-.3 0-.5-.1-.8-.1-.3 0-.6-.1-.8-.1-.3 0-.5 0-.8-.1h-.6c.7.5 1.3.9 2 1.4.7.5 1.4.9 2.1 1.3l-.6 1.1c-.5-.3-1-.6-1.5-1s-1-.7-1.5-1c-.5-.3-1-.7-1.4-1-.5-.3-.9-.6-1.3-.9l.7-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m757.4 479.4 1 .5-1.9 3.9-6.2-3 .6-1.1 5.2 2.6 1.3-2.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M760.8 474.3h-.9c-.3 0-.6 0-.9-.1l-1.1 2.7.6.6.6.6-.5 1.2c-.6-.5-1.1-1-1.6-1.5s-.9-.9-1.4-1.3l-1.2-1.2c-.4-.4-.8-.8-1.1-1.2l.5-1.1h3.3c.6 0 1.2 0 1.9.1.7 0 1.4.1 2.2.1l-.4 1.1zm-5.9-.3 1 1c.4.4.8.8 1.3 1.2l.9-2.1c-.6 0-1.2-.1-1.8-.1h-1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M757.1 467.1c-.2.7-.2 1.3.1 1.8.3.5.8.9 1.5 1.2.4.1.7.2 1 .2.3 0 .6 0 .9-.1.3-.1.5-.2.7-.4.2-.2.4-.5.5-.8.1-.2.1-.4.2-.5 0-.2.1-.3.1-.4l-2.3-.8.4-1.2 3.1 1.1c0 .2 0 .5-.1.9s-.2.9-.4 1.4c-.2.5-.4.9-.7 1.2-.3.3-.6.6-1 .8-.4.2-.8.3-1.3.3s-1-.1-1.5-.3c-.5-.2-1-.5-1.4-.8-.4-.3-.6-.7-.8-1.1-.2-.4-.3-.8-.3-1.3 0-.4.1-.9.2-1.3.1-.3.2-.6.3-.8.1-.2.2-.4.4-.6.1-.2.2-.3.3-.4l.2-.2.8.7c-.2.1-.4.3-.5.6-.2.2-.3.5-.4.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m763.8 465.6-6.7-1.9 1.2-4.3 1 .3-.9 3.1 1.6.5.8-2.7 1 .3-.8 2.7 1.9.6 1-3.3 1 .3-1.1 4.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M759.1 456.4c.2-1 .6-1.7 1.1-2.1.5-.4 1.1-.6 1.8-.4.9.2 1.4.8 1.5 1.8l.6-.3c.2-.1.5-.2.8-.3l.9-.3c.3-.1.6-.2.9-.2l-.3 1.4c-.3.1-.5.1-.8.2-.3.1-.5.2-.8.3-.3.1-.5.2-.7.3l-.6.3v.4l-.1.6 2.6.6-.3 1.2-6.6-1.6c0-.3 0-.6.1-1-.3-.3-.2-.6-.1-.9zm1 .1c-.1.3-.1.5-.1.7l2.2.5.1-.5c.1-.3.1-.6.1-.8v-.6c0-.2-.1-.3-.3-.4-.1-.1-.3-.2-.5-.2s-.4-.1-.6 0c-.2 0-.3.1-.4.3-.1.1-.2.3-.3.5 0 .1-.1.3-.2.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M767.4 450.9c-.1.5-.2.9-.4 1.2-.2.3-.4.6-.7.7-.3.2-.6.3-.9.4-.3.1-.7 0-1.1 0l-4.3-.7.2-1.3 4.2.7c.3 0 .6.1.8 0 .2 0 .4-.1.6-.2s.3-.2.4-.4c.1-.2.2-.4.2-.6v-.6c0-.2-.1-.4-.2-.5-.1-.2-.3-.3-.5-.4-.2-.1-.5-.2-.8-.2l-4.2-.7.2-1.3 4.3.7c.4.1.7.2 1.1.3.3.2.6.4.8.6.2.3.4.6.4.9 0 .5 0 .9-.1 1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M768.4 441.9c-.4.2-.8.4-1.3.6-.5.2-.9.5-1.4.7-.5.3-.9.5-1.4.8-.4.3-.8.5-1.2.8l4.9.5-.1 1.2-6.9-.7.1-1c.3-.2.7-.5 1.1-.8.4-.3.8-.5 1.3-.8.4-.3.9-.5 1.3-.8.4-.2.9-.5 1.2-.7l-4.6-.5.1-1.2 6.9.7v1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M762.7 435.8c0 .7.2 1.3.6 1.7.4.4 1 .6 1.8.6.4 0 .7 0 1-.1.3-.1.6-.2.8-.4.2-.2.4-.4.5-.6.1-.3.2-.6.2-.9v-.6c0-.2 0-.3-.1-.4l-2.5-.1v-1.3l3.3.1c.1.2.1.5.2.9s.1.9.1 1.4c0 .5-.1 1-.3 1.4-.2.4-.4.8-.7 1-.3.3-.7.5-1.1.6-.5.1-1 .2-1.5.2-.6 0-1.1-.1-1.5-.3-.4-.2-.8-.4-1.1-.8-.3-.3-.5-.7-.7-1.1-.1-.4-.2-.9-.2-1.3 0-.3 0-.6.1-.9 0-.2.1-.5.2-.6.1-.2.1-.3.2-.4s.1-.2.1-.2l1 .4c-.1.2-.2.4-.3.7-.1.3-.1.6-.1 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m693.6 335.9 2.6-6.4 4.1 1.6-.4 1-2.9-1.2-.7 1.6 2.6 1-.4 1-2.6-1-1.1 2.8-1.2-.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M703.7 332.6c.9.4 1.5.9 1.8 1.5.3.6.3 1.2 0 1.9-.4.8-1.1 1.2-2.1 1.1 0 .2.1.4.1.7.1.3.1.6.1.9s.1.6.1.9v.9l-1.3-.6c0-.3 0-.5-.1-.8 0-.3-.1-.6-.1-.8 0-.3-.1-.5-.1-.8 0-.2-.1-.5-.1-.7-.1 0-.2-.1-.2-.1-.1 0-.1-.1-.2-.1l-.6-.3-1.1 2.4-1.1-.5 2.9-6.2.9.3c.6 0 .9.2 1.1.3zm-.4 1c-.2-.1-.5-.2-.7-.3l-1 2 .5.2c.3.1.5.2.8.3.2.1.4.1.6.1.2 0 .3-.1.5-.2.1-.1.3-.2.3-.5.1-.2.1-.4.1-.5s-.1-.3-.2-.5c-.1-.1-.2-.3-.4-.4 0 0-.2-.1-.5-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m705.1 341 3.3-6.1 3.9 2.1-.5.9-2.8-1.5-.8 1.5 2.5 1.4-.5.9-2.5-1.4-1 1.8 3 1.6-.5.9-4.1-2.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m714 338 1.1.7-3.6 6-1.1-.7 3.6-6z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M719.2 342.5c-.6-.4-1.2-.5-1.7-.4-.6.2-1.1.6-1.5 1.2-.2.3-.4.6-.5.9-.1.3-.1.6-.1.9s.1.5.3.8c.2.2.4.5.7.7.2.1.3.2.5.3.1.1.3.1.4.2l1.4-2.1 1 .7-1.8 2.8c-.2 0-.5-.1-.9-.3-.4-.2-.8-.4-1.3-.7-.4-.3-.8-.6-1-1-.3-.4-.4-.8-.5-1.2-.1-.4 0-.9.1-1.3s.3-.9.7-1.4c.3-.5.7-.9 1.1-1.1.4-.3.8-.5 1.2-.5s.9-.1 1.3 0 .8.3 1.2.5c.3.2.5.4.7.5l.5.5c.2.2.2.3.3.4.1.1.1.2.1.2l-.9.6c-.1-.2-.2-.4-.5-.7-.3-.2-.5-.4-.8-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M722.7 352.5c.1-.3.2-.5.3-.8s.2-.5.3-.8l-2.3-1.8c-.2.2-.5.3-.7.5-.2.2-.5.3-.7.5l-1-.8c.7-.4 1.3-.8 1.8-1.2.6-.4 1.1-.7 1.6-1l1.5-.9c.5-.3 1-.5 1.5-.8l1 .7c-.1.5-.2 1.1-.4 1.6-.1.5-.3 1.1-.5 1.7-.2.6-.3 1.2-.5 1.8s-.4 1.3-.7 2.1l-1.2-.8zm1.8-5.7c-.3.2-.7.4-1.2.7l-1.5.9 1.8 1.4c.2-.6.4-1.2.5-1.7s.3-.9.4-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M726.3 355.6c-.3-.2-.5-.5-.8-.8-.3-.3-.5-.5-.6-.8l4.5-5c.1.1.3.2.4.3.1.1.3.2.4.3.1.1.3.2.4.3.1.1.3.2.4.3.3.3.6.6.8.9.2.3.4.6.5.9.1.3.1.6.1.8-.1.3-.2.5-.4.8-.2.2-.5.4-.7.5-.3.1-.6.1-.9 0 .2.4.3.7.3 1.1 0 .3-.2.7-.5 1-.5.5-1 .8-1.7.7-.7-.1-1.4-.5-2.2-1.3zm1.5-2.9-1.4 1.6.3.3.3.3c.2.2.4.3.6.4.2.1.4.2.5.3s.3.1.5 0 .3-.1.5-.3c.3-.3.3-.6.2-.9-.1-.3-.4-.6-.7-1l-.8-.7zm.7-.7.7.6c.4.3.7.5 1 .6.3.1.6 0 .8-.3.2-.2.3-.5.2-.8-.1-.3-.3-.6-.7-.9-.1-.1-.3-.2-.4-.3s-.2-.2-.3-.2l-1.3 1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m729.8 358.8 4.9-4.9 3.1 3.2-.8.8-2.2-2.3-1.2 1.2 2 2-.7.7-2-2-1.4 1.4 2.4 2.4-.8.8-3.3-3.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M737.2 366.7c.1-.4.3-.9.4-1.4.1-.5.3-1 .4-1.5.1-.5.3-1 .4-1.5.1-.5.2-1 .3-1.4l-3.8 3.2-.8-.9 5.3-4.5.7.8c0 .4-.1.8-.2 1.3l-.3 1.5c-.1.5-.2 1-.4 1.5-.1.5-.3.9-.4 1.3l3.5-3 .8.9-5.3 4.5-.6-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m737.6 370.2-.8-1 9.8-3.2.7 1-9.7 3.2z" className="st3" />
    </g>
    <g className="st2">
      <path d="m558.7 440.4.1 1.3-6.9.6-.1-1.3 6.9-.6z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M552.7 449.3c.3-.3.7-.6 1.1-.9.4-.3.8-.7 1.2-1.1.4-.4.8-.7 1.1-1.1l1-1-4.9.7-.2-1.2 6.9-1 .1 1c-.2.3-.5.6-.9 1-.3.4-.7.7-1 1.1l-1.1 1.1c-.4.4-.7.7-1 .9l4.6-.7.2 1.2-6.9 1-.2-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M553.7 454.8c.9-.7 1.9-1.4 3-2.1 1.1-.7 2.1-1.4 3.2-2l.3 1.4c-.4.3-.8.5-1.3.8s-.9.5-1.3.8c-.4.3-.8.5-1.2.8-.4.3-.8.5-1.1.7.4.1.8.1 1.3.2s.9.1 1.4.2 1 .1 1.5.2 1 .1 1.5.2l.3 1.3c-1.2-.1-2.5-.3-3.7-.5-1.3-.2-2.5-.4-3.6-.7l-.3-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m555 460.3 6.7-1.9 1.2 4.3-1 .3-.9-3.1-1.6.5.8 2.7-1 .3-.8-2.7-2 .6.9 3.3-1 .3-1.3-4.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M558.5 471.2c.3-.3.6-.7.9-1.1s.6-.8.9-1.3c.3-.4.6-.9.9-1.3s.5-.8.7-1.2l-4.7 1.7-.4-1.2 6.5-2.4.4 1c-.2.3-.4.7-.6 1.2-.3.4-.5.9-.8 1.3-.3.4-.6.9-.9 1.3-.3.4-.6.8-.8 1.1l4.3-1.6.4 1.2-6.5 2.4-.3-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m568.1 476-1 .4-.8-2-5.4 2.3-.5-1.2 5.4-2.3-.8-2 1-.4 2.1 5.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M563.7 482.9c-.2-.4-.4-.8-.4-1.2 0-.4 0-.7.1-1 .1-.3.3-.6.5-.8s.5-.5.9-.7l3.8-2 .6 1.1-3.7 2c-.3.1-.5.3-.7.5-.2.2-.3.3-.3.5s-.1.4-.1.6.1.4.2.6c.1.2.2.4.4.5.1.1.3.2.5.3.2 0 .4.1.6 0s.5-.1.8-.3l3.7-2 .6 1.1-3.8 2c-.4.2-.7.3-1 .4s-.7 0-1 0c-.3-.1-.6-.2-.9-.5-.3-.3-.6-.6-.8-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M573.2 485.2c.5.8.8 1.6.7 2.2 0 .6-.4 1.2-1 1.6-.8.5-1.6.4-2.4-.2-.1.2-.1.4-.2.7-.1.3-.2.5-.3.8-.1.3-.3.6-.4.8-.1.3-.3.5-.5.8l-.7-1.2c.1-.2.3-.5.4-.7.1-.3.3-.5.4-.8.1-.2.2-.5.3-.7.1-.2.2-.4.2-.6-.1-.1-.1-.1-.1-.2s-.1-.1-.1-.2l-.3-.5-2.2 1.4-.7-1.1 5.8-3.6c.2.2.4.5.6.8.2.2.4.5.5.7zm-.8.7c-.1-.2-.3-.4-.4-.6l-1.9 1.2.3.5c.2.3.3.5.5.7.2.2.3.3.5.4s.3.1.5.1.3-.1.5-.2.3-.2.4-.4.1-.3.1-.5 0-.4-.1-.6c-.2-.2-.3-.4-.4-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M627.9 529.9c-.2-1.2-.3-2.4-.4-3.7-.1-1.3-.2-2.5-.2-3.8l1.3.4c0 .5 0 1 .1 1.5 0 .5 0 1 .1 1.5 0 .5.1 1 .1 1.5s.1.9.1 1.3c.3-.3.5-.6.8-1l.9-1.2.9-1.2.9-1.2 1.3.4c-.7 1-1.5 2-2.3 3-.8 1-1.6 1.9-2.4 2.8l-1.2-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m632.9 531.3 1.5-6.8 4.3 1-.2 1-3.1-.7-.4 1.7 2.8.6-.2 1-2.8-.6-.4 2 3.3.7-.2 1-4.6-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M641.7 526c1 .2 1.7.5 2.2.9.5.4.6 1 .5 1.8-.1.9-.7 1.5-1.7 1.7l.3.6c.1.2.2.5.4.8l.3.9c.1.3.2.6.3.8l-1.4-.2c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.7l-.3-.6h-.4l-.6-.1-.4 2.6-1.2-.2 1.1-6.7h1c.2-.1.5 0 .8 0zm-.1 1.1c-.3 0-.5-.1-.7-.1l-.4 2.2.5.1c.3 0 .6.1.8.1.2 0 .4 0 .6-.1.2-.1.3-.2.4-.3.1-.1.2-.3.2-.5v-.6c-.1-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.3-.1 0-.4 0-.6-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M647.3 533.9c-.4 0-.7-.1-1.1-.1-.4-.1-.7-.1-1-.2l.7-6.7h2c.4 0 .8.1 1.2.2.4.1.7.2.9.4l.6.6c.1.3.2.6.1.9 0 .3-.1.6-.3.8s-.4.4-.7.5c.4.2.7.4.9.7s.2.6.2 1.1c-.1.7-.4 1.2-.9 1.5s-1.5.4-2.6.3zm-.5-3.2-.2 2.1c.1 0 .3.1.4.1.2 0 .3 0 .4.1h.7c.2 0 .4-.1.6-.1.2-.1.3-.2.4-.3.1-.1.2-.3.2-.5 0-.4-.1-.7-.3-.9-.3-.2-.7-.3-1.2-.3l-1-.2zm.1-1 .9.1c.5 0 .9 0 1.1-.1.3-.1.4-.3.5-.7 0-.3-.1-.6-.4-.7-.3-.2-.6-.3-1.1-.3h-.9l-.1 1.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M653.9 527.3c1 0 1.8.2 2.3.6.5.4.8 1 .7 1.7 0 .9-.5 1.6-1.4 1.9.1.2.3.3.4.6.2.2.3.5.5.7s.3.5.5.8.3.5.4.8h-1.4c-.1-.2-.2-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.6h-1l-.1 2.6h-1.3l.2-6.8c.3-.1.6-.1 1-.1.3-.1.6-.1.8-.1zm.1 1.1h-.7l-.1 2.2h1.3c.2 0 .4-.1.6-.2.2-.1.3-.2.4-.3.1-.1.1-.3.1-.6 0-.2 0-.4-.1-.5-.1-.1-.2-.3-.3-.4-.1-.1-.3-.2-.5-.2h-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M663.3 534.3c-.1-.3-.2-.5-.3-.8s-.2-.5-.3-.8l-2.9.1c-.1.3-.2.6-.3.8-.1.3-.2.5-.3.8h-1.3c.2-.7.5-1.4.7-2.1s.4-1.2.6-1.8c.2-.6.4-1.1.6-1.6l.6-1.5h1.2c.2.5.5 1 .7 1.5s.5 1 .7 1.6.5 1.1.7 1.8.5 1.3.8 2h-1.2zm-2.2-5.6c-.1.4-.3.8-.5 1.3s-.4 1.1-.6 1.7l2.3-.1c-.2-.6-.5-1.1-.7-1.6s-.3-.9-.5-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M668.3 534c-.5 0-.9 0-1.2-.1-.4-.1-.6-.3-.9-.5-.2-.2-.4-.5-.6-.8-.1-.3-.2-.7-.3-1.1l-.4-4.3 1.3-.1.4 4.2c0 .3.1.6.2.8.1.2.2.4.4.5s.3.2.5.3c.2 0 .4.1.6 0 .2 0 .4-.1.6-.2.2-.1.3-.2.4-.4s.2-.3.2-.6.1-.5 0-.8l-.4-4.2 1.3-.1.4 4.3c0 .4 0 .8-.1 1.1-.1.3-.2.6-.4.9-.2.3-.5.5-.8.7-.3.2-.7.3-1.2.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M675.6 532.9c-.5.1-1 .1-1.4 0-.4-.1-.8-.3-1.2-.5-.3-.3-.6-.6-.8-1-.2-.4-.4-.9-.5-1.5-.1-.6-.1-1.1 0-1.6s.3-.9.5-1.2c.2-.4.6-.7.9-.9s.8-.4 1.3-.5c.3 0 .5-.1.8-.1h.6c.2 0 .3.1.5.1s.2.1.3.1l-.2 1.1c-.2-.1-.4-.1-.7-.2h-1c-.3.1-.6.2-.8.3-.2.1-.4.3-.6.6-.2.2-.3.5-.3.8v1.1c.1.4.2.7.3 1s.3.5.5.7c.2.2.5.3.7.4.3.1.6.1 1 0s.8-.2 1-.3.5-.3.6-.4l.5 1c-.1.1-.2.1-.3.2-.1.1-.3.2-.5.2-.2.1-.4.2-.6.2-.1.3-.3.4-.6.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m681.4 524.4 1.2-.3 1.6 6.7-1.2.3-.7-3-2.9.7.7 3-1.2.3-1.6-6.7 1.2-.3.6 2.7 2.9-.7-.6-2.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M687.2 529c.4-.1.7-.3.9-.5.2-.2.2-.4.1-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.4-.2-.2-.1-.3-.1-.5-.1h-.7c-.3 0-.5 0-.7-.1-.2 0-.5-.1-.7-.2-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.7-.2-.6-.1-1.1.2-1.6s.8-.8 1.5-1c.4-.1.8-.2 1.1-.2.4 0 .6 0 .9.1l-.1 1.1c-.3-.1-.5-.1-.8-.1-.3 0-.6.1-.8.2-.3.1-.6.2-.7.4-.1.2-.2.4-.1.6 0 .1.1.3.2.3.1.1.2.2.3.2.1 0 .3.1.5.1h.6c.3 0 .7 0 .9.1.3 0 .5.1.8.2.2.1.4.3.6.4.2.2.3.4.4.8.2.6.1 1.1-.2 1.6s-.9.8-1.7 1.1c-.3.1-.5.1-.8.2s-.5.1-.6.1h-.5c-.1 0-.3 0-.4-.1v-1.1c.2 0 .5.1.8.1s.7-.1 1.1-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m689.9 525.5 2.5-.9.4 1-2.5.9-.4-1z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m736.9 496.1-5.5-4.2 2.7-3.5.8.7-2 2.5 1.4 1 1.7-2.2.8.6-1.7 2.2 1.6 1.2 2.1-2.7.8.7-2.7 3.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m734.8 487.3.7-1 5.7 4-.7 1-5.7-4z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M744.7 484.8h-1.4c-.5 0-1 0-1.6.1-.5 0-1.1.1-1.6.1s-1 .1-1.4.2l4.2 2.6-.6 1.1-5.9-3.6.5-.9c.4-.1.8-.2 1.3-.2.5-.1 1-.1 1.5-.2.5 0 1-.1 1.5-.1s1 0 1.4-.1l-3.9-2.4.7-1.1 5.9 3.6-.6.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m747.2 478 1 .5-2.1 3.9-6.1-3.3.6-1.1 5.2 2.8 1.4-2.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M750.7 472.9c-.3 0-.6 0-.9-.1s-.6 0-.9-.1l-1.2 2.7.6.6.6.6-.5 1.2c-.6-.5-1.1-1-1.6-1.5s-.9-.9-1.4-1.3c-.4-.4-.8-.8-1.2-1.3s-.7-.8-1.1-1.2l.5-1.1h3.3c.6 0 1.2.1 1.9.1s1.4.1 2.2.1l-.3 1.3zm-6-.4 1 1c.4.4.8.8 1.3 1.2l.9-2.1c-.6 0-1.2-.1-1.8-.1-.5.1-1 0-1.4 0z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M747.1 465.7c-.3.7-.2 1.3 0 1.8.3.5.8.9 1.5 1.2.3.1.7.2 1 .2.3 0 .6 0 .9-.1.3-.1.5-.2.7-.4.2-.2.4-.5.5-.8.1-.2.1-.4.2-.5s.1-.3.1-.4l-2.3-.9.4-1.2 3.1 1.2c0 .2 0 .5-.1.9s-.2.9-.4 1.4c-.2.5-.4.9-.7 1.2-.3.3-.6.6-1 .7-.4.2-.8.2-1.3.2s-1-.1-1.5-.3c-.5-.2-1-.5-1.3-.8-.4-.3-.6-.7-.8-1.1s-.3-.8-.3-1.3c0-.4.1-.9.2-1.3.1-.3.2-.6.4-.8.1-.2.2-.4.4-.6.1-.2.2-.3.3-.4.1-.1.2-.1.2-.2l.8.7c-.2.1-.4.3-.5.6s-.4.7-.5 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m753.9 464.3-6.7-1.9 1.2-4.3 1 .3-.9 3.1 1.6.5.8-2.7 1 .3-.8 2.7 1.9.6 1-3.3 1 .3-1.1 4.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M749.2 455.1c.2-1 .6-1.7 1.1-2.1s1.1-.6 1.8-.4c.9.2 1.4.8 1.5 1.8l.6-.3c.3-.1.5-.2.8-.3l.9-.3c.3-.1.6-.2.9-.2l-.3 1.4c-.3.1-.5.1-.8.2-.3.1-.5.2-.8.3-.3.1-.5.2-.7.3l-.6.3v.4l-.1.6 2.5.6-.3 1.2-6.6-1.6c0-.3 0-.6.1-1-.1-.3 0-.6 0-.9zm1.1.2c-.1.3-.1.5-.1.7l2.2.5.1-.5c.1-.3.1-.6.1-.8v-.6c0-.2-.1-.3-.3-.4-.1-.1-.3-.2-.5-.2s-.4-.1-.6 0c-.2 0-.3.1-.4.3-.1.1-.2.3-.3.5-.1 0-.1.2-.2.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M757.6 449.6c-.1.5-.2.9-.4 1.2-.2.3-.4.6-.7.7-.3.2-.6.3-.9.4-.3.1-.7 0-1.1 0l-4.3-.7.2-1.3 4.2.7c.3 0 .6.1.8 0 .2 0 .4-.1.6-.2.2-.1.3-.2.4-.4s.2-.4.2-.6v-.6c0-.2-.1-.4-.2-.5-.1-.1-.3-.3-.5-.4-.2-.1-.5-.2-.8-.2l-4.2-.7.2-1.3 4.3.7c.4.1.7.2 1.1.3.3.2.6.4.8.6.2.3.4.6.4.9 0 .5 0 1-.1 1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M758.6 440.7c-.4.2-.8.4-1.3.6s-.9.5-1.4.7c-.5.3-.9.5-1.4.8s-.8.5-1.2.8l4.9.5-.1 1.2-6.9-.7.1-1c.3-.2.7-.5 1.1-.8.4-.3.8-.5 1.3-.8.4-.3.9-.5 1.3-.8.4-.2.9-.5 1.2-.7l-4.6-.5.1-1.2 6.9.7v1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M752.8 434.5c0 .7.2 1.3.6 1.7.4.4 1 .6 1.8.6.4 0 .7 0 1-.1s.6-.2.8-.4c.2-.2.4-.4.5-.6s.2-.6.2-.9v-.6c0-.2 0-.3-.1-.4l-2.5-.1v-1.3l3.3.1c.1.2.1.5.2.9s.1.9.1 1.4c0 .5-.1 1-.3 1.4-.2.4-.4.8-.7 1s-.7.5-1.1.6c-.5.1-1 .2-1.5.2-.6 0-1.1-.1-1.5-.3-.4-.2-.8-.4-1.1-.8-.3-.3-.5-.7-.7-1.1-.1-.4-.2-.9-.2-1.3 0-.3 0-.6.1-.9 0-.2.1-.5.2-.6s.1-.3.2-.4.1-.2.1-.2l1 .4c-.1.2-.2.4-.3.7 0 .4-.1.7-.1 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="M760.6 430.7v1.2l-9.8-3.1v-1.2l9.8 3.1z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M585.8 372.8c-.3 0-.7-.1-1-.1h-1.1c-.4 0-.7.1-1.1.1-.4.1-.7.1-1 .2l2.4 2-.8 1-5.4-4.4.8-1 2.2 1.8c0-.3-.1-.6-.1-1 0-.3-.1-.7-.1-1-.1-.3-.1-.7-.2-1-.1-.3-.1-.6-.1-.9l1-1.2c.1.3.1.7.2 1s.1.7.2 1.1c.1.4.1.8.1 1.1s.1.7.1 1.1c.3-.1.7-.1 1.1-.2.4 0 .8-.1 1.2-.1h1.3c.4 0 .9.1 1.3.1l-1 1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M588.9 364.2c.4.4.8.8 1 1.3.2.4.3.9.3 1.3s-.1.8-.2 1.3c-.2.4-.4.8-.7 1.1-.3.3-.7.6-1.1.8-.4.2-.8.3-1.2.3-.4 0-.9-.1-1.3-.3-.5-.2-.9-.5-1.3-.9s-.8-.8-1-1.3c-.2-.4-.3-.9-.3-1.3s.1-.9.2-1.3c.2-.4.4-.8.7-1.1.3-.3.7-.6 1.1-.8.4-.2.8-.3 1.2-.3.4 0 .9.1 1.3.3.4.2.9.5 1.3.9zm-3.7 4c.3.3.6.5.9.6.3.1.6.2.9.2s.6 0 .8-.1c.3-.1.5-.3.7-.5.2-.2.4-.5.5-.7.1-.3.1-.5.1-.8 0-.3-.1-.6-.3-.8-.2-.3-.4-.6-.7-.8-.3-.3-.6-.5-.9-.6-.3-.1-.6-.2-.9-.2-.3 0-.6 0-.8.1-.3.1-.5.3-.7.5-.2.2-.4.5-.5.8-.1.3-.1.5-.1.8 0 .3.1.6.3.8.2.1.4.4.7.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M595.7 362.7c-.4-.1-.9-.3-1.4-.4s-1-.3-1.5-.4l-1.5-.3c-.5-.1-1-.2-1.4-.2l3.3 3.7-.9.8-4.6-5.1.8-.7c.4 0 .8.1 1.3.2l1.5.3 1.5.3c.5.1.9.2 1.4.3l-3.1-3.4.9-.8 4.6 5.1-.9.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m597.2 352.5.7.8-1.7 1.3 3.7 4.6-1 .8-3.7-4.6-1.7 1.3-.7-.8 4.4-3.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M600 350.5c.8-.6 1.6-.8 2.2-.8.6 0 1.2.3 1.6.9.5.8.5 1.6-.1 2.4.2.1.4.1.7.2.3.1.5.2.8.3.3.1.6.2.8.4.3.1.5.3.8.4l-1.2.8c-.2-.1-.5-.2-.7-.4s-.5-.2-.8-.3c-.3-.1-.5-.2-.7-.3s-.5-.2-.6-.2c-.1.1-.1.1-.2.1s-.1.1-.2.1l-.5.3 1.5 2.2-1 .7-3.9-5.6c.2-.2.5-.4.7-.7.3-.2.6-.4.8-.5zm.7.8c-.2.2-.4.3-.6.4l1.3 1.8.5-.3c.3-.2.5-.3.6-.5.2-.2.3-.3.4-.5.1-.2.1-.3.1-.5s-.1-.3-.2-.5-.3-.3-.4-.4c-.1-.1-.3-.1-.5-.1s-.4.1-.5.1c-.3.3-.5.4-.7.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M611.4 347.6c.3.5.5 1 .6 1.5.1.5.1.9-.1 1.3-.1.4-.3.8-.6 1.1s-.6.6-1 .9c-.4.2-.8.4-1.2.5-.4.1-.9.1-1.3-.1-.4-.1-.8-.3-1.2-.6-.4-.3-.7-.7-1-1.2s-.5-1-.5-1.5c-.1-.5 0-.9.1-1.4.1-.4.3-.8.6-1.1.3-.3.6-.6 1-.8s.8-.4 1.2-.4c.4-.1.9 0 1.3.1s.8.3 1.2.6c.3.2.6.6.9 1.1zm-4.7 2.7c.2.3.4.6.6.8s.5.4.7.5c.3.1.5.1.8.1.3 0 .6-.1.8-.3.3-.2.5-.3.6-.6s.3-.5.3-.8v-.9c-.1-.3-.2-.6-.4-1-.2-.3-.4-.6-.6-.8-.2-.2-.5-.4-.7-.5-.3-.1-.5-.1-.8-.1s-.6.1-.8.3c-.3.2-.5.4-.7.6-.2.2-.3.5-.3.8v.9c.2.3.3.7.5 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m617.6 347.1.5 1-3.9 2-3.1-6.2 1.1-.6 2.6 5.2 2.8-1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m622.7 344.9.4 1-4 1.7-2.8-6.4 1.2-.5 2.3 5.4 2.9-1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m624 345.6-2.3-6.5 4.2-1.5.4 1-3 1 .6 1.6 2.7-.9.3 1-2.7.9.7 1.9 3.2-1.1.4 1-4.5 1.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M687.2 337.8V341.4c0 .4 0 .8.1 1.1.2-.3.4-.7.6-1l.6-1.2c.2-.4.4-.8.7-1.3s.4-.9.6-1.3l1.2.4c-.6 1.1-1.2 2.2-1.8 3.2-.6 1-1.2 2-1.9 2.9l-1.2-.3c-.1-1.4-.2-3-.2-4.7-.5.7-.9 1.4-1.4 2-.5.6-.9 1.2-1.3 1.8l-1.2-.3v-3.5c.1-1.2.2-2.4.3-3.7l1.3.4c-.1.5-.1.9-.2 1.4 0 .5-.1 1-.1 1.4 0 .5-.1.9-.1 1.4v1.2c.2-.3.4-.6.7-.9s.5-.7.7-1c.2-.3.5-.7.7-1 .2-.3.4-.7.6-1l1.3.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m690.4 345.3 2.6-6.4 4.1 1.7-.4 1-3-1.2-.6 1.6 2.6 1.1-.4 1-2.6-1.1-.8 1.9 3.2 1.3-.4 1-4.3-1.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m698.9 341.3 1.1.5-2.8 6.3-1.1-.5 2.8-6.3z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M704.6 345.2c-.6-.3-1.2-.4-1.8-.2s-1 .7-1.4 1.4c-.2.3-.3.7-.4 1-.1.3-.1.6 0 .9.1.3.2.5.3.8s.4.4.7.6c.2.1.4.2.5.2s.3.1.4.1l1.2-2.2 1.1.6-1.6 2.9c-.2 0-.5-.1-.9-.2s-.8-.3-1.3-.6c-.4-.2-.8-.5-1.1-.9-.3-.3-.5-.7-.6-1.1s-.1-.8-.1-1.3c.1-.5.2-1 .5-1.5s.6-.9 1-1.2c.4-.3.8-.5 1.2-.7.4-.1.8-.2 1.3-.1.4.1.9.2 1.3.4.3.2.5.3.7.5.2.2.4.3.5.4.1.1.2.3.3.4.1.1.1.2.2.2l-.8.7c-.1-.2-.3-.4-.5-.6-.1-.1-.4-.3-.7-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m705.2 352.3 3.7-5.9 3.8 2.4-.6.9-2.7-1.7-.9 1.5 2.4 1.5-.6.9-2.4-1.5-1.1 1.7 2.9 1.8-.6.9-3.9-2.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M716.1 351.1c.8.6 1.3 1.2 1.5 1.8.2.6.1 1.2-.3 1.8-.6.8-1.3 1-2.2.7v1.6c0 .3 0 .6-.1.9 0 .3-.1.6-.1.9l-1.1-.8c0-.3.1-.5.1-.8 0-.3 0-.6.1-.8v-1.5c-.1 0-.1-.1-.2-.1s-.1-.1-.2-.1l-.5-.4-1.5 2.1-1-.7 4-5.5c.3.1.6.3.9.5.1.1.4.3.6.4zm-.6.9c-.2-.2-.4-.3-.6-.4l-1.3 1.8.4.3c.2.2.5.3.7.4.2.1.4.2.6.2.2 0 .3 0 .5-.1s.3-.2.4-.4c.1-.2.2-.3.2-.5s0-.3-.1-.5-.2-.3-.3-.5c-.1 0-.3-.1-.5-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M717.8 361.4c-.4-.3-.6-.6-.8-.9-.2-.3-.3-.7-.3-1 0-.3.1-.7.2-1 .1-.3.3-.6.6-.9l2.8-3.3 1 .8-2.7 3.2c-.2.2-.4.5-.4.7-.1.2-.1.4-.1.6 0 .2.1.4.1.5s.2.3.4.5c.2.1.3.2.5.3.2.1.4.1.6.1.2 0 .4-.1.6-.2.2-.1.4-.3.6-.5l2.7-3.2 1 .8-2.8 3.3c-.3.3-.5.5-.8.7-.3.2-.6.3-.9.3-.3 0-.7 0-1-.1-.6-.1-1-.3-1.3-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M724.6 367.5c.1-.4.2-.9.3-1.4s.2-1 .3-1.6c.1-.5.2-1 .2-1.6.1-.5.1-1 .2-1.4l-3.5 3.5-.9-.9 4.9-4.9.7.7c0 .4 0 .8-.1 1.3 0 .5-.1 1-.2 1.5s-.1 1-.2 1.5-.2 1-.3 1.4l3.2-3.3.9.9-4.9 4.9-.6-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M733.3 368.3c-.5-.5-1-.8-1.6-.8-.6 0-1.2.3-1.8.8-.3.2-.5.5-.7.8-.2.3-.3.5-.3.8-.1.3 0 .6 0 .8.1.3.2.6.5.8.1.2.3.3.4.4.1.1.2.2.3.2l1.9-1.6.8 1-2.5 2.2c-.2-.1-.4-.3-.7-.5-.3-.3-.7-.6-1-1-.3-.4-.6-.8-.7-1.2-.1-.4-.2-.8-.2-1.3 0-.4.2-.8.4-1.2.2-.4.6-.8 1-1.2.4-.4.9-.6 1.3-.8.5-.2.9-.2 1.3-.2s.8.2 1.2.4c.4.2.7.5 1 .8.2.2.4.5.5.7l.3.6c.1.2.1.3.2.4s.1.2.1.3l-1 .4c0-.2-.1-.5-.3-.8 0-.3-.1-.6-.4-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m731.3 375.1 5.5-4.2 2.7 3.6-.9.7-1.9-2.6-1.4 1 1.7 2.3-.8.6-1.7-2.3-1.6 1.2 2.1 2.7-.9.7-2.8-3.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M737.5 384c.2-.4.4-.8.6-1.3l.6-1.5.6-1.5c.2-.5.3-.9.5-1.4l-4.2 2.7-.7-1 5.8-3.8.6.9c-.1.4-.2.8-.4 1.3s-.3.9-.5 1.4c-.2.5-.4 1-.6 1.4-.2.5-.4.9-.6 1.3l3.9-2.5.7 1.1-5.8 3.8-.5-.9z"
        className="st3"
      />
    </g>
    <defs>
      <path id="SVGID_3_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_4_">
      <use
        xlinkHref="#SVGID_3_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M135.9 322.7c0 1-.1 2-.3 3-1.5 8.1-8.5 14-16.7 14-.5 0-1 0-1.5-.1-9.4-.8-16.2-9.1-15.4-18.5s9.1-16.2 18.5-15.4c8.7.9 15.4 8.2 15.4 17"
      className="st5"
      style={{
        clipPath: "url(#SVGID_4_)",
      }}
    />
    <path d="M115.9 317.5h5.4v4.1h-5.4z" className="st6" />
    <path
      d="M121.3 313.4v4.1h-5.4v-4.1h1.3v-2.9h-.6v-1.4h.6v-1.3h2.7v1.3h.7v1.4h-.7v2.9z"
      className="st3"
    />
    <path d="M112.6 324.8v7.3h12v-7.3z" className="st6" />
    <defs>
      <path id="SVGID_5_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_6_">
      <use
        xlinkHref="#SVGID_5_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M135.6 325.7c-1.5 8.1-8.5 14-16.7 14-.5 0-1 0-1.5-.1l-6.1-6.2H126v-17.3l9.6 9.6z"
      className="st8"
      style={{
        clipPath: "url(#SVGID_6_)",
      }}
    />
    <path
      d="M125.9 316.2v17.3h-14.7v-17.3h1.4v15.9h12v-15.9z"
      className="st3"
    />
    <defs>
      <path id="SVGID_7_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_8_">
      <use
        xlinkHref="#SVGID_7_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_8_)",
      }}
    >
      <path
        d="M328.8 391.6c-18.6-54.8-67.4-90.3-125.3-91v39c40.1.4 75.7 25.9 88.8 63.9l36.5-11.9zM199.7 339.6v-39c-57.8.8-106.7 36.2-125.3 91l38.3 12.4c12.7-37.5 47.4-63.2 87-64.4M111.6 407.7l-38.3-12.5c-8.4 27.1-8.4 55.2.1 81.4s25 48.9 47.8 65.9l23.8-32.8c-31.2-23.8-44.5-64.4-33.4-102M148 512l-23.8 32.8c47.2 33.4 107.6 33.4 154.8 0L255.9 513c-.4.3-.9.6-1.3.8-.7.5-1.4.9-2.1 1.4-.5.3-1 .6-1.6.9l-2.1 1.2c-.5.3-1 .6-1.5.8-1.1.6-2.2 1.2-3.3 1.7l-1.2.6c-.9.4-1.7.8-2.6 1.2l-1.6.6c-.8.3-1.6.7-2.4 1-.5.2-1 .4-1.5.5-1.2.5-2.5.9-3.8 1.3-.3.1-.6.2-.8.2-1.1.3-2.1.6-3.2.9-.5.1-1 .2-1.4.4-.9.2-1.9.5-2.9.7l-1.4.3c-1.4.3-2.8.5-4.1.7h-.4c-1.3.2-2.6.4-3.9.5l-1.3.1c-1 .1-2.1.2-3.2.2l-1.3.1c-1.4.1-2.9.1-4.4.1s-3 0-4.4-.1l-1.4-.1c-1-.1-2-.1-3-.2l-1.6-.2c-1-.1-2-.2-3-.4-.4-.1-.9-.1-1.4-.2-1.3-.2-2.7-.5-4-.7-.6-.1-1.1-.2-1.7-.4-.8-.2-1.6-.3-2.3-.5s-1.4-.4-2.1-.5l-1.9-.5c-.8-.2-1.5-.4-2.2-.7l-1.3-.4c-1.8-.6-3.5-1.2-5.2-1.9l-.5-.2c-.9-.4-1.9-.8-2.8-1.2l-.8-.3c-.9-.4-1.9-.9-2.8-1.4l-.2-.1c-4.2-2.1-8.2-4.5-12-7.2M330 395.2 293.5 407c11.5 38.4-2.3 79.9-34.5 103.7l23.1 31.8c46.3-34.6 65-92 47.9-147.3"
        className="st10"
      />
    </g>
    <g className="st2">
      <path
        d="M176.1 371.1h1.3v6.9h-1.3v-6.9zM179 373c.2-.1.5-.1.9-.2s.8-.1 1.2-.1c.4 0 .8.1 1.1.2.3.1.5.3.7.5.2.2.3.5.4.8.1.3.1.6.1 1v2.9h-1.2v-2.8c0-.3 0-.5-.1-.7s-.1-.4-.2-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.9v4.2H179V373z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="m185 371.4 1.2-.2v1.6h1.9v1h-1.9v2.1c0 .4.1.7.2.9.1.2.4.3.7.3.2 0 .4 0 .6-.1.2 0 .3-.1.4-.1l.2 1c-.1.1-.3.1-.6.2-.2.1-.5.1-.8.1-.4 0-.7 0-.9-.2-.2-.1-.4-.2-.6-.4-.1-.2-.2-.4-.3-.7-.1-.3-.1-.6-.1-.9v-4.6z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M189.1 375.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4h-3.5c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3zM196.9 378.1c-.4 0-.7 0-.9-.1l-.6-.3c-.1-.1-.2-.3-.3-.5s-.1-.4-.1-.7v-6l1.2-.2v6.4c0 .1.1.2.1.3l.2.2c.1 0 .2.1.4.1v.8zM199.9 378.1c-.4 0-.7 0-.9-.1l-.6-.3c-.1-.1-.2-.3-.3-.5s-.1-.4-.1-.7v-6l1.2-.2v6.4c0 .1.1.2.1.3l.2.2c.1 0 .2.1.4.1v.8zM202.4 371.2c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.4.1.5.2c.1.1.2.3.2.5zm-.2 6.8H201v-5.2h1.2v5.2zM208.1 377.5c0 .8-.2 1.4-.6 1.8s-1.1.6-1.9.6c-.3 0-.6 0-.9-.1-.3-.1-.6-.1-.8-.2l.2-1c.2.1.4.2.7.2.3.1.5.1.9.1.5 0 .8-.1 1-.3s.3-.5.3-.9v-.2c-.1.1-.3.1-.5.2s-.4.1-.7.1c-.3 0-.6-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.4-.5-.5-.8-.1-.3-.2-.7-.2-1.1 0-.4.1-.7.2-1 .1-.3.3-.6.5-.8.2-.2.5-.4.8-.5.3-.1.7-.2 1.1-.2.4 0 .8 0 1.1.1s.7.1.9.2v4.5zm-3.4-2.2c0 .5.1.9.3 1.1.2.2.5.4.9.4.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.7c-.1 0-.2 0-.3-.1h-.5c-.4 0-.8.1-1 .4-.2.3-.3.7-.3 1.2zM209.3 375.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4h-3.5c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9 0-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3zM215.3 373c.2-.1.5-.1.9-.2s.8-.1 1.2-.1c.4 0 .8.1 1.1.2.3.1.5.3.7.5.2.2.3.5.4.8.1.3.1.6.1 1v2.9h-1.2v-2.8c0-.3 0-.5-.1-.7s-.1-.4-.2-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.9v4.2h-1.2V373z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="m222 371.4 1.2-.2v1.6h1.9v1h-1.9v2.1c0 .4.1.7.2.9.1.2.4.3.7.3.2 0 .4 0 .6-.1.2 0 .3-.1.4-.1l.2 1c-.1.1-.3.1-.6.2-.2.1-.5.1-.8.1-.4 0-.7 0-.9-.2-.2-.1-.4-.2-.6-.4-.1-.2-.2-.4-.3-.7-.1-.3-.1-.6-.1-.9v-4.6z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M226 375.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4h-3.5c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9 0-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M148.3 382c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .4-.1.8-.2 1-.1.3-.4.5-.6.7-.3.2-.6.3-1 .4-.4.1-.8.1-1.3.1h-.6v2.4h-1.3V382c.3-.1.6-.1 1-.1.3.1.6.1.9.1zm.1 1.1h-.8v2.4h.6c.6 0 1.1-.1 1.4-.3s.5-.5.5-1c0-.2 0-.4-.1-.6-.1-.2-.2-.3-.4-.4s-.3-.1-.5-.2c-.2.1-.5.1-.7.1z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M155.7 384.9c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1h-.4c-.1 0-.3 0-.3.1v4.2h-1.2v-5c.2-.1.5-.2.9-.2.4-.1.7-.1 1.2-.1h.6c.1 0 .2 0 .3.1.1 0 .2 0 .2.1l-.3 1zM161.4 386.4c0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.8.6-.3.1-.7.2-1 .2-.4 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.3-.2-.7-.2-1.1s.1-.8.2-1.1c.1-.3.3-.6.5-.9.2-.2.5-.4.8-.6s.6-.2 1-.2.7.1 1 .2.6.3.8.6c.2.2.4.5.5.9s.2.7.2 1.1zm-1.3 0c0-.5-.1-.9-.3-1.2-.2-.3-.5-.5-.9-.5s-.7.2-.9.5c-.2.3-.3.7-.3 1.2s.1.9.3 1.2c.2.3.5.5.9.5s.7-.2.9-.5c.2-.3.3-.7.3-1.2z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M166.5 384.6c-.1.1-.3.3-.5.6s-.4.5-.7.8c-.2.3-.5.6-.7 1-.2.3-.5.7-.7 1h2.7v1h-4.2v-.8c.1-.3.3-.6.5-.9.2-.3.4-.6.7-.9.2-.3.5-.6.7-.9.2-.3.4-.5.6-.8h-2.4v-1h4v.9z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M167.4 386.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4h-3.5c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3zM174.7 388.1c.3 0 .6 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4l-.8-.4-.6-.3c-.2-.1-.3-.2-.5-.3-.1-.1-.2-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.5.2-.9.5-1.1.4-.3.8-.4 1.4-.4.3 0 .6 0 .9.1.3.1.5.1.6.2l-.2 1c-.1-.1-.3-.1-.5-.2s-.4-.1-.7-.1c-.2 0-.4 0-.6.1-.2.1-.2.2-.2.4v.2c0 .1.1.1.2.2s.2.1.3.2.3.1.4.2c.3.1.5.2.7.3.2.1.4.2.5.4.1.1.2.3.3.4.1.2.1.4.1.6 0 .5-.2.9-.6 1.1-.4.3-.9.4-1.6.4-.5 0-.8 0-1.1-.1-.3-.1-.5-.1-.6-.2l.2-1c.2.1.4.1.6.2s.7 0 1 0zM179.3 388.1c.3 0 .6 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4l-.8-.4-.6-.3c-.2-.1-.3-.2-.5-.3-.1-.1-.2-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.5.2-.9.5-1.1.4-.3.8-.4 1.4-.4.3 0 .6 0 .9.1.3.1.5.1.6.2l-.2 1c-.1-.1-.3-.1-.5-.2s-.4-.1-.7-.1c-.2 0-.4 0-.6.1-.2.1-.2.2-.2.4v.2c0 .1.1.1.2.2s.2.1.3.2.3.1.4.2c.3.1.5.2.7.3.2.1.4.2.5.4.1.1.2.3.3.4.1.2.1.4.1.6 0 .5-.2.9-.6 1.1-.4.3-.9.4-1.6.4-.5 0-.8 0-1.1-.1-.3-.1-.5-.1-.6-.2l.2-1c.2.1.4.1.6.2s.6 0 1 0zM184.3 383.6c.4 0 .7.1 1 .2s.5.2.7.4c.2.2.3.4.4.7.1.3.1.5.1.8v3.2c-.2 0-.5.1-.8.1-.4.1-.8.1-1.3.1-.3 0-.6 0-.9-.1-.3-.1-.5-.2-.7-.3-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.2.3-.4.5-.5.2-.1.4-.2.7-.3.3-.1.5-.1.8-.1h.4c.1 0 .3 0 .5.1V385.2c0-.1-.1-.2-.2-.3s-.2-.2-.3-.2c-.1-.1-.3-.1-.5-.1-.3 0-.5 0-.8.1s-.4.1-.6.1l-.1-1c.2-.1.4-.1.7-.2.1.1.4 0 .8 0zm.1 4.6c.4 0 .7 0 .9-.1v-1.3c-.1 0-.2 0-.3-.1h-.8c-.1 0-.3.1-.4.1-.1.1-.2.1-.3.2-.1.1-.1.2-.1.4 0 .3.1.5.3.6.1.1.4.2.7.2zM192.2 388.8c-.2.1-.5.1-.9.2s-.8.1-1.2.1c-.4 0-.8-.1-1.1-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.5-.4-.8-.1-.3-.1-.6-.1-1v-2.9h1.2v2.7c0 .6.1 1 .2 1.2.2.2.4.4.9.4h.9v-4.2h1.2v5z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="m194.6 382.4 1.2-.2v1.6h1.9v1h-1.9v2.1c0 .4.1.7.2.9.1.2.4.3.7.3.2 0 .4 0 .6-.1.2 0 .3-.1.4-.1l.2 1c-.1.1-.3.1-.6.2-.2.1-.5.1-.8.1-.4 0-.7 0-.9-.2-.2-.1-.4-.2-.6-.4-.1-.2-.2-.4-.3-.7-.1-.3-.1-.6-.1-.9v-4.6z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M203.6 386.4c0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.8.6-.3.1-.7.2-1 .2-.4 0-.7-.1-1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.3-.2-.7-.2-1.1s.1-.8.2-1.1c.1-.3.3-.6.5-.9.2-.2.5-.4.8-.6s.6-.2 1-.2.7.1 1 .2.6.3.8.6c.2.2.4.5.5.9s.2.7.2 1.1zm-1.2 0c0-.5-.1-.9-.3-1.2-.2-.3-.5-.5-.9-.5s-.7.2-.9.5c-.2.3-.3.7-.3 1.2s.1.9.3 1.2c.2.3.5.5.9.5s.7-.2.9-.5c.2-.3.3-.7.3-1.2zM207.9 386.3c0-.5-.1-.9-.2-1.2-.1-.2-.4-.4-.8-.4h-.8v4.2h-1.2V384c.2-.1.5-.1.9-.2s.8-.1 1.2-.1c.4 0 .7 0 .9.1.2.1.4.2.6.4.1-.1.2-.1.3-.2.1-.1.2-.1.4-.2s.3-.1.4-.1h.5c.4 0 .7.1 1 .2.3.1.5.3.6.5s.3.5.3.8.1.6.1 1v2.9h-1.2v-2.8c0-.5-.1-.9-.2-1.2-.1-.2-.4-.4-.8-.4-.2 0-.4 0-.5.1s-.3.1-.4.2c.1.2.1.3.1.5v3.5h-1.2v-2.7zM215.3 383.6c.4 0 .7.1 1 .2s.5.2.7.4c.2.2.3.4.4.7.1.3.1.5.1.8v3.2c-.2 0-.5.1-.8.1-.4.1-.8.1-1.3.1-.3 0-.6 0-.9-.1-.3-.1-.5-.2-.7-.3-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.2.3-.4.5-.5.2-.1.4-.2.7-.3.3-.1.5-.1.8-.1h.4c.1 0 .3 0 .5.1V385.2c0-.1-.1-.2-.2-.3s-.2-.2-.3-.2c-.1-.1-.3-.1-.5-.1-.3 0-.5 0-.8.1s-.4.1-.6.1l-.1-1c.2-.1.4-.1.7-.2.1.1.4 0 .8 0zm.1 4.6c.4 0 .7 0 .9-.1v-1.3c-.1 0-.2 0-.3-.1h-.8c-.1 0-.3.1-.4.1-.1.1-.2.1-.3.2-.1.1-.1.2-.1.4 0 .3.1.5.3.6.1.1.4.2.7.2zM218.8 382.4l1.2-.2v1.6h1.9v1H220v2.1c0 .4.1.7.2.9.1.2.4.3.7.3.2 0 .4 0 .6-.1.2 0 .3-.1.4-.1l.2 1c-.1.1-.3.1-.6.2-.2.1-.5.1-.8.1-.4 0-.7 0-.9-.2-.2-.1-.4-.2-.6-.4-.1-.2-.2-.4-.3-.7-.1-.3-.1-.6-.1-.9v-4.6zM224.4 382.2c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.4.1.5.2c.1.1.2.3.2.5zm-.1 6.8H223v-5.2h1.2v5.2zM227.1 388.1c.3 0 .6 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4l-.8-.4-.6-.3c-.2-.1-.3-.2-.5-.3-.1-.1-.2-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.5.2-.9.5-1.1.4-.3.8-.4 1.4-.4.3 0 .6 0 .9.1.3.1.5.1.6.2l-.2 1c-.1-.1-.3-.1-.5-.2s-.4-.1-.7-.1c-.2 0-.4 0-.6.1-.2.1-.2.2-.2.4v.2c0 .1.1.1.2.2s.2.1.3.2.3.1.4.2c.3.1.5.2.7.3.2.1.4.2.5.4.1.1.2.3.3.4.1.2.1.4.1.6 0 .5-.2.9-.6 1.1-.4.3-.9.4-1.6.4-.5 0-.8 0-1.1-.1-.3-.1-.5-.1-.6-.2l.2-1c.2.1.4.1.6.2s.7 0 1 0zM231.7 382.2c0 .2-.1.4-.2.5-.1.1-.3.2-.5.2s-.4-.1-.5-.2c-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.4.1.5.2c.1.1.2.3.2.5zm-.1 6.8h-1.2v-5.2h1.2v5.2zM232.8 386.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4H234c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9 0-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3zM241.8 384.9c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1h-.4c-.1 0-.3 0-.3.1v4.2h-1.2v-5c.2-.1.5-.2.9-.2.4-.1.7-.1 1.2-.1h.6c.1 0 .2 0 .3.1.1 0 .2 0 .2.1l-.3 1zM247.2 388.8c-.2.1-.5.1-.9.2s-.8.1-1.2.1c-.4 0-.8-.1-1.1-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.5-.4-.8-.1-.3-.1-.6-.1-1v-2.9h1.2v2.7c0 .6.1 1 .2 1.2.2.2.4.4.9.4h.9v-4.2h1.2v5zM248.7 384c.2-.1.5-.1.9-.2s.8-.1 1.2-.1c.4 0 .8.1 1.1.2.3.1.5.3.7.5.2.2.3.5.4.8.1.3.1.6.1 1v2.9h-1.2v-2.8c0-.3 0-.5-.1-.7s-.1-.4-.2-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.9v4.2h-1.2V384zM258.9 388.5c0 .8-.2 1.4-.6 1.8s-1.1.6-1.9.6c-.3 0-.6 0-.9-.1-.3-.1-.6-.1-.8-.2l.2-1c.2.1.4.2.7.2.3.1.5.1.9.1.5 0 .8-.1 1-.3s.3-.5.3-.9v-.2c-.1.1-.3.1-.5.2s-.4.1-.7.1c-.3 0-.6-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.4-.5-.5-.8-.1-.3-.2-.7-.2-1.1 0-.4.1-.7.2-1 .1-.3.3-.6.5-.8.2-.2.5-.4.8-.5.3-.1.7-.2 1.1-.2.4 0 .8 0 1.1.1s.7.1.9.2v4.5zm-3.4-2.2c0 .5.1.9.3 1.1.2.2.5.4.9.4.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.7c-.1 0-.2 0-.3-.1h-.5c-.4 0-.8.1-1 .4-.2.3-.3.7-.3 1.2z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M168 392.2c.3 0 .5 0 .7.1.2 0 .4.1.5.1l-.2 1c-.1-.1-.2-.1-.4-.1s-.3-.1-.5-.1-.4 0-.5.1-.2.1-.3.2c-.1.1-.1.2-.2.4v.8h1.9v1h-1.9v4.2h-1.2v-5.6c0-.7.2-1.2.5-1.6.4-.3.9-.5 1.6-.5zM174.2 399.8c-.2.1-.5.1-.9.2s-.8.1-1.2.1c-.4 0-.8-.1-1.1-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.5-.4-.8-.1-.3-.1-.6-.1-1v-2.9h1.2v2.7c0 .6.1 1 .2 1.2.2.2.4.4.9.4h.9v-4.2h1.2v5zm-3.2-5.9c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s.1-.4.2-.5.3-.2.5-.2.3.1.5.2c.1.1.2.3.2.5s-.1.4-.2.5c-.2.2-.4.2-.5.2zm2 0c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s.1-.4.2-.5.3-.2.5-.2.3.1.5.2c.1.1.2.3.2.5s-.1.4-.2.5c-.1.2-.3.2-.5.2zM178.7 395.9c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1h-.4c-.1 0-.3 0-.3.1v4.2h-1.2v-5c.2-.1.5-.2.9-.2.4-.1.7-.1 1.2-.1h.6c.1 0 .2 0 .3.1.1 0 .2 0 .2.1l-.3 1zM183.8 394.6c.4 0 .7.1 1 .2s.5.2.7.4c.2.2.3.4.4.7.1.3.1.5.1.8v3.2c-.2 0-.5.1-.8.1-.4.1-.8.1-1.3.1-.3 0-.6 0-.9-.1-.3-.1-.5-.2-.7-.3-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.2.3-.4.5-.5.2-.1.4-.2.7-.3.3-.1.5-.1.8-.1h.4c.1 0 .3 0 .5.1V396.2c0-.1-.1-.2-.2-.3s-.2-.2-.3-.2c-.1-.1-.3-.1-.5-.1-.3 0-.5 0-.8.1s-.4.1-.6.1l-.1-1c.2-.1.4-.1.7-.2.2.1.5 0 .8 0zm.1 4.6c.4 0 .7 0 .9-.1v-1.3c-.1 0-.2 0-.3-.1h-.8c-.1 0-.3.1-.4.1-.1.1-.2.1-.3.2-.1.1-.1.2-.1.4 0 .3.1.5.3.6.2.1.4.2.7.2zM189.2 400.1c-.4 0-.7 0-.9-.1l-.6-.3c-.1-.1-.2-.3-.3-.5s-.1-.4-.1-.7v-6l1.2-.2v6.4c0 .1.1.2.1.3l.2.2c.1 0 .2.1.4.1v.8zM192.2 400.1c-.4 0-.7 0-.9-.1l-.6-.3c-.1-.1-.2-.3-.3-.5s-.1-.4-.1-.7v-6l1.2-.2v6.4c0 .1.1.2.1.3l.2.2c.1 0 .2.1.4.1v.8zM193.1 397.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4h-3.5c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3zM206.1 400c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8h-2.9c-.1.3-.2.6-.3.8-.1.3-.2.5-.3.8h-1.3c.3-.7.5-1.4.7-2s.5-1.2.7-1.8c.2-.6.4-1.1.7-1.6s.4-1 .7-1.5h1.2c.2.5.5 1 .7 1.5.2.5.4 1 .7 1.6.2.6.5 1.2.7 1.8s.5 1.3.7 2h-1.4zm-2.1-5.6c-.2.4-.3.8-.5 1.3s-.4 1.1-.6 1.6h2.3c-.2-.6-.4-1.1-.6-1.7-.3-.4-.4-.8-.6-1.2zM208.2 395c.2-.1.5-.1.9-.2s.8-.1 1.2-.1c.4 0 .8.1 1.1.2.3.1.5.3.7.5.2.2.3.5.4.8.1.3.1.6.1 1v2.9h-1.2v-2.8c0-.3 0-.5-.1-.7s-.1-.4-.2-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.9v4.2h-1.2V395z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M217.6 400.1c-.4 0-.7 0-.9-.1l-.6-.3c-.1-.1-.2-.3-.3-.5s-.1-.4-.1-.7v-6l1.2-.2v6.4c0 .1.1.2.1.3l.2.2c.1 0 .2.1.4.1v.8z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M220.8 394.6c.4 0 .7.1 1 .2s.5.2.7.4c.2.2.3.4.4.7.1.3.1.5.1.8v3.2c-.2 0-.5.1-.8.1-.4.1-.8.1-1.3.1-.3 0-.6 0-.9-.1-.3-.1-.5-.2-.7-.3-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.3.1-.6.2-.8.1-.2.3-.4.5-.5.2-.1.4-.2.7-.3.3-.1.5-.1.8-.1h.4c.1 0 .3 0 .5.1V396.2c0-.1-.1-.2-.2-.3s-.2-.2-.3-.2c-.1-.1-.3-.1-.5-.1-.3 0-.5 0-.8.1s-.4.1-.6.1l-.1-1c.2-.1.4-.1.7-.2.2.1.5 0 .8 0zm.1 4.6c.4 0 .7 0 .9-.1v-1.3c-.1 0-.2 0-.3-.1h-.8c-.1 0-.3.1-.4.1-.1.1-.2.1-.3.2-.1.1-.1.2-.1.4 0 .3.1.5.3.6.2.1.4.2.7.2zM228.8 399.5c0 .8-.2 1.4-.6 1.8s-1.1.6-1.9.6c-.3 0-.6 0-.9-.1-.3-.1-.6-.1-.8-.2l.2-1c.2.1.4.2.7.2.3.1.5.1.9.1.5 0 .8-.1 1-.3s.3-.5.3-.9v-.2c-.1.1-.3.1-.5.2s-.4.1-.7.1c-.3 0-.6-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.4-.5-.5-.8-.1-.3-.2-.7-.2-1.1 0-.4.1-.7.2-1 .1-.3.3-.6.5-.8.2-.2.5-.4.8-.5.3-.1.7-.2 1.1-.2.4 0 .8 0 1.1.1s.7.1.9.2v4.5zm-3.4-2.2c0 .5.1.9.3 1.1.2.2.5.4.9.4.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.7c-.1 0-.2 0-.3-.1h-.5c-.4 0-.8.1-1 .4-.2.3-.3.7-.3 1.2zM230 397.4c0-.5.1-.9.2-1.2s.3-.6.5-.9c.2-.2.5-.4.8-.5.3-.1.6-.2.9-.2.7 0 1.3.2 1.7.7.4.4.6 1.1.6 2v.4h-3.5c0 .4.2.7.4 1 .3.2.6.3 1.1.3.3 0 .6 0 .8-.1.2-.1.4-.1.6-.2l.2 1c-.1 0-.2.1-.3.1-.1 0-.2.1-.4.1-.1 0-.3.1-.5.1h-.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9 0-.1-.1-.5-.1-.9zm3.5-.5c0-.2 0-.3-.1-.5 0-.1-.1-.3-.2-.4l-.3-.3c-.1-.1-.3-.1-.5-.1s-.4 0-.5.1c-.1.1-.3.2-.4.3-.1.1-.2.2-.2.4-.1.1-.1.3-.1.5h2.3zM236 395c.2-.1.5-.1.9-.2s.8-.1 1.2-.1c.4 0 .8.1 1.1.2.3.1.5.3.7.5.2.2.3.5.4.8.1.3.1.6.1 1v2.9h-1.2v-2.8c0-.3 0-.5-.1-.7s-.1-.4-.2-.5l-.3-.3c-.1-.1-.3-.1-.5-.1h-.9v4.2H236V395z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M135.6 413.2c0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.1s-.3 0-.4-.1c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3 0-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4 0-.1.1-.2.2-.3s.2-.2.3-.2c.1-.1.3-.1.4-.1s.3 0 .4.1c.1.1.2.1.3.2s.2.2.2.3.1.3.1.4z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M142 416.1c-.4 0-.7-.1-1.1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.4-.2-.8-.2-1.2 0-.5.1-.9.2-1.2.1-.4.3-.7.6-.9.2-.2.5-.4.8-.6.3-.1.7-.2 1-.2h.6c.2 0 .3.1.5.1.1 0 .2.1.3.1s.1.1.2.1l-.2.6s-.1-.1-.2-.1-.2-.1-.3-.1c-.1 0-.2-.1-.4-.1h-.4c-.3 0-.6.1-.8.2s-.4.2-.6.4c-.2.2-.3.4-.4.7-.1.3-.1.6-.1.9 0 .3 0 .6.1.9.1.3.2.5.3.7s.3.3.6.5.5.2.8.2c.4 0 .7 0 .9-.1.2-.1.4-.1.5-.2l.2.6s-.1.1-.2.1-.2.1-.4.1c-.1 0-.3.1-.5.1-.1.1-.3.1-.5.1zM144.5 416v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H145.3v3.5h-.8zM150.5 411.7c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H151.5V412.7c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1-.1.2.2.1.5.1zm0 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.2 0 .4.1.7.1zM154.8 411.8H155.5l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1zM159 415.6c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.3-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2.2 0 .4.1.7.1.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4s.2.2.4.2c.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.3zM160.8 413.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.3-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM165.5 412c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H166.4v3.5h-.7V412zM175.7 416c-.1-.2-.2-.5-.3-.7-.1-.2-.2-.5-.2-.7h-2.5l-.5 1.4h-.8c.2-.6.4-1.1.6-1.6.2-.5.4-1 .5-1.4s.4-.9.5-1.3l.6-1.2h.7l.6 1.2c.2.4.4.8.5 1.3s.4.9.5 1.4c.2.5.4 1 .6 1.6h-.8zm-.8-2c-.2-.5-.3-.9-.5-1.3s-.3-.9-.5-1.3c-.2.4-.4.8-.5 1.3s-.3.9-.5 1.3h2zM177.2 412c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H178.1v3.5h-.7V412zM181.4 413.3h2v.7h-2v-.7zM185 415.1v.2c0 .3 0 .7-.1 1-.1.3-.2.6-.4.9l-.6-.2c.1-.3.2-.5.3-.8 0-.3.1-.5.1-.8v-.4h.7zM190.1 416.1c-.4 0-.7-.1-.9-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.4-.4-.7s-.1-.6-.1-.9v-3.5h.8v3.4c0 .6.1 1 .4 1.2.2.3.6.4 1 .4.2 0 .4 0 .5-.1s.3-.2.4-.3.2-.3.3-.5c.1-.2.1-.4.1-.7v-3.4h.8v3.5c0 .3 0 .6-.1.9s-.2.5-.4.7-.4.3-.7.5c-.3.2-.6.2-1 .2zM193.5 412c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .5 0 .7.1.2.1.3.2.5.3 0 0 .1-.1.2-.1s.2-.1.3-.1c.1 0 .2-.1.4-.1.1 0 .3-.1.5-.1.3 0 .6 0 .8.1.2.1.4.2.5.4s.2.4.2.6c0 .2.1.5.1.8v2.3h-.7V413.2c0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.4-.1-.3 0-.5 0-.6.1-.2.1-.3.1-.3.2s.1.3.1.5v2.8H196V413.2c0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.4-.1H194.5v3.5h-.7V412zM200 413.3h2v.7h-2v-.7zM208 415.9c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H207V412h.7v3.9zM209.2 412c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H210.1v3.5h-.7V412zM216.5 409.9l.7-.1v6.1c-.2 0-.4.1-.7.1-.3 0-.6.1-.9.1-.3 0-.6-.1-.9-.2-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7s-.1-.6-.1-.9c0-.3 0-.6.1-.9.1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.2.8-.2.2 0 .5 0 .6.1.2.1.3.1.4.2v-2.1zm0 2.8c-.1-.1-.2-.1-.4-.2s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.3.2-.4.3s-.2.3-.2.5-.1.4-.1.6c0 .5.1.9.4 1.1s.6.4 1 .4h.5c.1 0 .2 0 .3-.1v-2.6zM224.1 416c-.1-.2-.2-.5-.3-.7s-.2-.5-.2-.7h-2.5l-.5 1.4h-.8c.2-.6.4-1.1.6-1.6s.4-1 .5-1.4.4-.9.5-1.3.4-.8.6-1.2h.7l.6 1.2c.2.4.4.8.5 1.3s.4.9.5 1.4.4 1 .6 1.6h-.8zm-.7-2c-.2-.5-.3-.9-.5-1.3s-.3-.9-.5-1.3c-.2.4-.4.8-.5 1.3s-.3.9-.5 1.3h2zM226.4 412c.1-.1.2-.1.4-.2s.4-.1.6-.1c.3 0 .6.1.8.2.2.1.4.3.6.4.2.2.3.4.4.7.1.3.1.6.1.9 0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.7.4-.3.1-.5.2-.9.2-.3 0-.7 0-.9-.1-.3 0-.5-.1-.7-.1v-6l.7-.1v2.2zm0 3.4c.1 0 .2 0 .3.1s.3 0 .5 0c.4 0 .7-.1 1-.4s.4-.6.4-1.1c0-.2 0-.4-.1-.6s-.1-.3-.2-.5-.2-.2-.4-.3c-.2-.1-.3-.1-.5-.1s-.4 0-.6.1c-.2.1-.3.1-.4.2v2.6zM230.4 412c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .5 0 .7.1.2.1.3.2.5.3 0 0 .1-.1.2-.1s.2-.1.3-.1c.1 0 .2-.1.4-.1.1 0 .3-.1.5-.1.3 0 .6 0 .8.1.2.1.4.2.5.4s.2.4.2.6c0 .2.1.5.1.8v2.3h-.7V413.2c0-.2-.1-.3-.1-.4s-.2-.2-.3-.3c-.1-.1-.3-.1-.4-.1-.3 0-.5 0-.6.1-.2.1-.3.1-.3.2s.1.3.1.5v2.8h-.7V413.2c0-.2-.1-.3-.1-.4s-.2-.2-.3-.3c-.1-.1-.3-.1-.4-.1H231.8v3.5h-.7V412zM237.1 413.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.4-.4-.7-.1-.1-.1-.3-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM243 416.1c-.5 0-.8-.1-1-.3-.2-.2-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM246.6 409.9l.7-.1v6.1c-.2 0-.4.1-.7.1-.3 0-.6.1-.9.1-.3 0-.6-.1-.9-.2-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7s-.1-.6-.1-.9c0-.3 0-.6.1-.9.1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.2.8-.2.2 0 .5 0 .6.1.2.1.3.1.4.2v-2.1zm0 2.8c-.1-.1-.2-.1-.4-.2s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.3.2-.4.3s-.2.3-.2.5-.1.4-.1.6c0 .5.1.9.4 1.1s.6.4 1 .4h.5c.1 0 .2 0 .3-.1v-2.6zM252 415.9c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H251V412h.7v3.9zM253.2 412c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1H254.1v3.5h-.7V412zM260.4 415.6c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.2-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2s.4.1.7.1c.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4.1.1.2.2.4.2.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.3z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M135.6 422.7c0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.1s-.3 0-.4-.1c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3 0-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4 0-.1.1-.2.2-.3s.2-.2.3-.2c.1-.1.3-.1.4-.1s.3 0 .4.1c.1.1.2.1.3.2s.2.2.2.3.1.3.1.4z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M142 425.6c-.4 0-.7-.1-1.1-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9-.1-.4-.2-.8-.2-1.2 0-.5.1-.9.2-1.2.1-.4.3-.7.6-.9.2-.2.5-.4.8-.6.3-.1.7-.2 1-.2h.6c.2 0 .3.1.5.1.1 0 .2.1.3.1s.1.1.2.1l-.2.6s-.1-.1-.2-.1-.2-.1-.3-.1c-.1 0-.2-.1-.4-.1h-.4c-.3 0-.6.1-.8.2s-.4.2-.6.4c-.2.2-.3.4-.4.7-.1.3-.1.6-.1.9 0 .3 0 .6.1.9.1.3.2.5.3.7s.3.3.6.5.5.2.8.2c.4 0 .7 0 .9-.1.2-.1.4-.1.5-.2l.2.6s-.1.1-.2.1-.2.1-.4.1c-.1 0-.3.1-.5.1-.1.1-.3.1-.5.1zM144.5 425.5v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H145.3v3.5h-.8zM150.5 421.2c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H151.5V422.2c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1-.1.2.2.1.5.1zm0 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.2 0 .4.1.7.1zM154.8 421.3H155.5l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1zM159 425.1c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.3-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2.2 0 .4.1.7.1.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4s.2.2.4.2c.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2V422zM160.8 423.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.3-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM165.5 421.5c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H166.4v3.5h-.7v-3.9zM170.8 421.5c.1-.1.2-.1.4-.2s.4-.1.6-.1c.3 0 .6.1.8.2s.4.3.6.4c.2.2.3.4.4.7.1.3.1.6.1.9 0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.7.4-.3.1-.5.2-.9.2-.3 0-.7 0-.9-.1-.3 0-.5-.1-.7-.1v-6l.7-.1v2.2zm0 3.4c.1 0 .2 0 .3.1h.5c.4 0 .7-.1 1-.4.2-.3.4-.6.4-1.1 0-.2 0-.4-.1-.6 0-.2-.1-.3-.2-.5-.1-.1-.2-.2-.4-.3-.2-.1-.3-.1-.5-.1s-.4 0-.6.1c-.2.1-.3.1-.4.2v2.6zM174.5 423.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.3-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M181.4 421.9c-.1.1-.3.3-.4.5s-.4.5-.6.7l-.6.9-.6.9h2.3v.6h-3.2v-.5c.1-.2.3-.5.5-.8.2-.3.4-.6.6-.8.2-.3.4-.5.6-.8.2-.2.4-.5.5-.6h-2.1v-.6h3v.5z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M185.9 423.4c0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2s-.5-.1-.8-.2c-.2-.1-.4-.3-.6-.4s-.3-.4-.4-.7c-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7s.4-.3.6-.4c.2-.1.5-.2.8-.2s.5.1.8.2c.2.1.4.3.6.4.2.2.3.4.4.7s.1.6.1.9zm-.8 0c0-.5-.1-.8-.3-1.1-.2-.3-.5-.4-.9-.4s-.6.1-.9.4c-.2.3-.3.6-.3 1.1 0 .5.1.8.3 1.1.2.3.5.4.9.4s.6-.1.9-.4c.2-.2.3-.6.3-1.1zM189.5 425.1c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.3-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2.2 0 .4.1.7.1.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4s.2.2.4.2c.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2V422zM191.3 423.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.3-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM196 421.5c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H196.9v3.5h-.9v-3.9zM200.4 423.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.3-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM211.5 422.7c0 .5-.1.9-.2 1.3s-.4.6-.6.9c-.3.2-.6.4-1 .5-.4.1-.8.2-1.2.2h-.7c-.3 0-.5-.1-.7-.1V420c.2-.1.5-.1.7-.1h.7c.5 0 .9.1 1.2.2.4.1.7.3 1 .5.3.2.5.5.6.9.2.3.2.8.2 1.2zm-3 2.2c.7 0 1.3-.2 1.6-.6s.5-.9.5-1.6c0-.7-.2-1.2-.5-1.6s-.9-.6-1.6-.6h-.8v4.2h.3c.1.2.3.2.5.2zM213.9 421.2c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H214.9V422.2c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .2.2.1.5.1zm0 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.2 0 .4.1.7.1zM217.4 421.3h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1-.2.1-.4.1-.6.1-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM219.6 423.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.3-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM224.3 421.5c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H225.2v3.5h-.7v-3.9zM228.7 423.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.3-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM234.9 421.3H235.6l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1zM238.1 419.3h.6c.2 0 .3.1.3.1l-.1.6c-.1 0-.2-.1-.3-.1h-.4c-.3 0-.6.1-.7.3s-.2.4-.2.8v.4h1.6v.6h-1.6v3.5h-.7V421c0-.5.1-.9.4-1.2.1-.4.5-.5 1.1-.5zM240.9 421.2c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H241.9V422.2c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .2.2.1.5.1zm.1 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.1 0 .4.1.7.1zM244.7 425c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1-.1-.1.2 0 .5 0zM248.3 425c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1-.1-.1.1 0 .5 0zM254.2 425.4c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H253.2v-3.5h.7v3.9zM255.4 421.5c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1H256.3v3.5h-.7v-3.9zM262.6 425.1c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.2-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2s.4.1.7.1c.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4.1.1.2.2.4.2.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2V422z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M135.6 432.2c0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.1s-.3 0-.4-.1c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3 0-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4 0-.1.1-.2.2-.3s.2-.2.3-.2c.1-.1.3-.1.4-.1s.3 0 .4.1c.1.1.2.1.3.2s.2.2.2.3.1.2.1.4z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M142.1 434.2c-.1-.1-.1-.3-.2-.5l-.3-.6c-.1-.2-.2-.5-.3-.7-.1-.2-.2-.5-.3-.7l-.3-.6c-.1-.2-.2-.3-.2-.4-.1.6-.1 1.3-.1 2s-.1 1.5-.1 2.2h-.8c0-.5 0-1 .1-1.5s.1-1 .1-1.4c0-.5.1-.9.1-1.4 0-.4.1-.9.1-1.3h.7c.1.2.3.5.5.8.2.3.3.7.5 1 .2.3.3.7.5 1 .2.3.3.7.4 1 .1-.3.3-.6.4-1 .2-.3.3-.7.5-1 .2-.3.3-.7.5-1 .2-.3.3-.6.5-.8h.7c.2 1.8.3 3.6.4 5.5h-.8c0-.7-.1-1.5-.1-2.2 0-.7-.1-1.4-.1-2-.1.1-.1.2-.2.4l-.3.6c-.1.2-.2.4-.3.7-.1.2-.2.5-.3.7l-.3.6c-.1.2-.2.4-.2.5h-.8zM147.9 430.7c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H148.9V431.7c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .2.2.1.5.1zm.1 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.1 0 .4.1.7.1zM151.4 430.8h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1-.2.1-.4.1-.6.1-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM153.9 435v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H154.7v3.5h-.8zM158.3 432.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM163 431c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .5 0 .7.1.2.1.3.2.5.3 0 0 .1-.1.2-.1s.2-.1.3-.1c.1 0 .2-.1.4-.1.1 0 .3-.1.5-.1.3 0 .6 0 .8.1.2.1.4.2.5.4s.2.4.2.6c0 .2.1.5.1.8v2.3h-.7V432.2c0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.4-.1-.3 0-.5 0-.6.1-.2.1-.3.1-.3.2s.1.3.1.5v2.8h-.7V432.2c0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.4-.1H164.4v3.5H163V431zM171.2 430.7c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H172.2V431.7c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .2.3.1.5.1zm.1 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.2 0 .4.1.7.1zM174.7 430.8h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1-.2.1-.4.1-.6.1-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM177.6 430.1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.4c0-.1 0-.3.1-.4s.2-.1.3-.1.2 0 .3.1c.1.1.1.2.1.4 0 .1 0 .3-.1.4 0 0-.1.1-.3.1zm.4 4.9h-.7v-4.2h.7v4.2zM180.3 434.5c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1-.1-.1.1 0 .5 0zM184.7 435.1c-.3 0-.6-.1-.9-.2-.3-.1-.5-.3-.6-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9s.2-.5.4-.7c.2-.2.4-.3.6-.5.2-.1.5-.2.8-.2h.6c.2 0 .4.1.5.2l-.2.6c-.1-.1-.2-.1-.4-.1h-.5c-.4 0-.7.1-1 .4-.2.3-.3.6-.3 1.1 0 .2 0 .4.1.6.1.2.1.3.2.5.1.1.2.2.4.3s.4.1.6.1c.2 0 .4 0 .5-.1s.3-.1.4-.1l.1.6s-.1.1-.2.1-.2 0-.3.1h-.3c.1.2 0 .2-.1.2zM186.6 435v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H187.4v3.5h-.8zM190.9 432.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM195.5 436.5h-.8l2.7-7.7h.7l-2.6 7.7zM198.7 431c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .5 0 .7.1.2.1.3.2.5.3 0 0 .1-.1.2-.1s.2-.1.3-.1c.1 0 .2-.1.4-.1.1 0 .3-.1.5-.1.3 0 .6 0 .8.1.2.1.4.2.5.4s.2.4.2.6c0 .2.1.5.1.8v2.3h-.7V432.2c0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.4-.1-.3 0-.5 0-.6.1-.2.1-.3.1-.3.2s.1.3.1.5v2.8h-.7V432.2c0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.4-.1H200.1v3.5h-.7V431zM205.3 432.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM210.7 430.8h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM214.6 430.7c.3 0 .5 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6.1-.2.2-.3.4-.4.2-.1.3-.2.6-.2.2 0 .4-.1.7-.1H215.6V431.7c0-.1-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .2.2.1.5.1zm.1 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1-.1.1-.2.1-.3.2s-.1.2-.1.3c0 .3.1.5.3.6.1 0 .4.1.7.1zM218.7 435.1c-.5 0-.8-.1-1-.3-.2-.2-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM220.9 435.1c-.5 0-.8-.1-1-.3-.2-.2-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM225.1 434.9c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H224.1V431h.7v3.9zM227.9 430.8H228.6l-.1.6c-.1 0-.2 0-.3-.1s-.3 0-.5 0h-.4c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1zM232.1 434.6c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.2-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2s.4.1.7.1c.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4.1.1.2.2.4.2.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.3zM234.5 430.1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.4c0-.1 0-.3.1-.4s.2-.1.3-.1c.1 0 .2 0 .3.1.1.1.1.2.1.4 0 .1 0 .3-.1.4-.1 0-.2.1-.3.1zm.4 4.9h-.7v-4.2h.7v4.2zM237.1 434.5c.3 0 .5 0 .7-.1s.2-.2.2-.4-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2c.2.1.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9s-.7.3-1.2.3c-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1-.1-.1.2 0 .5 0zM241.5 435.1c-.3 0-.6-.1-.9-.2-.3-.1-.5-.3-.6-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7.2-.2.4-.3.6-.5s.5-.2.8-.2h.6c.2 0 .4.1.5.2l-.2.6c-.1-.1-.2-.1-.4-.1h-.5c-.4 0-.7.1-1 .4-.2.3-.3.6-.3 1.1 0 .2 0 .4.1.6s.1.3.2.5c.1.1.2.2.4.3s.4.1.6.1c.2 0 .4 0 .5-.1s.3-.1.4-.1l.1.6s-.1.1-.2.1-.2 0-.3.1h-.3c.1.2 0 .2-.1.2zM243.4 435v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1H244.2v3.5h-.8zM247.8 432.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M142.1 443.7c-.1-.1-.1-.3-.2-.5l-.3-.6c-.1-.2-.2-.5-.3-.7-.1-.2-.2-.5-.3-.7l-.3-.6c-.1-.2-.2-.3-.2-.4-.1.6-.1 1.3-.1 2s-.1 1.5-.1 2.2h-.8c0-.5 0-1 .1-1.5s.1-1 .1-1.4c0-.5.1-.9.1-1.4 0-.4.1-.9.1-1.3h.7c.1.2.3.5.5.8.2.3.3.7.5 1 .2.3.3.7.5 1 .2.3.3.7.4 1 .1-.3.3-.6.4-1 .2-.3.3-.7.5-1 .2-.3.3-.7.5-1 .2-.3.3-.6.5-.8h.7c.2 1.8.3 3.6.4 5.5h-.8c0-.7-.1-1.5-.1-2.2 0-.7-.1-1.4-.1-2-.1.1-.1.2-.2.4l-.3.6c-.1.2-.2.4-.3.7-.1.2-.2.5-.3.7l-.3.6c-.1.2-.2.4-.2.5h-.8zM150.2 442.4c0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2s-.5-.1-.8-.2c-.2-.1-.4-.3-.6-.4s-.3-.4-.4-.7c-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7s.4-.3.6-.4c.2-.1.5-.2.8-.2s.5.1.8.2c.2.1.4.3.6.4.2.2.3.4.4.7s.1.6.1.9zm-.8 0c0-.5-.1-.8-.3-1.1-.2-.3-.5-.4-.9-.4s-.6.1-.9.4c-.2.3-.3.6-.3 1.1 0 .5.1.8.3 1.1.2.3.5.4.9.4s.6-.1.9-.4c.2-.2.3-.6.3-1.1zM154 438.4l.7-.1v6.1c-.2 0-.4.1-.7.1-.3 0-.6.1-.9.1-.3 0-.6-.1-.9-.2-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7.2-.2.4-.3.6-.4s.5-.2.8-.2c.2 0 .5 0 .6.1.2.1.3.1.4.2v-2.1zm0 2.8c-.1-.1-.2-.1-.4-.2s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.3.2-.4.3-.1.1-.2.3-.2.5s-.1.4-.1.6c0 .5.1.9.4 1.1.2.3.6.4 1 .4h.5c.1 0 .2 0 .3-.1v-2.6zM155.7 442.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM161.7 444.6c-.5 0-.8-.1-1-.3s-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM163.9 444.6c-.5 0-.8-.1-1-.3s-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM164.6 442.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM173.9 440.9c-.1.1-.3.3-.4.5s-.4.5-.6.7l-.6.9-.6.9h2.3v.6h-3.2v-.5c.1-.2.3-.5.5-.8.2-.3.4-.6.6-.8.2-.3.4-.5.6-.8.2-.2.4-.5.5-.6h-2.1v-.6h3v.5zM178.1 444.4c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H177.1v-3.5h.7v3.9zM180.9 440.3H181.6l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1z"
        className="st11"
      />
    </g>
    <g className="st2">
      <path
        d="M141.4 451.2c0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.1s-.3 0-.4-.1c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3 0-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4 0-.1.1-.2.2-.3s.2-.2.3-.2c.1-.1.3-.1.4-.1s.3 0 .4.1c.1.1.2.1.3.2s.2.2.2.3.1.2.1.4z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M149.6 449.1c-.1.1-.3.3-.4.5-.2.2-.3.4-.5.6-.2.2-.4.5-.6.8-.2.3-.4.5-.6.8-.2.3-.4.5-.5.8-.2.3-.3.5-.4.8h3.1v.7h-4v-.5c.1-.2.2-.4.4-.7.2-.3.3-.5.5-.8s.4-.5.5-.8c.2-.3.4-.5.6-.8.2-.3.4-.5.5-.7s.3-.4.5-.6h-2.8v-.7h3.8v.6z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M149.9 454.8c.1 0 .1.1.2.1h.3c.3 0 .5-.1.7-.2.2-.1.3-.3.4-.6-.3-.6-.6-1.3-.9-2-.3-.7-.5-1.4-.7-2.2h.8c.1.2.1.5.2.8l.3.9.3.9c.1.3.2.6.4.8.2-.6.4-1.1.5-1.7.1-.5.3-1.1.4-1.7h.8c-.2.8-.4 1.5-.6 2.3s-.5 1.4-.8 2l-.3.6c-.1.2-.2.3-.4.4-.1.1-.3.2-.5.2-.2.1-.4.1-.6.1H149.7l.2-.7zM155.9 451.7c.2.1.3.3.5.5s.4.4.5.6c.2.2.3.4.5.6.2.2.3.4.4.6h-.9c-.1-.2-.2-.4-.4-.6-.1-.2-.3-.4-.5-.6l-.5-.5c-.2-.2-.3-.3-.5-.4v2h-.7v-6.1l.7-.1v3.8l.4-.4.5-.5c.1-.2.3-.3.4-.5.1-.1.2-.3.3-.4h.9l-.4.4c-.1.1-.3.3-.4.5l-.5.5c0 .3-.2.5-.3.6z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M159.3 454.1c-.5 0-.8-.1-1-.3s-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM160.6 449.1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.4c0-.1 0-.3.1-.4s.2-.1.3-.1.2 0 .3.1c.1.1.1.2.1.4 0 .1 0 .3-.1.4 0 0-.1.1-.3.1zm.4 4.9h-.7v-4.2h.7v4.2z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M162.9 453.5c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1 0-.1.2 0 .5 0z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M167.1 454.1c-.3 0-.6-.1-.9-.2-.3-.1-.5-.3-.6-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9s.2-.5.4-.7c.2-.2.4-.3.6-.5.2-.1.5-.2.8-.2h.6c.2 0 .4.1.5.2l-.2.6c-.1-.1-.2-.1-.4-.1h-.5c-.4 0-.7.1-1 .4-.2.3-.3.6-.3 1.1 0 .2 0 .4.1.6.1.2.1.3.2.5.1.1.2.2.4.3s.4.1.6.1c.2 0 .4 0 .5-.1s.3-.1.4-.1l.1.6s-.1.1-.2.1-.2 0-.3.1h-.3c.2.2 0 .2-.1.2zM169 454v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H169.8v3.5h-.8zM173.4 451.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM178.1 450c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H179v3.5h-.7V450z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M185.7 454H184.5c-.1 0-.2 0-.4-.1v-5.4c.1 0 .2 0 .4-.1H185.7c.3 0 .6 0 .9.1.3 0 .5.1.7.2.2.1.4.3.5.5.1.2.2.4.2.7 0 .3-.1.6-.2.7-.1.2-.3.3-.6.4.3.1.6.2.8.5.2.2.3.5.3.9 0 .6-.2 1-.6 1.3s-1.1.3-2 .3zm-.7-3.2h1.3c.1 0 .3-.1.4-.1l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.5-.1H184.8v1.6zm0 .6v2h1.4c.2 0 .4-.1.5-.2.2-.1.3-.2.4-.3.1-.1.1-.3.1-.5s0-.3-.1-.5l-.3-.3c-.1-.1-.3-.1-.5-.2s-.4 0-.6 0h-.9zM189.1 451.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM195.3 449.7H196l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1zM196.6 451.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM203.1 454.1c-.3 0-.6-.1-.9-.2-.3-.1-.5-.3-.6-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9s.2-.5.4-.7c.2-.2.4-.3.6-.5.2-.1.5-.2.8-.2h.6c.2 0 .4.1.5.2l-.2.6c-.1-.1-.2-.1-.4-.1h-.5c-.4 0-.7.1-1 .4-.2.3-.3.6-.3 1.1 0 .2 0 .4.1.6.1.2.1.3.2.5.1.1.2.2.4.3s.4.1.6.1c.2 0 .4 0 .5-.1s.3-.1.4-.1l.1.6s-.1.1-.2.1-.2 0-.3.1h-.3c.2.2.1.2-.1.2zM205.1 454v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H205.9v3.5h-.8zM209.6 450c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H210.5v3.5h-.7V450zM217.5 453.9c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H216.5V450h.7v3.9zM218.8 450c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H219.7v3.5h-.7V450zM226 453.6c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.3-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2.2 0 .4.1.7.1.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4s.2.2.4.2c.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.3z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="m231.6 447.9.7-.1v6.1c-.2 0-.4.1-.7.1-.3 0-.6.1-.9.1-.3 0-.6-.1-.9-.2-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7.2-.2.4-.3.6-.4s.5-.2.8-.2c.2 0 .5 0 .6.1.2.1.3.1.4.2v-2.1zm0 2.8c-.1-.1-.2-.1-.4-.2s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.3.2-.4.3-.1.1-.2.3-.2.5s-.1.4-.1.6c0 .5.1.9.4 1.1.2.3.6.4 1 .4h.5c.1 0 .2 0 .3-.1v-2.6z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M233.3 451.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M238.8 453.5c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1 0-.1.2 0 .5 0z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path d="M146.1 457.9h.8v5.5h-.8v-5.5z" className="st12" />
    </g>
    <g className="st2">
      <path
        d="M149 463c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1-.1-.1.2 0 .5 0zM152.3 459.3h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1-.2.1-.4.1-.6.1-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M157.2 459.9c-.1.1-.3.3-.4.5s-.4.5-.6.7l-.6.9-.6.9h2.3v.6h-3.2v-.5c.1-.2.3-.5.5-.8.2-.3.4-.6.6-.8.2-.3.4-.5.6-.8.2-.2.4-.5.5-.6h-2.1v-.6h3v.5zM161.4 463.4c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H160.4v-3.5h.7v3.9z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M163.5 463c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1 0-.1.2 0 .5 0z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M166.7 459.3h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1-.2.1-.4.1-.6.1-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM170.5 459.2c.3 0 .6 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6s.2-.3.4-.4c.2-.1.3-.2.6-.2s.4-.1.7-.1H171.5V460.2c0-.2-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1s-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .1.3.1.5.1zm.1 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1s-.2.1-.3.2c-.1.1-.1.2-.1.3 0 .3.1.5.3.6.2 0 .4.1.7.1zM173.4 459.5c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.8v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H174.2v3.5h-.7v-3.9z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="m180.3 457.4.7-.1v6.1c-.2 0-.4.1-.7.1-.3 0-.6.1-.9.1-.3 0-.6-.1-.9-.2-.3-.1-.5-.2-.7-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7.2-.2.4-.3.6-.4s.5-.2.8-.2c.2 0 .5 0 .6.1.2.1.3.1.4.2v-2.1zm0 2.8c-.1-.1-.2-.1-.4-.2s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.3.2-.4.3-.1.1-.2.3-.2.5s-.1.4-.1.6c0 .5.1.9.4 1.1.2.3.6.4 1 .4h.5c.1 0 .2 0 .3-.1v-2.6z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M182 461.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M187.5 463c.3 0 .5 0 .7-.1.1-.1.2-.2.2-.4s-.1-.3-.2-.4c-.1-.1-.4-.2-.7-.4-.2-.1-.3-.1-.5-.2-.1-.1-.3-.1-.4-.2l-.3-.3c-.1-.1-.1-.3-.1-.5 0-.4.1-.7.4-.9.3-.2.6-.3 1.1-.3h.7c.1 0 .2 0 .3.1.1 0 .1 0 .2.1l-.1.6c-.1 0-.2-.1-.4-.1s-.4-.1-.6-.1c-.2 0-.4 0-.5.1-.2.1-.2.2-.2.4 0 .1 0 .2.1.2 0 .1.1.1.2.2s.2.1.3.2c.1 0 .2.1.4.2s.4.1.5.2.3.2.4.3l.3.3c.1.1.1.3.1.5 0 .4-.1.7-.4.9-.3.2-.7.3-1.2.3-.4 0-.7 0-.9-.1s-.3-.1-.4-.1l.1-.6c.1 0 .2.1.4.1 0-.1.2 0 .5 0z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M141.4 470.2c0 .1 0 .3-.1.4 0 .1-.1.2-.2.3-.1.1-.2.2-.3.2-.1.1-.3.1-.4.1s-.3 0-.4-.1c-.1-.1-.2-.1-.3-.2-.1-.1-.2-.2-.2-.3 0-.1-.1-.3-.1-.4 0-.1 0-.3.1-.4 0-.1.1-.2.2-.3s.2-.2.3-.2c.1-.1.3-.1.4-.1s.3 0 .4.1c.1.1.2.1.3.2s.2.2.2.3.1.2.1.4z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M147.6 473H146.4c-.1 0-.2 0-.4-.1v-5.4c.1 0 .2 0 .4-.1H147.6c.3 0 .6 0 .9.1.3 0 .5.1.7.2.2.1.4.3.5.5.1.2.2.4.2.7 0 .3-.1.6-.2.7-.1.2-.3.3-.6.4.3.1.6.2.8.5.2.2.3.5.3.9 0 .6-.2 1-.6 1.3s-1.1.3-2 .3zm-.7-3.2h1.3c.1 0 .3-.1.4-.1l.3-.3c.1-.1.1-.3.1-.4 0-.2 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.1-.5-.1H146.7v1.6zm0 .6v2h1.4c.2 0 .4-.1.5-.2.2-.1.3-.2.4-.3.1-.1.1-.3.1-.5s0-.3-.1-.5l-.3-.3c-.1-.1-.3-.1-.5-.2s-.4 0-.6 0h-.9zM151 470.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7-.1-.1-.1-.4-.1-.7zm2.8-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM157.2 468.7H157.9l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.7v-4c.2-.1.4-.1.7-.2s.6.1.9.1zM158.5 470.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM165 473.1c-.3 0-.6-.1-.9-.2-.3-.1-.5-.3-.6-.4-.2-.2-.3-.4-.4-.7-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9s.2-.5.4-.7c.2-.2.4-.3.6-.5.2-.1.5-.2.8-.2h.6c.2 0 .4.1.5.2l-.2.6c-.1-.1-.2-.1-.4-.1h-.5c-.4 0-.7.1-1 .4-.2.3-.3.6-.3 1.1 0 .2 0 .4.1.6.1.2.1.3.2.5.1.1.2.2.4.3s.4.1.6.1c.2 0 .4 0 .5-.1s.3-.1.4-.1l.1.6s-.1.1-.2.1-.2 0-.3.1h-.3c.2.2.1.2-.1.2zM167 473v-6.1l.7-.1v2.1c.1-.1.3-.1.4-.1h.5c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H167.8v3.5h-.8zM171.5 469c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H172.4v3.5h-.7V469zM179.4 472.9c-.2 0-.4.1-.7.1-.3 0-.6.1-1 .1-.3 0-.6 0-.8-.1-.2-.1-.4-.2-.5-.4l-.3-.6c-.1-.2-.1-.5-.1-.8v-2.3h.7v2.2c0 .5.1.9.2 1.1.2.2.4.3.8.3H178.4V469h.7v3.9zM180.7 469c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H181.6v3.5h-.7V469zM187.9 472.6c-.1 0-.2.1-.4.2s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.4-.2-.2-.3-.4-.4-.6-.1-.2-.1-.5-.1-.9 0-.3 0-.6.1-.8s.2-.5.4-.7c.2-.2.4-.3.6-.4.3-.1.5-.2.8-.2.3 0 .6 0 .9.1s.5.1.7.1v3.7c0 .6-.2 1.1-.5 1.4-.3.3-.8.4-1.5.4-.3 0-.5 0-.7-.1-.2 0-.4-.1-.6-.2l.1-.6c.1.1.3.1.5.2.2 0 .4.1.7.1.4 0 .8-.1 1-.3.2-.2.3-.5.3-.8v-.2zm0-3.1c-.1 0-.2 0-.3-.1h-.5c-.4 0-.7.1-.9.4-.2.3-.3.6-.3 1 0 .2 0 .4.1.6.1.2.1.3.2.4s.2.2.4.2c.1.1.3.1.4.1.2 0 .4 0 .5-.1.2-.1.3-.1.4-.2v-2.3zM195 468.8c-.2.8-.5 1.5-.7 2.2-.3.7-.6 1.4-.8 1.9h-.7c-.3-.6-.5-1.2-.8-1.9-.3-.7-.5-1.5-.7-2.2h.8c.1.3.1.5.2.8l.3.9c.1.3.2.6.3.8.1.3.2.5.3.7.1-.2.2-.5.3-.7.1-.3.2-.6.3-.8l.3-.9c.1-.3.2-.6.2-.8h.7zM199.3 470.9c0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2s-.5-.1-.8-.2c-.2-.1-.4-.3-.6-.4s-.3-.4-.4-.7c-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7s.4-.3.6-.4c.2-.1.5-.2.8-.2s.5.1.8.2c.2.1.4.3.6.4.2.2.3.4.4.7s.1.6.1.9zm-.7 0c0-.5-.1-.8-.3-1.1-.2-.3-.5-.4-.9-.4s-.6.1-.9.4c-.2.3-.3.6-.3 1.1 0 .5.1.8.3 1.1.2.3.5.4.9.4s.6-.1.9-.4c.2-.2.3-.6.3-1.1zM200.4 469c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.8v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H201.2v3.5h-.7V469zM210.5 470.9c0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2s-.5-.1-.8-.2c-.2-.1-.4-.3-.6-.4s-.3-.4-.4-.7c-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7s.4-.3.6-.4c.2-.1.5-.2.8-.2s.5.1.8.2c.2.1.4.3.6.4.2.2.3.4.4.7s.1.6.1.9zm-.8 0c0-.5-.1-.8-.3-1.1-.2-.3-.5-.4-.9-.4s-.6.1-.9.4c-.2.3-.3.6-.3 1.1 0 .5.1.8.3 1.1.2.3.5.4.9.4s.6-.1.9-.4c.2-.2.3-.6.3-1.1zM215.2 470.9c0 .3 0 .6-.1.9-.1.3-.2.5-.4.7-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2-.2 0-.5 0-.6-.1s-.3-.1-.4-.2v1.7h-.7V469c.2 0 .4-.1.7-.1.3-.1.6-.1.9-.1.3 0 .6.1.9.2s.5.2.7.4c.2.2.3.4.4.7v.8zm-.8 0c0-.5-.1-.9-.4-1.1-.2-.3-.6-.4-1-.4h-.5c-.1 0-.2 0-.3.1v2.6c.1.1.2.1.4.2s.4.1.6.1c.2 0 .4 0 .5-.1.2-.1.3-.2.4-.3.1-.1.2-.3.2-.5.1-.2.1-.4.1-.6zM217 468.8h1.6v.6H217v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1s-.4.1-.6.1c-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM219.9 468.1c-.1 0-.2 0-.3-.1s-.1-.2-.1-.4c0-.1 0-.3.1-.4s.2-.1.3-.1c.1 0 .2 0 .3.1.1.1.1.2.1.4 0 .1 0 .3-.1.4-.1 0-.2.1-.3.1zm.3 4.9h-.7v-4.2h.7v4.2zM221.5 469c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .5 0 .7.1.2.1.3.2.5.3 0 0 .1-.1.2-.1s.2-.1.3-.1c.1 0 .2-.1.4-.1.1 0 .3-.1.5-.1.3 0 .6 0 .8.1.2.1.4.2.5.4s.2.4.2.6c0 .2.1.5.1.8v2.3h-.7V470.2c0-.2-.1-.3-.1-.4s-.2-.2-.3-.3c-.1-.1-.3-.1-.4-.1-.3 0-.5 0-.6.1-.2.1-.3.1-.3.2s.1.3.1.5v2.8H224V470.2c0-.2-.1-.3-.1-.4s-.2-.2-.3-.3c-.1-.1-.3-.1-.4-.1H222.5v3.5h-.7V469zM229.7 468.7c.3 0 .5 0 .8.1.2.1.4.2.5.3.1.1.2.3.3.5.1.2.1.4.1.6v2.6h-.3c-.1 0-.2 0-.4.1h-1c-.2 0-.5 0-.6-.1-.2 0-.4-.1-.5-.2-.1-.1-.3-.2-.3-.4s-.1-.4-.1-.6c0-.2 0-.4.1-.6.1-.2.2-.3.4-.4.2-.1.3-.2.6-.2.2 0 .4-.1.7-.1H230.7V469.7c0-.1-.1-.2-.1-.3-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1-.5 0-.6.1c-.2 0-.3.1-.4.1l-.1-.6c.1 0 .3-.1.5-.1 0 .1.3.1.5.1zm.1 3.8h.8v-1.2c-.1 0-.1 0-.3-.1h-.8c-.1 0-.2 0-.3.1-.1.1-.2.1-.3.2s-.1.2-.1.3c0 .3.1.5.3.6.2 0 .4.1.7.1zM233.8 473.1c-.5 0-.8-.1-1-.3-.2-.2-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM234.5 470.9c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2-.3-.1-.5-.3-.7-.5-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM239.2 469c.2 0 .4-.1.7-.1.3 0 .6-.1 1-.1.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7 0-.2-.1-.3-.2-.4-.1-.1-.2-.2-.3-.2-.1-.1-.3-.1-.5-.1H240.1v3.5h-.7V469z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M147.4 481.9c.8 0 1.2-.3 1.2-.8 0-.2 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.4-.2-.2-.1-.3-.1-.5-.2s-.4-.1-.6-.2-.3-.2-.5-.3c-.1-.1-.2-.3-.3-.4-.1-.2-.1-.4-.1-.6 0-.5.2-.9.5-1.1.3-.3.8-.4 1.4-.4.3 0 .6 0 .9.1.3.1.5.2.6.2l-.2.6c-.1-.1-.3-.1-.5-.2s-.5-.1-.8-.1h-.4c-.1 0-.2.1-.3.1-.1.1-.2.1-.2.2-.1.1-.1.2-.1.3 0 .1 0 .3.1.4.1.1.1.2.2.3.1.1.2.1.4.2.1.1.3.1.5.2s.5.2.7.3c.2.1.4.2.5.3.1.1.3.3.3.5.1.2.1.4.1.7 0 .5-.2.9-.5 1.1-.4.3-.9.4-1.5.4h-.6c-.2 0-.3-.1-.5-.1s-.3-.1-.4-.1c-.1 0-.2-.1-.2-.1l.2-.6c.1.1.3.1.6.2h.8zM154 480.4c0 .3 0 .6-.1.9s-.2.5-.4.7c-.2.2-.4.3-.6.4-.2.1-.5.2-.8.2s-.5-.1-.8-.2c-.2-.1-.4-.3-.6-.4s-.3-.4-.4-.7c-.1-.3-.1-.6-.1-.9 0-.3 0-.6.1-.9.1-.3.2-.5.4-.7s.4-.3.6-.4c.2-.1.5-.2.8-.2s.5.1.8.2c.2.1.4.3.6.4.2.2.3.4.4.7s.1.6.1.9zm-.8 0c0-.5-.1-.8-.3-1.1-.2-.3-.5-.4-.9-.4s-.6.1-.9.4c-.2.3-.3.6-.3 1.1 0 .5.1.8.3 1.1.2.3.5.4.9.4s.6-.1.9-.4c.2-.3.3-.6.3-1.1zM156.3 482.6c-.5 0-.8-.1-1-.3s-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM158.5 482.6c-.5 0-.8-.1-1-.3s-.3-.5-.3-.9v-5l.7-.1v5.3c0 .1.1.1.1.2s.1.1.2.1.2 0 .3.1v.6zM159 479.7h2v.7h-2v-.7z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M164.3 478.7c-.2.7-.5 1.4-.7 2-.2.6-.5 1.2-.7 1.8h-.8c-.3-.8-.5-1.7-.7-2.6-.2-.9-.4-1.9-.6-3h.8c.1.4.2.8.2 1.2s.2.8.2 1.2.2.8.3 1.1.2.7.3 1c.2-.6.4-1.2.7-1.8.2-.7.5-1.4.7-2.1h.7c.2.7.4 1.4.7 2.1.2.7.5 1.3.7 1.8.1-.3.2-.6.3-1s.2-.7.3-1.1c.1-.4.2-.8.2-1.2s.2-.8.2-1.3h.8c-.2 1.1-.4 2.1-.6 3-.2.9-.5 1.8-.7 2.6h-.8c-.2-.6-.5-1.2-.7-1.8-.4-.5-.6-1.2-.8-1.9z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M168.2 480.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2H169c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM174.5 478.2H175.2l-.1.6c-.1 0-.2 0-.3-.1h-.9c-.1 0-.2 0-.3.1v3.5h-.6v-4c.2-.1.4-.1.7-.2s.5.1.8.1zM176.7 478.3h1.6v.6h-1.6v2.4c0 .1.1.2.1.3l.2.2h.3c.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1l.1.6c-.1 0-.2.1-.4.1-.2.1-.4.1-.6.1-.3 0-.5 0-.7-.1-.2-.1-.3-.2-.4-.3-.1-.1-.2-.3-.2-.5s-.1-.5-.1-.7v-3.7l.7-.1v1.3zM178.9 480.4c0-.4.1-.7.2-1 .1-.3.2-.5.4-.7.2-.2.4-.3.6-.4.2-.1.5-.1.7-.1.6 0 1 .2 1.3.5.3.3.4.9.4 1.6v.2h-2.8c0 .4.2.8.4 1 .2.2.6.3 1 .3.3 0 .5 0 .7-.1s.3-.1.4-.1l.1.6c-.1 0-.2.1-.5.2-.2.1-.5.1-.8.1-.4 0-.7-.1-.9-.2s-.5-.3-.7-.5c-.2-.2-.3-.4-.4-.7 0-.1-.1-.4-.1-.7zm2.9-.4c0-.3-.1-.6-.3-.8-.2-.2-.4-.3-.7-.3-.2 0-.3 0-.5.1l-.3.3c-.1.1-.2.2-.2.4s-.1.3-.1.4h2.1zM183.6 478.4c.2 0 .4-.1.7-.1s.6-.1 1-.1c.3 0 .6 0 .8.1.2.1.4.2.5.4l.3.6c.1.2.1.5.1.8v2.3h-.7v-2.2c0-.3 0-.5-.1-.7s-.1-.3-.2-.4c-.1-.1-.2-.2-.3-.2s-.3-.1-.5-.1H184.5v3.5h-.7v-3.9z"
        className="st12"
      />
    </g>
    <g className="st2">
      <path
        d="M104.3 386c.2-.4.3-.7.2-1 0-.3-.2-.4-.4-.6-.1-.1-.3-.1-.4-.1-.1 0-.3 0-.4.1-.1.1-.3.2-.5.3-.2.1-.3.3-.5.5s-.4.3-.6.5c-.2.2-.4.3-.6.4s-.4.1-.7.1c-.2 0-.5-.1-.8-.2-.6-.3-.9-.7-1-1.2-.1-.5 0-1.2.3-1.8.2-.4.4-.7.6-1s.4-.4.6-.6l.7.8c-.2.1-.4.3-.6.5-.2.2-.3.4-.5.7-.2.3-.2.6-.2.8 0 .2.2.4.4.5.1.1.3.1.4.1.1 0 .3 0 .4-.1.1-.1.3-.2.4-.3.1-.1.3-.2.4-.4.3-.2.5-.4.7-.6.2-.2.5-.3.7-.4s.5-.1.7-.1c.2 0 .5.1.8.2.6.3.9.7 1 1.2.1.6 0 1.2-.4 2-.1.3-.3.5-.4.7-.1.2-.3.4-.4.5s-.2.3-.4.4c-.1.1-.2.2-.3.2l-.8-.8c.2-.1.4-.3.6-.5.6-.1.8-.5 1-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M107.2 375.3c.5.3.9.6 1.2 1s.5.8.6 1.2c.1.4.1.8.1 1.3s-.2.8-.4 1.2c-.2.4-.5.7-.8 1s-.7.5-1.1.6c-.4.1-.9.1-1.3.1-.5-.1-1-.3-1.5-.5-.5-.3-.9-.6-1.2-1s-.5-.8-.6-1.2c-.1-.4-.1-.8-.1-1.3.1-.4.2-.8.4-1.2.2-.4.5-.7.8-1 .3-.3.7-.5 1.1-.6.4-.1.9-.1 1.3-.1s1 .2 1.5.5zm-2.7 4.7c.3.2.7.3 1 .4.3.1.6.1.9 0 .3 0 .5-.1.8-.3s.4-.4.6-.7c.2-.3.2-.5.3-.8 0-.3 0-.6-.1-.8s-.3-.5-.5-.7c-.2-.2-.5-.4-.8-.6-.3-.2-.7-.3-1-.4-.3-.1-.6-.1-.9 0-.3 0-.5.1-.8.3l-.6.6c-.2.3-.2.6-.3.8 0 .3 0 .6.1.8.1.3.3.5.5.7.2.3.5.5.8.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M113.7 371.9c-.4 0-.9 0-1.4-.1h-3.2c-.5 0-1 .1-1.4.1l4.1 2.8-.7 1-5.7-3.9.6-.9c.4-.1.8-.1 1.3-.2.5 0 1-.1 1.5-.1s1 0 1.5-.1h1.4l-3.8-2.6.7-1 5.7 3.9-.6 1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M116.3 362.7c.5.4.8.8 1.1 1.2.2.4.4.9.4 1.3s-.1.9-.2 1.4c-.2.5-.5.9-.8 1.4-.2.2-.4.5-.6.7-.2.3-.5.5-.7.7l-5.3-4.2c.1-.3.3-.6.5-.9.2-.3.4-.6.6-.8.4-.5.7-.8 1.1-1.1s.8-.5 1.3-.6c.4-.1.9-.1 1.4.1.3.1.8.4 1.2.8zm-.9 5.1.2-.2c.1-.1.2-.2.3-.4.5-.7.7-1.3.7-1.9-.1-.6-.4-1.1-1-1.6s-1.2-.7-1.8-.6c-.6.1-1.1.4-1.7 1.1-.2.3-.4.5-.5.6l3.8 3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m120.1 363.6-5.2-4.6 2.9-3.3.8.7-2.1 2.4 1.3 1.1 1.9-2.1.8.7-1.9 2.1 1.5 1.3 2.3-2.6.8.7-3.1 3.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M120.6 352.8c.7-.7 1.4-1.1 2-1.2.6-.1 1.2.1 1.8.6.7.7.8 1.4.4 2.3.2 0 .4 0 .7.1.3 0 .6.1.9.2.3.1.6.1.9.2l.9.3-1 1c-.3-.1-.5-.2-.8-.2s-.5-.1-.8-.2c-.3-.1-.5-.1-.8-.1-.2 0-.5-.1-.7-.1l-.2.2-.1.1-.4.4 1.9 1.9-.9.9-4.8-4.8c.2-.3.4-.5.6-.8s.2-.6.4-.8zm.8.7-.5.5 1.6 1.6.4-.4c.2-.2.4-.4.5-.6.1-.2.2-.4.3-.5s.1-.3 0-.5c0-.2-.2-.3-.3-.5-.2-.2-.3-.2-.5-.3s-.3 0-.5 0-.3.1-.5.2-.3.3-.5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M125.6 348.1c.3.1.6.2 1 .4s.8.3 1.2.5l1.2.6c.4.2.8.4 1.1.5-.1-.4-.2-.8-.4-1.2-.1-.4-.3-.9-.4-1.3l-.3-1.2c-.1-.4-.2-.7-.2-1l.9-.7c.4.3.8.7 1.2 1.1.4.4.8.8 1.3 1.2l1.3 1.3c.4.4.8.9 1.2 1.3l-.9.8c-.5-.6-1.1-1.2-1.7-1.8l-1.8-1.8c0 .2.1.4.2.6s.1.5.2.7c.1.3.2.5.2.8.1.3.2.5.3.8.1.3.2.5.2.7.1.2.1.4.2.6l-.7.6c-.2-.1-.3-.2-.5-.3s-.4-.2-.7-.3c-.2-.1-.5-.2-.8-.4-.3-.1-.5-.2-.8-.4-.2-.1-.5-.2-.7-.3-.2-.1-.4-.2-.6-.2.5.7 1 1.3 1.5 2s1.1 1.3 1.6 1.9l-.9.8c-.4-.5-.7-.9-1.1-1.4-.4-.5-.7-1-1.1-1.5-.4-.5-.7-1-1-1.4-.3-.5-.6-.9-.9-1.3l.7-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m135.9 348.5-4.2-5.5 3.6-2.7.6.9-2.6 1.9 1 1.4 2.3-1.7.6.8-2.3 1.7 1.2 1.6 2.7-2.1.6.9-3.5 2.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m141.1 336.4.6.9-1.8 1.2 3.2 4.9-1.1.7-3.2-4.9-1.8 1.2-.6-.9 4.7-3.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M149.4 339.6c-.2-.2-.4-.4-.7-.6s-.4-.4-.7-.6l-2.5 1.5c.1.3.1.6.2.9s.1.6.2.8l-1.1.7c-.1-.8-.3-1.5-.4-2.2-.1-.7-.2-1.3-.3-1.9-.1-.6-.2-1.2-.2-1.7-.1-.6-.1-1.1-.2-1.6l1-.6c.4.3.9.6 1.3 1s.9.7 1.4 1.1l1.5 1.2c.5.4 1.1.9 1.7 1.4l-1.2.6zm-4.6-3.8c0 .4.1.8.2 1.4s.2 1.1.3 1.7l2-1.1c-.5-.4-.9-.8-1.4-1.1-.4-.4-.8-.7-1.1-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m155.1 335.4.5 1-3.9 2-3.1-6.2 1.1-.6 2.6 5.2 2.8-1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m160.4 333 .4 1-4 1.8-2.8-6.3 1.1-.5 2.4 5.3 2.9-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M164.5 332.7c-.4.2-.8.2-1.2.2-.4 0-.7-.1-1-.2s-.6-.4-.8-.6c-.2-.3-.4-.6-.5-1l-1.5-4 1.2-.5 1.5 3.9c.1.3.2.5.4.7.1.2.3.3.5.4.2.1.4.1.5.1s.4 0 .6-.1c.2-.1.4-.2.5-.3s.3-.3.3-.5c.1-.2.1-.4.1-.6 0-.2-.1-.5-.2-.8l-1.5-3.9 1.2-.5 1.5 4c.1.4.2.7.2 1.1 0 .3 0 .7-.2 1-.1.3-.3.6-.6.8s-.5.7-1 .8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M168.4 323.9c1-.3 1.7-.4 2.3-.2.6.2 1 .6 1.3 1.4.3.9 0 1.6-.7 2.2.2.1.4.2.6.4.2.2.4.3.7.5s.5.4.7.6l.6.6-1.3.4-.6-.6c-.2-.2-.4-.4-.6-.5s-.4-.3-.6-.5c-.2-.1-.4-.3-.6-.4-.1 0-.2.1-.2.1-.1 0-.1 0-.2.1l-.6.2.8 2.5-1.2.4-2-6.5c.3-.2.6-.3.9-.4.1-.1.4-.2.7-.3zm.4 1c-.3.1-.5.2-.7.3l.7 2.1.5-.2c.3-.1.5-.2.8-.3.2-.1.4-.2.5-.3.1-.1.2-.3.2-.4 0-.2 0-.4-.1-.6-.1-.2-.2-.4-.3-.5-.1-.1-.3-.2-.4-.2h-.6c-.1 0-.4 0-.6.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M176.7 322.7c-.7.2-1.2.5-1.4 1s-.3 1.2-.1 1.9c.1.4.2.7.4 1s.3.5.6.7c.2.2.5.3.8.3.3.1.6 0 .9 0 .2-.1.4-.1.5-.2.2-.1.3-.1.4-.2l-.6-2.4 1.2-.3.8 3.2-.8.4c-.4.2-.8.3-1.4.4-.5.1-.9.1-1.4.1-.4-.1-.8-.2-1.2-.4-.4-.2-.7-.5-.9-.9-.3-.4-.5-.9-.6-1.4-.1-.6-.2-1.1-.1-1.6s.2-.9.4-1.3.5-.7.9-.9c.4-.2.8-.4 1.2-.5.3-.1.6-.1.8-.1h.7c.2 0 .3 0 .5.1.1 0 .2.1.3.1l-.1 1.1c-.2-.1-.5-.1-.8-.1-.3-.2-.6-.1-1 0z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m180.6 320.8 1.2-.2 1.2 6.8-1.2.2-1.2-6.8z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m185 327-1-6.9 4.4-.6.2 1.1-3.2.5.2 1.7 2.8-.4.2 1-2.8.4.3 2 3.4-.5.2 1.1-4.7.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M218.3 314.7c.1.3.2.6.3 1 .1.4.2.8.4 1.2.1.4.2.9.4 1.3l.3 1.2c.2-.3.4-.7.7-1.1.2-.4.5-.8.7-1.1.2-.4.5-.7.7-1.1.2-.3.4-.6.6-.8l1.1.2c0 .5 0 1.1-.1 1.6 0 .6-.1 1.2-.1 1.8 0 .6-.1 1.2-.2 1.8-.1.6-.1 1.2-.2 1.8l-1.2-.2c.1-.8.2-1.6.3-2.5.1-.8.2-1.7.2-2.5-.1.1-.2.3-.3.5-.1.2-.3.4-.4.6-.2.2-.3.5-.5.7s-.3.5-.5.7c-.1.2-.3.4-.4.6-.1.2-.2.4-.3.5l-.9-.1c0-.2-.1-.4-.2-.6s-.1-.5-.2-.7c-.1-.3-.1-.5-.2-.8-.1-.3-.1-.6-.2-.8-.1-.3-.1-.5-.2-.7-.1-.2-.1-.4-.2-.6-.2.8-.4 1.6-.5 2.4s-.3 1.7-.5 2.4l-1.2-.2c.1-.6.2-1.1.4-1.7.1-.6.3-1.2.4-1.8.1-.6.3-1.2.4-1.7.1-.6.3-1.1.4-1.5l1.2.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M229.1 323.7c0-.3-.1-.6-.1-.9 0-.3-.1-.6-.1-.9l-2.9-.6c-.2.3-.3.5-.5.7-.2.2-.3.5-.4.7l-1.3-.3c.4-.7.8-1.3 1.2-1.8s.7-1.1 1-1.6c.3-.5.7-1 1-1.4.3-.4.6-.9 1-1.3l1.2.3c.1.5.2 1.1.3 1.6.1.5.2 1.1.3 1.7.1.6.2 1.2.3 1.9.1.7.2 1.4.3 2.2l-1.3-.3zm-.8-5.9c-.2.3-.5.7-.8 1.2-.3.5-.6.9-.9 1.5l2.2.5-.3-1.8c0-.6-.1-1-.2-1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m237.5 318.8-.3 1-2-.6-1.6 5.6-1.2-.3 1.6-5.6-2-.6.3-1 5.2 1.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m236.9 325.8 2.2-6.6 4.2 1.4-.3 1-3-1-.5 1.6 2.7.9-.3 1-2.7-.9-.6 1.9 3.3 1.1-.3 1-4.7-1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M247.1 322.1c.9.4 1.6.8 1.9 1.4.4.5.4 1.2.1 1.9-.4.9-1 1.3-2 1.2.1.2.1.4.2.7.1.3.1.5.2.8.1.3.1.6.1.9 0 .3.1.6.1.9l-1.3-.5c0-.3-.1-.5-.1-.8 0-.3-.1-.6-.1-.8-.1-.3-.1-.5-.2-.8-.1-.2-.1-.5-.2-.7-.1 0-.2-.1-.2-.1-.1 0-.1 0-.2-.1l-.6-.2-1 2.4-1.2-.5 2.6-6.3c.3.1.6.1 1 .2s.7.3.9.4zm-.3 1c-.2-.1-.5-.2-.7-.3l-.8 2.1.5.2c.3.1.5.2.8.3.2.1.4.1.6.1.2 0 .3-.1.5-.2s.2-.3.3-.5c.1-.2.1-.4.1-.5 0-.2-.1-.3-.2-.5-.1-.1-.2-.3-.4-.4-.3-.1-.5-.2-.7-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m251.8 324.1 1.1.5-2.9 6.3-1.1-.5 2.9-6.3z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M256 333.8c0-.3.1-.6.1-.9s.1-.6.1-.9l-2.6-1.3-.6.6-.6.6-1.2-.6c.6-.5 1.1-1.1 1.6-1.5s1-.9 1.4-1.3c.5-.4.9-.8 1.3-1.1.4-.4.9-.7 1.3-1l1.1.5c0 .5 0 1.1-.1 1.7 0 .6-.1 1.1-.1 1.7s-.1 1.2-.2 1.9-.2 1.4-.3 2.2l-1.2-.6zm.7-6c-.3.2-.6.6-1.1.9-.4.4-.8.8-1.3 1.2l2.1 1c.1-.6.1-1.2.2-1.8 0-.4.1-.9.1-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m262.7 336.3-.5.9-3.8-2.2 3.4-6 1.1.6-2.9 5.1 2.7 1.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m264.2 338.6.6-3.6c.2-1.2.5-2.5.8-3.7l1.2.8c-.1.5-.2 1-.4 1.5s-.2 1-.4 1.5-.2 1-.3 1.4-.2.9-.2 1.3c.3-.2.7-.5 1.1-.8l1.2-.9 1.2-.9 1.2-.9 1.1.7c-1 .8-2 1.5-3 2.3l-3 2.1-1.1-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m268.6 341.5 4.1-5.6 3.6 2.6-.6.9-2.6-1.9-1 1.4 2.3 1.7-.6.8-2.3-1.7-1.2 1.6 2.8 2-.6.9-3.9-2.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M279.5 341c.8.6 1.2 1.3 1.4 1.9.2.6 0 1.2-.5 1.8-.6.7-1.4.9-2.3.6v.7c0 .3 0 .6-.1.9 0 .3-.1.6-.1.9-.1.3-.1.6-.2.9l-1.1-.9c.1-.3.1-.5.1-.8s.1-.6.1-.8c0-.3.1-.5.1-.8v-.7c-.1-.1-.1-.1-.2-.1s-.1-.1-.1-.1l-.5-.4-1.7 2-1-.8 4.4-5.3c.3.1.6.3.8.5.4.2.7.3.9.5zm-.6.9c-.2-.2-.4-.3-.6-.5l-1.4 1.7.4.4c.2.2.5.4.7.5s.4.2.6.2h.5c.2-.1.3-.2.5-.4.1-.2.2-.3.3-.5s0-.3 0-.5c-.1-.2-.2-.3-.3-.5-.4-.1-.5-.2-.7-.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M286.2 348.1c-.2.3-.4.7-.5 1-.2.4-.4.7-.5 1.1-.2.4-.3.7-.5 1.1-.2.4-.3.7-.5 1 .3-.2.7-.4 1-.6.4-.2.7-.5 1.1-.8.4-.3.8-.5 1.2-.8.4-.3.8-.6 1.2-.8l.9.9c-1 .7-2.1 1.4-3.1 2.1-1 .6-2 1.2-3 1.7l-.9-.8c.6-1.3 1.2-2.7 2-4.2-.7.4-1.4.8-2.1 1.1-.7.3-1.4.7-2 1l-.9-.8c.5-1 1-2 1.6-3.1.6-1 1.2-2.1 1.9-3.1l1 .9c-.3.4-.5.8-.8 1.2s-.5.8-.8 1.2c-.2.4-.5.8-.7 1.2-.2.4-.4.7-.6 1.1.3-.2.7-.3 1-.5.4-.2.7-.4 1.1-.6.4-.2.7-.4 1.1-.6.4-.2.7-.4 1-.6l.8.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m290.7 351.5.9.9-5.1 4.7-.9-.9 5.1-4.7z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m287.8 358.6 5.3-4.5 2.9 3.4-.8.7-2.1-2.4-1.3 1.1 1.8 2.2-.8.7-1.8-2.2-1.5 1.3 2.2 2.6-.8.7-3.1-3.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M298.5 362.2c-.4-.6-.9-.9-1.5-.9s-1.2.2-1.8.7c-.3.2-.5.5-.7.7-.2.3-.3.5-.4.8s-.1.6 0 .8c.1.3.2.6.4.8.1.2.3.3.4.4l.3.3 2-1.5.8 1-2.6 2c-.2-.1-.4-.3-.7-.6s-.6-.6-1-1.1c-.3-.4-.5-.8-.6-1.2-.1-.4-.2-.8-.1-1.3.1-.4.2-.8.5-1.2.3-.4.6-.8 1.1-1.1.5-.4.9-.6 1.4-.7.5-.1.9-.2 1.3-.1s.8.2 1.2.4c.4.2.7.5 1 .9.2.3.4.5.5.7l.3.6c.1.2.1.3.1.5v.3l-1 .3c0-.2-.1-.5-.2-.8-.4-.2-.5-.5-.7-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M297.4 371.2c-.3-.4-.4-.8-.5-1.1s-.1-.7 0-1c.1-.3.2-.6.4-.9.2-.3.5-.5.8-.7l3.6-2.4.7 1.1-3.5 2.4c-.3.2-.5.4-.6.5l-.3.6v.6c0 .2.1.4.3.5.1.2.3.3.4.4.2.1.3.2.5.2s.4 0 .6-.1c.2-.1.5-.2.7-.4l3.5-2.4.7 1.1-3.6 2.4c-.3.2-.7.4-1 .5-.3.1-.7.1-1 .1-.3 0-.6-.2-1-.4-.2-.3-.5-.6-.7-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M302.3 378.9c.2-.4.5-.8.7-1.3.2-.5.5-.9.7-1.4s.5-1 .7-1.4c.2-.5.4-.9.5-1.3l-4.3 2.4-.6-1.1 6-3.4.5.9c-.1.4-.3.8-.4 1.2-.2.5-.4.9-.6 1.4-.2.5-.4.9-.6 1.4s-.4.9-.6 1.2l4-2.3.6 1.1-6 3.4-.6-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M310.5 381.8c-.3-.6-.8-1-1.3-1.2-.6-.1-1.2 0-1.9.3l-.9.6c-.3.2-.4.5-.5.7-.1.3-.2.5-.2.8 0 .3.1.6.2.9.1.2.2.4.3.5.1.1.2.2.2.3l2.2-1.1.6 1.1-3 1.5c-.1-.1-.3-.4-.6-.7-.3-.3-.5-.7-.7-1.2-.2-.4-.4-.9-.4-1.3s0-.9.2-1.3c.1-.4.4-.8.7-1.1.3-.3.8-.6 1.3-.9.5-.3 1-.4 1.5-.4s.9 0 1.3.1.8.4 1.1.7c.3.3.6.7.8 1.1.1.3.2.6.3.8.1.2.1.5.2.6v.8l-1.1.1c0-.2 0-.5-.1-.8.1-.3 0-.6-.2-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M218.5 331.9c-.5-.1-.9-.2-1.2-.4s-.6-.4-.7-.7c-.2-.3-.3-.6-.4-.9-.1-.3-.1-.7 0-1.1l.7-4.3 1.3.2-.6 4.2c0 .3-.1.6 0 .8 0 .2.1.4.2.6.1.2.2.3.4.4.2.1.4.2.6.2h.6c.2 0 .4-.1.5-.2s.3-.3.4-.5c.1-.2.2-.5.2-.8l.6-4.2 1.3.2-.7 4.3c-.1.4-.2.8-.3 1.1-.2.3-.4.6-.6.8-.3.2-.6.4-.9.4-.5 0-.9 0-1.4-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M226.9 333.4c-.1-.4-.3-.9-.5-1.4l-.6-1.5-.6-1.5c-.2-.5-.4-.9-.6-1.3l-1 4.8-1.2-.3 1.5-6.8 1 .2c.2.3.4.7.6 1.2.2.4.4.9.7 1.4.2.5.4.9.6 1.4.2.5.4.9.5 1.3l1-4.5 1.2.3-1.5 6.8-1.1-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M235.7 332.2c-.2.6-.4 1-.7 1.4-.3.4-.7.6-1.1.8-.4.2-.9.3-1.4.3-.5 0-1-.1-1.6-.3l-.9-.3c-.3-.1-.6-.3-.9-.4l1.9-6.4c.3 0 .7.1 1 .2.4.1.7.2.9.2.6.2 1 .4 1.5.7s.8.6 1 1c.2.4.4.8.4 1.3.1.4.1.9-.1 1.5zm-5.1 1c.1 0 .2.1.3.1.1 0 .3.1.5.1.8.2 1.5.2 2-.1.5-.3.9-.8 1.1-1.6.2-.8.2-1.4-.1-1.9s-.8-.9-1.6-1.1c-.4-.1-.6-.2-.8-.2l-1.4 4.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m238.5 333.3 2.5.9-.4 1-2.5-.9.4-1z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M242.5 338.5c-.3-.1-.7-.3-1-.5-.3-.2-.6-.3-.8-.5l2.7-6.2c.1 0 .3.1.5.1s.3.1.5.2.3.1.5.2.3.1.4.2c.4.2.7.3 1 .5.3.2.5.4.7.7.2.2.3.5.3.8 0 .3 0 .6-.1.9-.1.3-.3.5-.5.7-.2.2-.5.2-.8.3.3.3.5.6.6.9.1.3 0 .7-.1 1.1-.3.7-.7 1-1.3 1.2-.8 0-1.6-.1-2.6-.6zm.5-3.2-.8 1.9c.1.1.3.1.4.2.1.1.3.1.4.2.2.1.5.2.7.2.2.1.4.1.6.1.2 0 .3-.1.5-.2s.3-.2.3-.4c.2-.4.1-.7-.1-.9-.2-.3-.5-.5-1-.7l-1-.4zm.4-1 .8.4c.4.2.8.3 1.1.3s.5-.2.7-.5c.1-.3.1-.6-.1-.8s-.5-.4-.9-.6c-.2-.1-.3-.1-.5-.2s-.3-.1-.4-.1l-.7 1.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m246.4 340.1 3.1-6.2 4 2-.5 1-2.9-1.4-.8 1.5 2.5 1.3-.5.9-2.5-1.3-.9 1.8 3.1 1.5-.5 1-4.1-2.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M256.5 337.4c.9.5 1.4 1 1.7 1.6.3.6.2 1.2-.1 1.9-.5.8-1.2 1.1-2.2 1 0 .2.1.4.1.7 0 .3.1.6.1.9v1.8l-1.2-.7V343c0-.3 0-.5-.1-.8 0-.2-.1-.5-.1-.7-.1 0-.2-.1-.2-.1-.1 0-.1-.1-.2-.1l-.5-.3-1.3 2.3-1.1-.6 3.4-5.9c.3.1.6.2.9.4.3-.1.6.1.8.2zm-.5 1c-.2-.1-.5-.2-.7-.3l-1.1 1.9.5.3c.3.2.5.3.7.4.2.1.4.1.6.1.2 0 .3 0 .5-.1.1-.1.3-.2.4-.4.1-.2.2-.4.2-.5 0-.2 0-.3-.1-.5s-.2-.3-.4-.4c-.1-.3-.3-.4-.6-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m256.8 345.6 3.7-5.8 3.7 2.4-.6.9-2.7-1.7-.9 1.4 2.4 1.5-.6.9-2.4-1.5-1.1 1.7 2.9 1.9-.6.9-3.8-2.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m265.5 343.1 1 .7-4 5.7-1-.7 4-5.7z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m272 347.7-.7.9-1.7-1.3-3.6 4.7-1-.8 3.6-4.7-1.7-1.3.7-.9 4.4 3.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M270.3 354.1c.3.3.6.5.9.5.3 0 .5-.1.7-.3.1-.1.2-.3.2-.4v-.4c0-.2-.1-.3-.2-.5l-.3-.6c-.1-.2-.2-.4-.3-.7-.1-.2-.2-.4-.2-.7v-.7c.1-.2.2-.5.4-.7.4-.5.9-.7 1.5-.7s1.1.3 1.7.7c.3.3.6.6.8.9.2.3.3.5.4.8l-1 .5c-.1-.2-.2-.5-.4-.7l-.6-.6c-.3-.2-.5-.3-.7-.4-.2 0-.4.1-.6.3-.1.1-.2.2-.2.4v.4c0 .1.1.3.2.4.1.2.2.3.3.5.2.3.3.6.4.8.1.3.2.5.2.8 0 .2 0 .5-.1.7-.1.2-.2.5-.4.7-.4.5-.9.7-1.5.7s-1.2-.3-1.8-.9l-.6-.6c-.2-.2-.3-.4-.4-.5-.1-.2-.2-.3-.3-.4-.1-.1-.1-.2-.1-.3l1-.5c.1.2.2.4.4.7 0 .3.2.5.6.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m280.6 355.4-.7.8-1.6-1.4-4 4.3-.9-.9 4-4.3-1.6-1.4.7-.8 4.1 3.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m276.5 361.1 5-4.8 3.1 3.2-.8.7-2.2-2.3-1.2 1.2 2 2-.8.7-2-2-1.5 1.4 2.4 2.5-.8.7-3.2-3.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m284 367.7-.8.7-2.9-3.3 5.3-4.5.8 1-4.4 3.8 2 2.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m287.2 371.8-.9.7-2.7-3.5 5.5-4.2.8 1-4.6 3.5 1.9 2.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M288.2 375.4c-.3-.4-.5-.8-.5-1.1-.1-.4-.1-.7 0-1 .1-.3.2-.6.4-.9.2-.3.5-.5.8-.8l3.6-2.5.7 1-3.5 2.4c-.3.2-.5.4-.6.6l-.3.6v.6c0 .2.1.4.3.5.1.2.3.3.4.4.2.1.3.2.5.2s.4 0 .6-.1c.2-.1.5-.2.7-.4l3.5-2.4.7 1-3.6 2.5c-.3.2-.7.4-1 .5-.3.1-.7.1-1 .1-.3 0-.7-.2-1-.4-.1-.1-.4-.4-.7-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M292.9 382.4c.2-.4.4-.8.7-1.3.2-.5.5-.9.7-1.4s.4-1 .6-1.4c.2-.5.4-.9.5-1.3l-4.3 2.5-.6-1.1 6-3.5.5.9c-.1.4-.2.8-.4 1.2-.2.5-.4.9-.6 1.4-.2.5-.4.9-.6 1.4-.2.5-.4.9-.6 1.3l4-2.4.6 1.1-6 3.5-.5-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M300.8 384.6c-.3-.6-.8-1-1.3-1.1-.6-.1-1.2 0-1.9.3-.3.2-.6.4-.8.6-.2.2-.4.5-.5.7-.1.3-.2.5-.2.8 0 .3.1.6.3.9.1.2.2.4.3.5.1.1.2.2.2.3l2.2-1.1.6 1.1-3 1.5c-.1-.1-.3-.3-.6-.7-.3-.3-.5-.7-.8-1.2-.2-.4-.4-.9-.4-1.3s0-.9.1-1.3.4-.8.7-1.1c.3-.3.7-.7 1.3-.9.5-.3 1-.4 1.5-.5.5 0 .9 0 1.3.1s.8.3 1.1.6c.3.3.6.6.8 1.1.1.3.3.5.3.8.1.2.1.5.2.6s.1.3.1.5v.3l-1.1.1c0-.2 0-.5-.1-.8 0-.2-.1-.5-.3-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M94.1 453.5c-.1-.7-.4-1.2-.9-1.5-.5-.3-1.1-.4-1.9-.2-.4.1-.7.2-1 .3-.3.1-.5.3-.7.5-.2.2-.3.5-.4.7-.1.3-.1.6 0 .9 0 .2.1.4.1.6 0 .2.1.3.1.4l2.5-.4.1 1.2-3.3.6-.4-.8c-.2-.4-.3-.9-.4-1.4-.1-.5-.1-1 0-1.4.1-.4.3-.8.5-1.2.3-.3.6-.6 1-.9.4-.2.9-.4 1.5-.5s1.1-.1 1.6 0 .9.3 1.2.5c.4.2.7.6.9.9.2.4.4.8.5 1.3.1.3.1.6.1.9v.7c0 .2-.1.3-.1.5 0 .1-.1.2-.1.3l-1.1-.2c.1-.2.1-.5.2-.8s0-.7 0-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m95.7 456.8.3 1.2-6.8 1.4-.3-1.2 6.8-1.4z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m89.5 461.3 6.7-1.7 1.1 4.3-1 .3-.8-3.1-1.7.4.7 2.8-1 .3-.7-2.8-2 .5.9 3.3-1 .3-1.2-4.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M92.5 468.4c.1.4.3.7.5.9.2.1.4.2.7.1.2-.1.3-.1.4-.2.1-.1.2-.2.2-.4s.1-.3.1-.5v-.7c0-.3 0-.5.1-.7 0-.2.1-.5.2-.7.1-.2.2-.4.4-.6.2-.2.4-.3.7-.4.6-.2 1.1-.1 1.6.2.5.3.8.8 1 1.5.1.4.2.8.2 1.1 0 .3 0 .6-.1.8l-1.1-.1c.1-.3.1-.5.1-.8 0-.3-.1-.5-.2-.8-.1-.3-.2-.6-.4-.7s-.4-.2-.6-.1c-.1 0-.3.1-.3.2-.1.1-.2.2-.2.3 0 .1-.1.3-.1.5v.6c0 .3 0 .7-.1.9 0 .3-.1.5-.2.7s-.3.4-.4.6c-.2.2-.4.3-.8.4-.6.2-1.1.1-1.6-.2-.5-.3-.8-.9-1.1-1.7-.1-.3-.1-.5-.2-.8 0-.2-.1-.4-.1-.6v-.5c0-.1 0-.3.1-.4h1.1c0 .2-.1.5-.1.8 0 .5 0 .9.2 1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M94.3 473.8c.2.4.3.7.5.9.2.1.5.2.7.1.2-.1.3-.1.4-.2s.2-.2.2-.4.1-.3.1-.5v-1.5c0-.3.1-.5.2-.7.1-.2.2-.4.4-.6.2-.2.4-.3.7-.4.6-.2 1.1-.2 1.6.1.5.3.8.8 1.1 1.5.1.4.2.8.3 1.1s0 .6 0 .9h-1.1c0-.3.1-.5 0-.8 0-.3-.1-.5-.2-.8-.1-.3-.3-.5-.5-.7-.2-.1-.4-.2-.7-.1-.1.1-.3.1-.3.2-.1.1-.1.2-.2.4 0 .1-.1.3-.1.5v1.5c0 .3-.1.5-.2.8-.1.2-.2.4-.4.6-.2.2-.4.3-.7.4-.6.2-1.1.2-1.6-.1-.5-.3-.9-.9-1.1-1.7-.1-.3-.2-.5-.2-.8 0-.2-.1-.4-.1-.6v-.9h1.1v.8c-.1.2-.1.6.1 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m94.8 477.9 6.4-2.7 1.7 4.1-1 .4-1.2-2.9-1.6.7 1.1 2.6-1 .4-1.1-2.6-1.9.8 1.3 3.2-1 .4-1.7-4.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M99.2 487.6c.2-.4.5-.8.8-1.2.3-.4.5-.9.8-1.4.3-.5.5-.9.8-1.4.2-.5.4-.9.6-1.3l-4.5 2.2-.5-1.1 6.2-3 .5.9c-.1.4-.3.8-.5 1.2-.2.4-.4.9-.7 1.4-.2.5-.5.9-.7 1.4-.2.4-.5.8-.7 1.2l4.1-2 .5 1.1-6.2 3-.5-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M279.6 512.6c.7-.7 1.4-1.1 2-1.2.6-.1 1.2.1 1.8.7.3.3.5.6.6.9s.1.6.1.9c-.1.3-.2.7-.4 1-.2.3-.5.7-.9 1l-.4.4 1.7 1.7-.9.9-4.8-4.8c.2-.3.4-.5.6-.8.2-.3.4-.5.6-.7zm.8.7c-.2.2-.4.4-.5.6l1.7 1.7.4-.4c.4-.4.7-.8.8-1.2.1-.3 0-.7-.3-1-.2-.2-.3-.3-.5-.3h-.5c-.2 0-.3.1-.5.2s-.4.2-.6.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M284.1 507.9c.7-.7 1.3-1.2 1.9-1.3.6-.1 1.2 0 1.8.5.7.6.9 1.4.5 2.3.2 0 .4 0 .7.1s.6.1.9.1.6.1.9.2c.3.1.6.1.9.2l-.9 1.1c-.3-.1-.5-.1-.8-.2-.3-.1-.6-.1-.8-.1-.3 0-.5-.1-.8-.1-.2 0-.5 0-.7-.1l-.2.2-.1.1-.4.5 2 1.7-1 .9-5.1-4.6c.2-.3.3-.5.6-.8.2-.3.4-.5.6-.7zm.8.6c-.2.2-.3.4-.5.6l1.7 1.5.4-.4c.2-.2.4-.4.5-.6l.3-.6v-.5c-.1-.2-.2-.3-.3-.5-.2-.1-.3-.2-.5-.3h-.5c-.2.1-.3.1-.5.3-.2.2-.4.3-.6.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m287.3 504.2.8-1 5.3 4.4-.8 1-5.3-4.4z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M290.2 500.5c.3 0 .6.1 1 .2s.8.1 1.3.2c.4.1.9.2 1.3.3.4.1.9.2 1.2.3-.2-.3-.4-.7-.6-1.1-.2-.4-.5-.8-.7-1.2-.2-.4-.4-.8-.6-1.1-.2-.4-.3-.7-.5-.9l.7-.9c.4.2.9.5 1.4.8l1.5.9c.5.3 1 .6 1.5 1 .5.3 1 .6 1.5 1l-.7 1c-.7-.5-1.4-.9-2.1-1.4-.7-.5-1.4-.9-2.1-1.3.1.2.2.3.3.5.1.2.2.4.4.7s.3.5.4.7.3.5.4.7c.1.2.3.5.4.7.1.2.2.4.3.5l-.6.8c-.2 0-.4-.1-.6-.1-.2-.1-.5-.1-.8-.2-.3-.1-.5-.1-.8-.2-.3-.1-.6-.1-.8-.2s-.5-.1-.8-.2c-.2 0-.4-.1-.6-.1.6.5 1.2 1.1 1.9 1.6s1.3 1 2 1.5l-.7 1c-.4-.4-.9-.7-1.4-1.1-.5-.4-.9-.8-1.4-1.2-.5-.4-.9-.8-1.3-1.2-.4-.4-.8-.7-1.2-1.1l.8-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M294.8 492.6c-.1.2-.2.3-.4.3s-.3 0-.5-.1-.3-.3-.3-.4c0-.2 0-.3.1-.5s.2-.3.4-.3c.2-.1.4 0 .5.1.2.1.3.3.3.4 0 .2 0 .3-.1.5zm1.1-1.8c-.1.2-.2.3-.4.3-.2.1-.4 0-.5-.1-.2-.1-.3-.3-.3-.4 0-.2 0-.3.1-.5s.2-.3.4-.3.4 0 .5.1c.2.1.3.3.3.4 0 .2 0 .4-.1.5zm7 3.2c-.3-.1-.6-.1-.8-.2-.3-.1-.6-.1-.9-.2l-1.6 2.5c.2.2.4.5.5.7.2.2.4.4.5.7l-.7 1.1c-.5-.6-.9-1.2-1.4-1.7l-1.2-1.5c-.4-.5-.7-1-1-1.4-.3-.5-.6-.9-.9-1.4l.6-1c.5.1 1.1.1 1.6.2s1.1.2 1.7.3c.6.1 1.2.2 1.9.4.7.1 1.4.3 2.1.5l-.4 1zm-5.8-1.2c.2.3.5.7.8 1.1s.7.9 1.1 1.4l1.2-1.9c-.6-.1-1.2-.2-1.7-.4-.6-.1-1-.1-1.4-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M299.2 486.3c.5-.9 1-1.5 1.5-1.8.6-.3 1.2-.3 1.9.1.8.4 1.2 1.1 1.1 2.1.2 0 .4-.1.7-.1.3 0 .6-.1.9-.1.3 0 .6-.1.9-.1h.9l-.6 1.3h-.8c-.3 0-.6 0-.8.1-.3 0-.5.1-.8.1-.2 0-.5.1-.7.1 0 .1-.1.2-.1.2 0 .1-.1.1-.1.2l-.3.5 2.3 1.2-.6 1.1-6.1-3.1.3-.9c.2-.4.3-.7.4-.9zm1 .4c-.1.2-.2.5-.3.7l2 1 .3-.5c.1-.3.3-.5.3-.7.1-.2.1-.4.1-.6 0-.2-.1-.3-.1-.5-.1-.1-.2-.3-.4-.4-.2-.1-.4-.1-.5-.1-.2 0-.3.1-.5.1-.1.1-.3.2-.4.4-.2.2-.4.4-.5.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M302.2 480.6c.3 0 .6-.1 1-.1s.8 0 1.3-.1h2.6l-.9-.9c-.3-.3-.6-.7-.9-1-.3-.3-.6-.7-.8-1-.3-.3-.5-.6-.7-.8l.4-1c.5.1 1 .3 1.6.5.5.2 1.1.4 1.7.6.6.2 1.1.4 1.7.6.6.2 1.1.4 1.7.6l-.5 1.1c-.8-.3-1.5-.6-2.3-.9-.8-.3-1.6-.6-2.3-.8.1.1.2.3.4.5s.3.4.5.6l.6.6.6.6c.2.2.4.4.5.6l.4.4-.4.9H304c.7.4 1.4.8 2.2 1.1.8.4 1.5.7 2.3 1.1l-.5 1.1c-.5-.2-1-.5-1.6-.8-.5-.3-1.1-.6-1.6-.8-.5-.3-1.1-.6-1.6-.8-.5-.3-1-.5-1.4-.8l.4-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m311.6 476-6.5-2.4 1.5-4.2 1 .4-1.1 3 1.6.6 1-2.7 1 .4-1 2.7 1.9.7 1.2-3.2 1 .4-1.6 4.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m308.5 463.2 1 .3-.6 2 5.6 1.7-.4 1.2-5.6-1.7-.6 2-1-.3 1.6-5.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M316.5 459.8c-.3 0-.6.1-.9.1-.3 0-.6.1-.9.1l-.7 2.8c.3.2.5.3.7.5.2.2.5.3.7.5l-.3 1.3c-.7-.4-1.3-.8-1.8-1.2-.6-.4-1.1-.7-1.6-1.1-.5-.3-1-.7-1.4-1-.4-.3-.9-.7-1.3-1l.3-1.2c.5-.1 1.1-.2 1.6-.3.5-.1 1.1-.2 1.7-.3.6-.1 1.2-.2 1.9-.3.7-.1 1.4-.2 2.2-.3l-.2 1.4zm-5.9.7c.3.2.7.5 1.1.8.4.3.9.6 1.5 1l.5-2.2c-.6.1-1.2.1-1.8.2-.5 0-.9.1-1.3.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m316.8 452.2 1.1.2-.8 4.3-6.8-1.2.2-1.2 5.7 1 .6-3.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m317.6 446.2 1.1.1-.5 4.3-6.9-.8.2-1.2 5.8.7.3-3.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M319.2 442c0 .5-.1.9-.3 1.2-.2.3-.4.6-.6.8-.3.2-.6.4-.9.4-.3.1-.7.1-1.1.1l-4.3-.3.1-1.3 4.2.3c.3 0 .6 0 .8-.1.2-.1.4-.1.6-.3.1-.1.3-.3.3-.4.1-.2.1-.4.1-.6 0-.2 0-.4-.1-.6-.1-.2-.1-.3-.3-.5-.1-.1-.3-.2-.5-.3-.2-.1-.5-.1-.8-.2l-4.2-.3.1-1.3 4.3.3c.4 0 .8.1 1.1.2.3.1.6.3.8.6.2.2.4.5.5.9.2.5.2.9.2 1.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M312.3 435.2c0-1 .2-1.8.6-2.3.4-.5.9-.8 1.7-.8.9 0 1.6.5 1.9 1.4.2-.1.3-.3.6-.4s.5-.3.7-.5.5-.3.8-.5c.3-.2.5-.3.8-.4v1.4c-.2.1-.5.3-.7.4s-.5.3-.7.4c-.2.1-.4.3-.7.4-.2.1-.4.3-.5.4v1h2.6v1.3h-6.8c-.1-.3-.1-.6-.1-1-.2-.3-.2-.6-.2-.8zm1-.1v.7h2.2v-1.3c0-.2-.1-.4-.2-.6-.1-.2-.2-.3-.3-.4-.1-.1-.3-.1-.6-.1-.2 0-.4 0-.5.1-.1.1-.3.2-.4.3-.1.2-.1.3-.2.5.1.3 0 .5 0 .8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M313 427.2c0 .7.3 1.2.8 1.6.5.4 1.1.5 1.9.5.4 0 .7-.1 1-.2.3-.1.6-.3.8-.4.2-.2.4-.4.5-.7.1-.3.2-.6.1-.9 0-.2 0-.4-.1-.6 0-.2-.1-.3-.1-.4l-2.5.1-.1-1.3 3.3-.2c.1.2.2.5.3.9.1.4.2.9.2 1.4 0 .5 0 1-.2 1.4-.1.4-.4.8-.6 1.1-.3.3-.7.5-1.1.7s-.9.3-1.5.3-1.1 0-1.6-.2-.8-.4-1.2-.7c-.3-.3-.6-.6-.8-1s-.3-.8-.3-1.3v-.9c0-.3.1-.5.1-.7 0-.2.1-.3.1-.5.1-.1.1-.2.1-.3l1 .3c-.1.2-.2.5-.3.8.2.6.2.9.2 1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m311.8 423.4-.1-1.2 6.9-.8.1 1.2-6.9.8z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m318.2 419.1-6.9 1-.7-4.4 1.1-.2.5 3.2 1.7-.3-.4-2.8 1-.2.4 2.8 2-.3-.5-3.4 1.1-.2.7 4.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M146.6 535.4c.4.2.7.3 1 .3.3 0 .5-.2.6-.4.1-.1.1-.3.1-.4s0-.3-.1-.4c-.1-.1-.2-.3-.3-.5-.1-.2-.3-.3-.4-.5-.2-.2-.3-.4-.5-.6s-.3-.4-.3-.6c-.1-.2-.1-.4-.1-.7s.1-.5.2-.7c.3-.5.7-.9 1.3-1s1.2 0 1.8.4c.4.2.7.4.9.7s.4.5.5.7l-.8.7c-.1-.2-.3-.4-.5-.6-.2-.2-.4-.4-.7-.5-.3-.2-.6-.2-.8-.2-.2 0-.4.2-.5.4-.1.1-.1.3-.1.4 0 .1 0 .3.1.4.1.1.1.3.2.4.1.1.2.3.3.4.2.3.4.5.6.7.2.2.3.5.4.7.1.2.1.5.1.7 0 .2-.1.5-.3.8-.3.5-.7.9-1.3.9-.6.1-1.2-.1-2-.5-.2-.1-.5-.3-.7-.4-.2-.1-.4-.3-.5-.4-.1-.1-.2-.3-.3-.4-.1-.1-.2-.2-.2-.3l.8-.7c.1.2.3.4.5.6.3.1.6.4 1 .6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m149.7 538.1 3.1-6.2 4 2-.5 1-2.8-1.4-.8 1.5 2.5 1.3-.5.9-2.5-1.3-.9 1.8 3.1 1.5-.5 1-4.2-2.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M158.9 542.4c-.1-.3-.1-.6-.2-1s-.2-.7-.3-1.1c-.1-.3-.3-.7-.4-1-.1-.3-.3-.6-.5-.9l-1.2 2.9-1.2-.5 2.7-6.4 1.2.5-1.1 2.6c.3-.1.6-.2.9-.4.3-.1.6-.3 1-.4.3-.1.6-.3.9-.4.3-.1.6-.3.8-.4l1.4.6c-.3.1-.6.3-1 .4-.3.2-.7.3-1 .5-.3.2-.7.3-1 .4-.4.1-.7.3-1 .4.2.3.3.6.5 1s.3.8.4 1.2l.3 1.2c.1.4.2.8.2 1.2l-1.4-.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M163.8 544.4c-.4-.2-.8-.4-1.1-.6-.3-.2-.5-.5-.6-.8-.1-.3-.2-.6-.2-1 0-.3.1-.7.2-1.1l1.5-4.1 1.2.4-1.4 4c-.1.3-.2.6-.2.8 0 .2 0 .4.1.6s.2.3.3.4.3.2.5.3c.2.1.4.1.6.1.2 0 .4 0 .5-.1.2-.1.3-.2.5-.4.1-.2.3-.4.4-.7l1.4-4 1.2.4-1.5 4.1c-.1.4-.3.7-.5 1-.2.3-.5.5-.8.6-.3.2-.6.2-1 .2-.2.1-.6 0-1.1-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M172.4 546.9c-.1-.4-.2-.9-.4-1.4s-.3-1-.5-1.5-.3-1-.5-1.5-.4-.9-.5-1.3l-1.4 4.8-1.2-.3 1.9-6.7 1 .3c.2.3.4.7.6 1.2.2.5.4.9.6 1.4.2.5.4 1 .5 1.4.2.5.3.9.4 1.3l1.3-4.4 1.2.3-1.9 6.7-1.1-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M181.7 545.6c-.1.6-.3 1.1-.6 1.5-.3.4-.6.7-1 .9s-.9.3-1.4.4c-.5 0-1 0-1.6-.1-.3-.1-.6-.1-.9-.2-.3-.1-.7-.2-1-.4l1.5-6.6c.3 0 .7 0 1 .1.4.1.7.1.9.2.6.1 1.1.3 1.5.6.4.2.8.5 1.1.9.3.4.5.8.5 1.3.1.2.1.8 0 1.4zm-5.1 1.3c.1 0 .2 0 .3.1.1 0 .3.1.5.1.8.2 1.5.1 2-.2.5-.3.8-.9 1-1.6.2-.8.1-1.4-.2-1.9-.3-.5-.9-.8-1.7-1-.4-.1-.6-.1-.8-.1l-1.1 4.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M186.6 549.9c0-.3-.1-.6-.2-.8s-.1-.6-.2-.9l-2.9-.5c-.1.3-.3.5-.4.8s-.3.5-.4.8l-1.3-.2c.4-.7.7-1.3 1.1-1.9.3-.6.6-1.1 1-1.6l.9-1.5c.3-.5.6-.9.9-1.4l1.2.2c.2.5.3 1.1.4 1.6s.3 1.1.4 1.7c.1.6.3 1.2.4 1.9.1.7.3 1.4.4 2.1l-1.3-.3zm-1.2-5.9c-.2.3-.4.7-.7 1.2l-.9 1.5 2.3.4c-.1-.6-.2-1.2-.3-1.7-.2-.6-.3-1-.4-1.4zm-.7-2.2c-.2 0-.3-.1-.4-.3-.1-.1-.2-.3-.1-.5 0-.2.1-.4.3-.5.2-.1.3-.1.5-.1s.3.1.4.3c.1.1.2.3.1.5 0 .2-.1.4-.3.5-.1.1-.3.1-.5.1zm2.1.3c-.2 0-.3-.1-.4-.3-.1-.1-.2-.3-.1-.5 0-.2.1-.4.3-.5.2-.1.3-.1.5-.1s.3.1.4.3.2.3.1.5c0 .2-.1.4-.3.5-.2.1-.4.2-.5.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M191.7 543.4c1 .1 1.7.4 2.2.8.5.4.7 1 .6 1.8-.1.9-.6 1.5-1.6 1.8.1.2.2.4.4.6.1.2.3.5.4.8.1.3.3.6.4.8.1.3.2.6.3.8l-1.4-.1c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.4-.8-.1-.2-.3-.5-.4-.7-.1-.2-.2-.4-.4-.6h-.4l-.6-.1-.3 2.6-1.3-.1.7-6.8h2.1zm-.1 1.1h-.7l-.2 2.2.5.1h.8c.2 0 .4 0 .6-.1.2-.1.3-.2.4-.3.1-.1.2-.3.2-.5s0-.4-.1-.5c-.1-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.2-.2-.2-.4-.3-.7-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M197.3 543.9c.1.3.3.6.5.9.2.4.3.8.5 1.2.2.4.3.8.5 1.2s.3.8.5 1.2c.2-.3.3-.7.5-1.1l.6-1.2c.2-.4.4-.8.6-1.1.2-.4.4-.7.5-.9h1.1c0 .5.1 1 .1 1.6 0 .6.1 1.2.1 1.8 0 .6.1 1.2.1 1.8v1.8h-1.2v-2.5c0-.9 0-1.7-.1-2.5-.1.2-.2.3-.3.5-.1.2-.2.4-.3.7-.1.2-.2.5-.4.8-.1.3-.2.5-.4.8-.1.2-.2.5-.3.7-.1.2-.2.4-.3.5h-.9c-.1-.2-.1-.3-.2-.6-.1-.2-.2-.5-.3-.7-.1-.3-.2-.5-.3-.8s-.2-.5-.3-.8c-.1-.2-.2-.5-.3-.7-.1-.2-.2-.4-.2-.6-.1.8-.2 1.6-.2 2.5-.1.9-.1 1.7-.2 2.5h-1.2c0-.6.1-1.2.1-1.8s.1-1.2.2-1.8c.1-.6.1-1.2.2-1.8.1-.6.1-1.1.2-1.6h1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m204.5 551-.2-6.9 4.5-.1v1.1l-3.2.1.1 1.7 2.8-.1v1l-2.8.1.1 2 3.4-.1v1.1l-4.7.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m214.7 543.4.1 1.1-2.1.2.5 5.8-1.3.1-.5-5.8-2.1.2-.1-1.1 5.5-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M220.3 549.7c-.1-.3-.3-.5-.4-.8s-.3-.5-.4-.8l-2.9.4c-.1.3-.1.6-.2.9-.1.3-.1.6-.2.8l-1.3.2c.2-.8.3-1.5.5-2.1.1-.7.3-1.3.4-1.9.1-.6.3-1.1.4-1.7.2-.5.3-1.1.5-1.6l1.2-.2c.3.5.6.9.9 1.4l.9 1.5c.3.5.6 1.1.9 1.7.3.6.7 1.2 1 1.9l-1.3.3zm-2.8-5.3c-.1.4-.2.8-.3 1.3-.1.5-.3 1.1-.4 1.7l2.3-.3c-.3-.6-.6-1.1-.8-1.6-.4-.4-.6-.8-.8-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m226.9 547.4.2 1.1-4.3.8-1.3-6.8 1.2-.2 1.1 5.7 3.1-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m232.2 546.1.3 1.1-4.3 1-1.6-6.7 1.2-.3 1.4 5.7 3-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M236.1 546.3c-.5.1-.9.2-1.2.2-.4 0-.7-.1-1-.3-.3-.2-.5-.4-.7-.7s-.4-.6-.5-1l-1.2-4.1 1.2-.4 1.2 4c.1.3.2.5.3.7.1.2.3.3.4.4.2.1.3.2.5.2s.4 0 .6-.1c.2-.1.4-.2.5-.3l.4-.4c.1-.2.1-.4.1-.6 0-.2 0-.5-.1-.8l-1.2-4 1.2-.4 1.2 4.1c.1.4.2.8.2 1.1 0 .4-.1.7-.2 1-.1.3-.4.6-.7.8-.1.2-.5.4-1 .6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M239.7 537.6c.9-.3 1.7-.4 2.3-.2.6.2 1.1.6 1.3 1.3.3.9.1 1.6-.7 2.3.2.1.4.2.6.4.2.2.5.3.7.5.2.2.5.4.7.6.2.2.5.4.7.6l-1.3.5c-.2-.2-.4-.4-.6-.5s-.4-.4-.7-.5c-.2-.2-.4-.3-.6-.5-.2-.1-.4-.3-.6-.4-.1 0-.2.1-.2.1s-.1 0-.2.1l-.6.2.9 2.5-1.2.4-2.3-6.4c.3-.2.6-.3.9-.5.3-.3.6-.4.9-.5zm.4 1c-.3.1-.5.2-.7.3l.7 2.1.5-.2c.3-.1.5-.2.7-.3.2-.1.4-.2.5-.4.1-.1.2-.3.2-.4 0-.2 0-.4-.1-.6-.1-.2-.2-.4-.3-.5-.1-.1-.3-.2-.4-.2h-.6s-.2.1-.5.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M246.8 535.8c-.7.3-1.1.7-1.2 1.3-.2.6-.1 1.2.2 1.9.1.3.3.6.5.9.2.2.4.4.7.6.3.1.5.2.8.2.3 0 .6-.1.9-.2.2-.1.4-.2.5-.3.1-.1.2-.1.3-.2l-1-2.3 1.2-.5 1.3 3.1c-.1.1-.4.3-.7.6-.3.2-.8.5-1.3.7-.5.2-.9.3-1.4.3-.4 0-.9-.1-1.2-.2-.4-.2-.7-.4-1.1-.8-.3-.3-.6-.8-.8-1.3s-.4-1-.4-1.5.1-.9.2-1.3c.2-.4.4-.8.7-1.1.3-.3.7-.6 1.1-.7.3-.1.6-.2.8-.3.2-.1.5-.1.7-.1h.8l.1 1.1h-.8c-.3 0-.6 0-.9.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m249.6 533.6 1.1-.5 3 6.2-1.1.5-3-6.2z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m255.4 538.4-3.2-6.1 3.9-2.1.5.9-2.8 1.5.8 1.5 2.5-1.3.5.9-2.5 1.3.9 1.8 3-1.6.5.9-4.1 2.3z"
        className="st3"
      />
    </g>
    <defs>
      <path id="SVGID_9_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_10_">
      <use
        xlinkHref="#SVGID_9_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_10_)",
      }}
    >
      <path
        d="M155.6 505.7c21.1 14.8 46.9 18.8 73.1 10.1 8-2.7 15.5-6.5 22.4-11.4"
        className="st14"
      />
      <path d="m157.2 513.2-1.6-7.5 7.6-1" className="st14" />
    </g>
    <defs>
      <path id="SVGID_11_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_12_">
      <use
        xlinkHref="#SVGID_11_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_12_)",
      }}
    >
      <path
        d="M119.8 412.1c-4.9 16.1-4.6 32 1.1 49.1 5.5 16.6 16 31.1 30.1 41.5"
        className="st14"
      />
      <path d="m113.1 416 6.7-3.9 3.3 6.9" className="st14" />
    </g>
    <defs>
      <path id="SVGID_13_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_14_">
      <use
        xlinkHref="#SVGID_13_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_14_)",
      }}
    >
      <path
        d="M199.1 349.8c-7.8.2-15.5 1.6-22.8 4.2-25.3 8.3-45.3 27.8-54.2 52.8"
        className="st14"
      />
      <path d="m193.3 344.7 5.8 5.1-5.5 5.3" className="st14" />
    </g>
    <defs>
      <path id="SVGID_15_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_16_">
      <use
        xlinkHref="#SVGID_15_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_16_)",
      }}
    >
      <path
        d="M282.2 405.6c-2.6-7.4-6.3-14.4-11-20.6-16.3-22.5-40-34.8-65.5-35.5"
        className="st14"
      />
      <path
        d="m285.3 398.6-3.1 7-6.7-3.6M205.9 343.9l-.3 11.2"
        className="st14"
      />
    </g>
    <defs>
      <path id="SVGID_17_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_18_">
      <use
        xlinkHref="#SVGID_17_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_18_)",
      }}
    >
      <path
        d="M254.9 501.4c6.2-4.7 11.6-10.4 16.1-16.8 15.6-21.4 20.4-48.7 13-74.1"
        className="st14"
      />
      <path d="m262.5 502.2-7.6-.8 1.3-7.5" className="st14" />
    </g>
    <defs>
      <path id="SVGID_19_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_20_">
      <use
        xlinkHref="#SVGID_19_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_20_)",
      }}
    >
      <path
        d="M245.1 294.9c0 9.4-7.6 17-17 17h-.3c-9.4-.2-16.9-7.9-16.7-17.3.2-9.4 7.9-16.9 17.3-16.7 9.3.2 16.7 7.8 16.7 17"
        className="st5"
      />
      <path
        d="M243.4 302.2c-2.8 5.9-8.8 9.7-15.4 9.7h-.3L216.9 301h1.4l2.9 2.9H235l2.9-2.9h1.5v-2.9l4 4.1z"
        className="st8"
      />
    </g>
    <path
      d="M228.1 281.4h-1.4v4h2.8v-4zM216.9 298.1h22.4v2.9h-22.4z"
      className="st3"
    />
    <path d="m237.9 301-2.9 2.9h-13.9l-2.9-2.9z" className="st6" />
    <defs>
      <path id="SVGID_21_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_22_">
      <use
        xlinkHref="#SVGID_21_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_22_)",
      }}
    >
      <path
        d="M228.7 287.2c0 .3-.2.6-.6.6-.3 0-.6-.2-.6-.6s.2-.6.6-.6c.3 0 .6.3.6.6M228.7 289.5c0 .3-.2.6-.6.6-.3 0-.6-.2-.6-.6s.2-.6.6-.6c.3 0 .6.3.6.6M228.7 291.8c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6M228.7 294.1c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6M228.7 296.4c0 .3-.3.6-.6.6s-.6-.3-.6-.6.3-.6.6-.6.6.3.6.6M223.6 289.3c-.2.3-.5.4-.8.2s-.4-.5-.2-.8c0 0 0-.1.1-.1.2-.3.5-.3.8-.1.2.2.3.5.1.8M224.9 287.4c-.2.3-.5.3-.8.1-.3-.2-.3-.5-.1-.8s.5-.3.8-.1c.2.2.3.6.1.8M222.2 291.2c-.2.3-.5.3-.8.1-.3-.2-.3-.5-.1-.8.2-.3.5-.3.8-.1.3.2.3.5.1.8M220.9 293c-.2.3-.5.3-.8.1-.3-.2-.3-.5-.1-.8.2-.3.5-.3.8-.1.2.2.3.5.1.8M219.6 294.9c-.2.3-.5.3-.8.1-.3-.2-.3-.5-.1-.8.2-.3.5-.3.8-.1.2.2.3.6.1.8M218.2 296.8c-.2.3-.5.3-.8.1-.3-.2-.3-.5-.1-.8.2-.3.5-.3.8-.1.3.2.3.6.1.8M232.9 289.3c.2.2.6.2.8 0 .2-.2.2-.5.1-.7-.2-.3-.5-.3-.8-.1-.3.2-.3.5-.1.8M231.5 287.4c.2.3.5.3.8.1.3-.2.3-.5.1-.8s-.5-.3-.8-.1c-.2.2-.3.6-.1.8M234.2 291.2c.2.3.5.3.8.1.3-.2.3-.5.1-.8-.2-.3-.5-.3-.8-.1-.2.2-.3.5-.1.8M235.5 293c.2.3.5.3.8.1.3-.2.3-.5.1-.8-.2-.3-.5-.3-.8-.1-.2.2-.3.5-.1.8M236.9 294.9c.2.3.5.3.8.1.3-.2.3-.5.1-.8-.2-.3-.5-.3-.8-.1-.2.2-.3.6-.1.8M238.2 296.8c.2.3.5.3.8.1.3-.2.3-.5.1-.8-.2-.3-.5-.3-.8-.1-.2.2-.3.6-.1.8"
        className="st3"
      />
      <path
        d="M91.3 492.7c0 9.4-7.6 17-17 17s-17-7.6-17-17 7.6-17 17-17 17 7.6 17 17"
        className="st5"
      />
      <path
        d="M90.1 499c-1.7 4.2-5 7.6-9.3 9.4l-.6.2-.6.2c-.2.1-.4.1-.6.2l-.3.1-10.5-10.4 12.7.1 1-7.7 8.2 7.9z"
        className="st8"
      />
    </g>
    <path
      d="M75.1 500.9H79v3.4h-3.9zM69.5 497.4l-.6-4.3h11.5l-.5 4.3z"
      className="st6"
    />
    <path d="M76.4 496.2V491h1.3v5.2l-.6.5z" className="st3" />
    <path d="M66.4 481.8h12.8v6.4H66.4z" className="st6" />
    <path d="M80.6 479.6h-1.3v8.6H66.4v-8.6h-1.3v9.9h15.5z" className="st3" />
    <defs>
      <path id="SVGID_23_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_24_">
      <use
        xlinkHref="#SVGID_23_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M73.1 486.1v9h.7v-9h-.7m-1.2 0v9h.7v-9h-.7"
      className="st3"
      style={{
        clipPath: "url(#SVGID_24_)",
      }}
    />
    <path d="M72.6 486.1h.6v9h-.6z" className="st6" />
    <defs>
      <path id="SVGID_25_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_26_">
      <use
        xlinkHref="#SVGID_25_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_26_)",
      }}
    >
      <path
        d="M76.2 500.3V497.4H78V500.3h-1.8zM79.1 509l-.4.1h-.2l-.4.1-.6.1-.4.1H77l-.4.1c-.5-1.8-.7-3.6-.8-5.5v-3.2h2.6v3.1c.1 1.7.3 3.4.7 5.1M79.2 505c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M75.6 505c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M79.3 506c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M75.7 506c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M79.4 507c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M75.8 507c0 .1-.1.3-.2.3s-.3-.1-.3-.2.1-.3.2-.3c.2 0 .3.1.3.2M79.6 508c0 .1-.1.2-.2.2s-.2-.1-.2-.2.1-.2.2-.2.2.1.2.2M76 508c0 .1-.1.3-.3.2-.1 0-.2-.1-.2-.2s.1-.2.2-.2c.2-.1.3.1.3.2M76.2 509c0 .1-.1.3-.3.3-.1 0-.2-.2-.2-.3 0-.1.1-.2.2-.2.2-.1.3.1.3.2"
        className="st3"
      />
    </g>
    <path
      d="m82 491-.9 7.7H68.3l-1-7.7h1.4l.8 6.4h10.3l.9-6.4z"
      className="st3"
    />
    <defs>
      <path id="SVGID_27_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_28_">
      <use
        xlinkHref="#SVGID_27_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_28_)",
      }}
    >
      <path
        d="m78.6 509.2-.4.1-.6.1-.4.1c-.4-1.8-.7-3.6-.8-5.5v-3.2h1.4v3.1c.1 1.8.3 3.6.8 5.3"
        className="st6"
      />
      <path d="M77.3 500.9h-.6v-3.5h.6v3.5" className="st6" />
      <path
        d="M177.5 568v1c-.5 8.8-7.8 15.7-16.6 15.9H159l-.6-.1h-.3c-.4 0-.8-.1-1.1-.2s-.8-.2-1.2-.3c-9-2.6-14.2-12.1-11.5-21.1 2.6-9 12.1-14.2 21.1-11.5 6.7 2 11.5 7.9 12.1 14.9v1.4"
        className="st5"
      />
    </g>
    <path
      d="M168.5 559.8v18.9H152v-18.9h1.3v17.5h13.9v-17.5z"
      className="st3"
    />
    <path
      d="M157.5 553.8h1.4V567h-1.4zM159.6 553.8h1.4V567h-1.4zM161.7 553.8h1.4V567h-1.4zM153.3 568.6h13.9v8.7h-13.9z"
      className="st6"
    />
    <defs>
      <path id="SVGID_29_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_30_">
      <use
        xlinkHref="#SVGID_29_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_30_)",
      }}
    >
      <path
        d="M177.5 568.8v.2c-.5 8.8-7.7 15.7-16.6 15.9H159l-.6-.1h-.3l-6.1-6.2h16.6v-18.8l8.9 9z"
        className="st8"
      />
      <path
        d="M218.5 576.2c0 .6 0 1.3-.1 1.9-.2 1.4-.5 2.8-1 4.2l-.3.7-.3.6c-.1.2-.2.5-.3.7-4.5 8.3-14.8 11.3-23 6.9-8.3-4.5-11.3-14.8-6.9-23 2.7-5 7.7-8.3 13.3-8.8h2.6c9.1.4 16 7.9 16 16.8"
        className="st5"
      />
      <path
        d="M218.4 578.1c-.1 1.2-.4 2.4-.8 3.5-.1.2-.2.5-.2.7-.1.2-.1.4-.2.6v.1l-.3.6c-.1.2-.2.5-.4.7-3.5 6.6-11 10.1-18.4 8.6l-5.9-6h18.4v-16.6l7.8 7.8z"
        className="st8"
      />
    </g>
    <path d="M193.6 576.7h15.8v8.8h-15.8z" className="st6" />
    <path
      d="m210.7 570.2-4.7-4.7-.9 1 4.3 4.3v14.7h-15.8v-14.7l4.3-4.3-1-1-4.7 4.7v16.7h18.5v-16.7z"
      className="st3"
    />
    <defs>
      <path id="SVGID_31_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_32_">
      <use
        xlinkHref="#SVGID_31_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_32_)",
      }}
    >
      <path
        d="M200.5 559.2h-.4V575h.7v-15.8h-.3m1.9 0h-.4V575h.7v-15.8h-.3M206.6 582.8v.7h10.2c.1-.2.2-.4.2-.6v-.1h-10.4zm0-1.2v.7h10.7c.1-.2.2-.5.2-.7h-10.9z"
        className="st3"
      />
      <path d="M217.4 582.3c-.1.2-.1.4-.2.6h-10.5v-.6h10.7z" className="st6" />
      <path
        d="M258.5 568.4c0 1.9-.3 3.8-1 5.7 0 .1 0 .1-.1.2-.1.2-.1.3-.2.5 0 .1 0 .1-.1.2 0 .1-.1.3-.2.4 0 0-.1.1-.1.2-.1.2-.2.3-.2.5l-.1.2c-4.2 8.1-14.3 11.3-22.4 7-8.1-4.2-11.3-14.3-7-22.4 2.6-4.9 7.4-8.2 12.9-8.8l.6-.1H242.4c8.6.3 15.5 7.2 15.9 15.8.2.1.2.4.2.6"
        className="st5"
      />
      <path
        d="M258.5 568.4c0 1.9-.3 3.8-1 5.7 0 .1 0 .1-.1.2-.1.2-.1.3-.2.5 0 .1 0 .1-.1.2 0 .1-.1.3-.2.4 0 0-.1.1-.1.2-.1.2-.2.3-.2.5l-.1.2c-2.9 5.5-8.5 8.9-14.7 8.9-1.1 0-2.3-.1-3.4-.3l-6.3-6.3h18.5v-13.7h7.4c.2 1 .4 2 .4 3 0 0 0 .3.1.5"
        className="st8"
      />
    </g>
    <path d="M237.7 565.8h7.5v5.5h-7.5z" className="st6" />
    <path d="M246.5 563.3v9.4h-10.1v-9.4h1.3v8h7.5v-8z" className="st3" />
    <defs>
      <path id="SVGID_33_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_34_">
      <use
        xlinkHref="#SVGID_33_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M242.3 574.1v-4.6h-.7v5.3h15.6l.2-.5v-.2h-15.1zm-1.2 1.2v-5.8h-.6v6.6h16.2c.1-.2.2-.3.2-.5l.1-.2-15.9-.1z"
      className="st3"
      style={{
        clipPath: "url(#SVGID_34_)",
      }}
    />
    <path
      d="M250.7 559.6v-2.5h-5.5v1.3h4.2v2.5h8.6v2.4h-8.6V577h-15.9v-18.6h4.2v-1.3h-5.5v21.3h18.5v-13.8h8.6v-5z"
      className="st3"
    />
    <defs>
      <path id="SVGID_35_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_36_">
      <use
        xlinkHref="#SVGID_35_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_36_)",
      }}
    >
      <path
        d="m257.2 574.7-.1.2-.2.4H241v-5.8h.6v5.3l15.6-.1z"
        className="st6"
      />
      <path
        d="M240.1 551.9v10.2h.6v-10.2h-.6m1.8-.1V562h.6v-10.2h-.6"
        className="st3"
      />
      <path
        d="M358.4 466.2c0 9.4-7.6 17-17 17-1.3 0-2.7-.2-4-.5-9.1-2.2-14.7-11.4-12.5-20.5 2.2-9.1 11.4-14.7 20.5-12.5 6.8 1.7 11.9 7.4 12.8 14.4.2.7.2 1.4.2 2.1"
        className="st5"
      />
    </g>
    <path
      d="M336.9 460.2h8.5V472h-8.5zM334.5 472h1v-13.5l-1-.5zM346.8 457.2h.9V472h-.9z"
      className="st6"
    />
    <defs>
      <path id="SVGID_37_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_38_">
      <use
        xlinkHref="#SVGID_37_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M358.4 466.2c0 9.4-7.6 17-17 17-1.2 0-2.3-.1-3.5-.4l-6-6h18.4V456l7.9 7.9c.1.8.1 1.6.2 2.3"
      className="st8"
      style={{
        clipPath: "url(#SVGID_38_)",
      }}
    />
    <path
      d="M334.5 472h13.2v2.4h-13.2zM345 456.1v3h-7.8v-1.6l-5.3-3.1V453l5.3 3.1z"
      className="st3"
    />
    <defs>
      <path id="SVGID_39_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_40_">
      <use
        xlinkHref="#SVGID_39_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_40_)",
      }}
    >
      <path
        d="M349 475.5h-15.7v-18.3l2.2 1.3v14.8h11.3v-16.1h2.3v18.3zm-3.6-19.4V469c0 1.7-1.3 3-3 3h-2.5c-1.7 0-3-1.3-3-3v-11.3l-4.9-2.8v22h18.4v-20.8h-5z"
        className="st3"
      />
      <path
        d="M341.4 503.2V504.6l-.3 2.1c-1.6 7.9-8.6 13.6-16.7 13.6-1.2 0-2.4-.1-3.6-.4l-1.2-.3c-1.2-.3-2.3-.8-3.3-1.4-8.2-4.5-11.3-14.8-6.8-23.1 4.5-8.2 14.8-11.3 23.1-6.8 5.4 3 8.8 8.7 8.8 14.9"
        className="st5"
      />
      <path
        d="M341.1 506.1c0 .2-.1.4-.1.5-1.6 7.9-8.6 13.6-16.7 13.6-1.2 0-2.4-.1-3.6-.4l-7.5-7.5v-.1l18.4.1V509h2.1v3.1h1.9V509h2.5v-5.9l3 3z"
        className="st8"
      />
    </g>
    <path
      d="M338.2 503.1v5.9h-2.5v3.3h-.7v-4.6h1.8v-3.2h-6.4v-6.7l-4.2-.8v-1.4l5.5 1.1v6.4z"
      className="st3"
    />
    <defs>
      <path id="SVGID_41_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_42_">
      <use
        xlinkHref="#SVGID_41_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M334.5 507.7v4.6h-.7V509h-2.1v3.3c-6 1.9-12.4 1.9-18.4 0v-15.6l5.6-1.1v1.4l-4.2.8v13.4c2.6.7 5.2 1 7.9 1 2.6 0 5.3-.3 7.8-1v-3.5h4.1z"
      className="st3"
      style={{
        clipPath: "url(#SVGID_42_)",
      }}
    />
    <path
      d="M319.7 489h1.4v15.5h-1.4zM321.8 489h1.4v15.5h-1.4zM324 489h1.4v15.5H324z"
      className="st6"
    />
    <path d="M334.5 507.7h.6v1.4h-.6z" className="st3" />
    <path d="M334.5 507.5h.6v4.8h-.6z" className="st6" />
    <defs>
      <path id="SVGID_43_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_44_">
      <use
        xlinkHref="#SVGID_43_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_44_)",
      }}
    >
      <path
        d="M330.4 507.6v3.5c-2.6.7-5.2 1-7.8 1-2.7 0-5.3-.3-7.9-1v-5h22.1v1.5h-6.4z"
        className="st6"
      />
      <path
        d="M79.5 455.2c0 9.4-7.6 17-17 17-1.8 0-3.6-.3-5.3-.9-8.9-2.9-13.8-12.5-10.9-21.5 1.6-4.9 5.3-8.8 10.1-10.6.4-.2.9-.3 1.3-.5 2.9-.8 6-.9 9-.1.5.1.9.3 1.3.4 6.3 2.2 10.8 8 11.3 14.7.2.6.3 1.1.2 1.5"
        className="st5"
      />
      <path
        d="M79.5 455.2c0 9.4-7.6 17-17 17-1.8 0-3.6-.3-5.3-.9l-6.1-6.1h22.4V448h.1l5.9 5.9v1.3"
        className="st8"
      />
      <path
        d="M61.6 445.2v1.4h-5.2v-7.2c.4-.2.9-.3 1.3-.5v6.4h3.9zM68.2 439.2v7.4H63v-1.4h3.8v-6.5c.5.2 1 .3 1.4.5"
        className="st3"
      />
    </g>
    <path
      d="M72.2 448v13.2h-1.4v2.7h-17v-2.7h-1.4V448h-1.3v17.2h22.4V448z"
      className="st3"
    />
    <path
      d="M61.6 462.5V448h-1.3v13.2h-2.5V448h-1.3v13.2h-1.4v1.3zM69.5 462.5v-1.3h-1.4V448h-1.3v13.2h-2.5V448H63v14.5z"
      className="st3"
    />
    <path
      d="M72.2 452.4h-4.1v8.8h1.4v1.3H63v-17.3h3.8v-2.5h-9v2.5h3.8v17.3h-6.5v-1.3h1.4v-8.8h-4.1v8.8h1.4v2.7h17v-2.7h1.4z"
      className="st6"
    />
    <defs>
      <path id="SVGID_45_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_46_">
      <use
        xlinkHref="#SVGID_45_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_46_)",
      }}
    >
    <a href="/auftragsabrechnung">
        <path
        d="M391.7 115.5 353.8 24c-48.1 20.6-83 55.5-103.6 103.6l91.4 37.9c10-22.2 27.8-40 50.1-50"
        className="st12"
        />
      </a>
      <a href="/controlling">
      <path
        d="M339.5 170.8 248 132.9c-19.4 48.6-19.4 97.9 0 146.5l91.4-37.9c-8.7-22.7-8.7-47.9.1-70.7"
        className="st12"
        />
        </a>
        <a href="/prozessautomatisierung">
        <path
            d="M391.6 297c-22.3-10-40.1-27.9-50-50.1l-91.4 37.8c3.7 8.5 7.9 16.8 12.7 24.7 28.5 13.7 51.5 36.9 65 65.5 8.3 5.1 17 9.5 26 13.4l37.7-91.3"
            className="st12"
            />
        </a>
        <a href="/schmelzplanung">
        <path
            d="M396.9 299.1 359 390.5c48.6 19.4 97.9 19.4 146.5 0l-37.8-91.2c-22.8 8.6-48 8.6-70.8-.2"
            className="st12"
            />
        </a>
      <a href="/materialwirtschaft">
        <path
          d="M603.6 306.3c4-7 7.6-14.2 10.8-21.7l-91.2-37.8c-10 22.3-27.9 40.1-50.2 50.1l37.8 91.3c7.5-3.2 14.8-6.9 21.8-10.9 13.9-31.7 39.3-57 71-71"
          className="st12"
        />
      </a>
      <a href="/rohstoffoptimierung">
        <path
          d="m616.6 132.9-91.3 37.8c8.7 22.8 8.7 48.1 0 70.9l91.2 37.8c19.5-48.6 19.5-97.9.1-146.5"
          className="st12"
        />
      </a>
      <a href="/produktionsplanung">
      <path
        d="M614.4 127.7c-20.6-48.1-55.5-83-103.6-103.6L473 115.4c22.3 10 40.1 27.8 50.2 50.1l91.2-37.8z"
        className="st12"
        />
       </a>
       <a href="/administration">
        <path
        d="M467.7 113.2l37.8-91.4c-48.6-19.4-97.9-19.4-146.5 0l37.9 91.4c22.8-8.6 48-8.6 70.8 0"
        className="st12"
        />
        </a>
    </g>
    <g className="st2">
      <path
        d="M298.3 110.4c.6-.8 1.2-1.3 1.8-1.5.6-.2 1.2-.1 1.8.3.8.6 1 1.3.7 2.2h1.6c.3 0 .6 0 .9.1.3 0 .6.1.9.1l-.8 1.1c-.3 0-.5-.1-.8-.1-.3 0-.6 0-.8-.1h-1.5c0 .1-.1.1-.1.2s-.1.1-.1.2l-.4.5 2.1 1.5-.7 1-5.5-4c.1-.3.3-.6.5-.9 0-.1.2-.4.4-.6zm.9.6c-.2.2-.3.4-.4.6l1.8 1.3.3-.4c.2-.2.3-.5.4-.7.1-.2.2-.4.2-.6 0-.2 0-.3-.1-.5s-.2-.3-.4-.4c-.2-.1-.3-.2-.5-.2s-.3 0-.5.1-.3.2-.5.3c0 .1-.1.3-.3.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m306.8 110.7-5.5-4.3 2.7-3.5.8.7-2 2.5 1.3 1.1 1.7-2.2.8.6-1.7 2.2 1.6 1.2 2.1-2.7.8.7-2.6 3.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M306.4 99.9c.6-.8 1.3-1.3 1.9-1.4.6-.2 1.2 0 1.8.5.3.3.5.5.7.8.1.3.2.6.1.9 0 .3-.1.7-.3 1-.2.4-.4.7-.8 1.1l-.4.5 1.9 1.6-.8 1-5.3-4.4c.1-.3.3-.5.5-.8.4-.3.6-.6.7-.8zm.9.6c-.2.2-.4.5-.5.6l1.8 1.5.4-.5c.4-.5.6-.9.7-1.2.1-.4-.1-.7-.4-1-.2-.1-.3-.2-.5-.3h-.5c-.2 0-.3.2-.5.3-.1.3-.3.4-.5.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M316.6 93.8c.4.4.8.8 1 1.3.2.4.3.9.3 1.3s-.1.8-.2 1.3-.4.8-.7 1.1c-.3.3-.7.6-1.1.8-.4.2-.8.3-1.2.3s-.9-.1-1.3-.2c-.5-.2-.9-.5-1.3-.9s-.8-.8-1-1.3c-.2-.4-.3-.9-.3-1.3s.1-.9.2-1.3c.2-.4.4-.8.7-1.1.3-.3.7-.6 1-.8.4-.2.8-.3 1.2-.3.4 0 .9.1 1.3.2.5.2 1 .5 1.4.9zm-3.7 4c.3.3.6.5.9.6s.6.2.9.2.5 0 .8-.1c.3-.1.5-.3.7-.5.2-.2.4-.5.4-.8.1-.3.1-.5.1-.8s-.1-.6-.3-.8c-.2-.3-.4-.5-.7-.8s-.6-.5-.9-.6c-.3-.1-.6-.2-.9-.2s-.6 0-.8.1c-.3.1-.5.3-.7.5-.2.2-.4.5-.5.8-.1.3-.1.5-.1.8s.1.6.3.8c.3.3.6.5.8.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M316.7 88.8c.7-.7 1.4-1.1 2-1.2.6-.1 1.2.1 1.7.6.7.7.8 1.4.4 2.3.2 0 .4.1.7.1.3 0 .6.1.9.2.3.1.6.1.9.2l.9.3-1 1c-.3-.1-.5-.2-.8-.2-.3-.1-.5-.1-.8-.2-.3-.1-.5-.1-.8-.2-.2 0-.5-.1-.7-.1l-.2.2-.1.1-.4.4 1.8 1.9-.9.9-4.8-4.9c.2-.3.4-.5.6-.8s.4-.4.6-.6zm.8.7-.5.5 1.6 1.6.4-.4c.2-.2.4-.4.5-.6.1-.2.2-.4.3-.5 0-.2.1-.3 0-.5s-.1-.3-.3-.5c-.1-.2-.3-.3-.5-.3h-.5c-.2 0-.3.1-.5.2-.1.2-.3.4-.5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m324 82.1.7.8-1.6 1.4 3.9 4.3-.9.8-3.9-4.3-1.6 1.4-.7-.8 4.1-3.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m325.1 81.2 1-.8 4.5 5.3-1 .8-4.5-5.3z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M335.7 81.5c-.4-.2-.9-.3-1.4-.5-.5-.2-1-.3-1.5-.5s-1-.3-1.5-.4-1-.2-1.4-.3l3.1 3.9-1 .8-4.3-5.4.8-.6c.4.1.8.1 1.3.2s1 .2 1.5.4c.5.1 1 .3 1.5.4.5.1.9.3 1.3.4l-2.9-3.6 1-.8 4.3 5.4-.8.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M337.2 72.9c-.6.4-.9.9-.9 1.5s.2 1.2.6 1.8c.2.3.5.6.7.8.3.2.5.3.8.4.3.1.6.1.8 0 .3-.1.6-.2.9-.4.2-.1.3-.2.4-.4l.3-.3-1.5-2 1-.7 2 2.7c-.1.2-.3.4-.6.7-.3.3-.6.6-1.1.9-.4.3-.8.5-1.2.6-.4.1-.8.1-1.3.1-.4-.1-.8-.3-1.2-.5-.4-.3-.8-.6-1.1-1.1-.3-.5-.6-.9-.7-1.4-.1-.5-.1-.9-.1-1.3.1-.4.2-.8.5-1.2.2-.4.5-.7.9-1 .3-.2.5-.3.7-.4l.6-.3c.2-.1.3-.1.5-.1h.3l.3 1.1c-.2 0-.5.1-.8.2-.3 0-.6.1-.8.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M396.7 52.4c-.2-.2-.3-.5-.5-.7-.2-.2-.3-.5-.5-.7l-2.8.7c0 .3-.1.6-.1.9 0 .3-.1.6-.1.8l-1.3.3c.1-.8.2-1.5.2-2.2.1-.7.2-1.3.2-1.9.1-.6.2-1.2.3-1.7.1-.5.2-1.1.3-1.6l1.2-.3c.3.4.7.9 1 1.3.3.4.7.9 1 1.4.3.5.7 1 1.1 1.6l1.2 1.8-1.2.3zm-3.3-5c-.1.4-.1.8-.2 1.4-.1.5-.1 1.1-.2 1.7l2.2-.5c-.3-.5-.7-1-1-1.5-.3-.4-.6-.8-.8-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M403.9 47.4c.1.6.1 1.1 0 1.6s-.3.9-.6 1.2-.6.7-1.1.9c-.4.2-1 .4-1.5.5-.3.1-.6.1-.9.1-.4 0-.7.1-1 .1l-1.3-6.6c.3-.1.6-.2 1-.3.3-.1.7-.2.9-.2.6-.1 1.1-.1 1.6-.1s.9.2 1.3.4.7.5 1 .9c.3.4.5.9.6 1.5zm-4 3.2h.3c.1 0 .3 0 .5-.1.8-.2 1.4-.5 1.7-1 .3-.5.4-1.1.3-1.9-.2-.8-.5-1.3-.9-1.7-.5-.3-1.1-.4-2-.3-.4.1-.6.1-.8.2l.9 4.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M406.1 43.5c.2.2.4.5.6.8.2.3.5.7.7 1.1s.5.8.7 1.1c.2.4.5.7.7 1.1l.3-1.2c.1-.4.2-.9.4-1.3.1-.4.3-.8.4-1.2.1-.4.2-.7.4-1l1.1-.2c.1.5.3 1 .4 1.6s.3 1.1.4 1.7.3 1.2.4 1.8c.1.6.2 1.2.4 1.7l-1.2.2c-.1-.8-.3-1.6-.5-2.4-.2-.8-.3-1.6-.5-2.4-.1.2-.1.4-.2.6-.1.2-.1.5-.2.7-.1.3-.2.5-.2.8-.1.3-.2.6-.2.8-.1.3-.1.5-.2.7-.1.2-.1.4-.2.6l-.9.1c-.1-.1-.2-.3-.3-.5-.1-.2-.3-.4-.4-.7-.1-.2-.3-.5-.4-.7s-.3-.5-.5-.7c-.1-.2-.3-.4-.4-.6-.1-.2-.2-.4-.3-.5 0 .8.1 1.6.2 2.5.1.8.2 1.7.3 2.5l-1.2.2c-.1-.6-.1-1.2-.2-1.8-.1-.6-.1-1.2-.1-1.8s-.1-1.2-.1-1.8c0-.6 0-1.1-.1-1.6l.9-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m413.5 42.5 1.3-.1.8 6.9-1.3.1-.8-6.9z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M421.7 48.6c-.3-.4-.5-.7-.9-1.2-.3-.4-.6-.8-1-1.3s-.7-.8-1-1.2c-.3-.4-.7-.7-1-1.1l.4 5-1.2.1-.6-6.9 1-.1.9.9c.3.4.7.7 1 1.1.3.4.7.8 1 1.2.3.4.6.8.9 1.1l-.4-4.6 1.2-.1.6 6.9-.9.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m424 41.6 1.3-.1.3 6.9-1.3.1-.3-6.9z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M428.9 47.4c.5 0 .8-.1 1-.2.2-.2.3-.4.3-.7 0-.2 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.5-.3-.2-.1-.4-.2-.6-.2-.2-.1-.5-.2-.7-.3-.2-.1-.4-.2-.6-.4s-.3-.3-.4-.5c-.1-.2-.2-.5-.2-.8 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.8-.6.4 0 .8 0 1.2.1s.6.2.8.3l-.4 1c-.2-.1-.5-.2-.8-.3-.3-.1-.6-.1-.8-.1-.3 0-.6.1-.8.2-.2.1-.3.3-.3.6 0 .2 0 .3.1.4l.3.3c.1.1.3.2.4.2.2.1.3.1.5.2l.9.3c.3.1.5.3.7.4.2.2.3.4.4.6.1.2.2.5.2.8 0 .6-.2 1.1-.6 1.5-.4.4-1.1.5-1.9.6h-.8c-.2 0-.4-.1-.6-.1-.2 0-.3-.1-.5-.2-.1-.1-.2-.1-.3-.1l.3-1c.2.1.4.2.7.3.2.2.6.2 1 .2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M437.5 41.5v1.1h-2.1l-.1 5.8H434l.1-5.8H432v-1.1h5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M440.7 41.5c1 .1 1.8.3 2.3.7.5.4.7 1 .7 1.7 0 .9-.5 1.5-1.5 1.8.1.2.3.4.4.6s.3.5.5.7c.2.3.3.5.4.8.1.3.3.5.4.8l-1.4-.1c-.1-.2-.2-.5-.4-.7s-.3-.5-.4-.7c-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.6h-1l-.1 2.6-1.3-.1.4-6.8c.3-.1.6-.1 1-.1.2.1.5.1.8.1zm0 1.1h-.7l-.1 2.2h1.3c.2 0 .4-.1.6-.1.2-.1.3-.2.4-.3.1-.1.1-.3.1-.6 0-.2 0-.4-.1-.5-.1-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.2-.2-.1-.4-.1-.7-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M449.7 49.2c-.1-.3-.1-.6-.2-.8-.1-.3-.1-.6-.2-.8l-2.9-.3c-.1.3-.2.5-.4.8-.1.3-.2.5-.4.8l-1.3-.1c.3-.7.6-1.4.9-2 .3-.6.6-1.2.8-1.7.3-.5.5-1.1.8-1.5.3-.5.5-1 .8-1.4l1.2.1c.2.5.4 1 .5 1.6.2.5.3 1.1.5 1.7.2.6.3 1.2.5 1.8.2.6.4 1.4.6 2.1l-1.2-.3zm-1.6-5.8c-.2.3-.4.8-.6 1.2-.2.5-.5 1-.8 1.6l2.3.2c-.2-.6-.3-1.2-.5-1.7-.1-.5-.2-.9-.4-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m456.7 43.1-.1 1.1-2.1-.3-.8 5.8-1.3-.2.8-5.8-2.1-.3.1-1.1 5.5.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m458 43.3 1.2.2-1.1 6.9-1.2-.2 1.1-6.9z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M466.7 48.4c-.1.6-.3 1.1-.6 1.5-.3.4-.6.7-.9 1-.4.2-.7.4-1.2.5-.4.1-.9.1-1.3 0s-.9-.2-1.2-.5-.7-.5-.9-.9c-.2-.4-.4-.8-.5-1.2s-.1-1 0-1.6.3-1.1.6-1.5c.3-.4.6-.7.9-1 .4-.2.8-.4 1.2-.5.4-.1.9-.1 1.3 0s.9.2 1.2.5c.4.2.7.5.9.9.2.4.4.8.5 1.2s.1 1.1 0 1.6zm-5.3-1c-.1.4-.1.7-.1 1 0 .3.1.6.2.9.1.2.3.5.5.6.2.2.5.3.8.3.3.1.6.1.9 0 .3-.1.5-.2.7-.4s.4-.4.5-.7c.1-.3.3-.6.3-1 .1-.4.1-.7.1-1 0-.3-.1-.6-.2-.9-.1-.2-.3-.5-.5-.6-.2-.2-.5-.3-.8-.3-.3-.1-.6-.1-.9 0-.3.1-.5.2-.7.4-.2.2-.4.4-.5.7-.1.3-.2.6-.3 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M471.6 53.2c-.1-.4-.3-.9-.4-1.4-.2-.5-.3-1-.5-1.5l-.6-1.5c-.2-.5-.4-.9-.6-1.3l-1.2 4.8-1.2-.3 1.6-6.7 1 .2c.2.3.4.7.6 1.2.2.4.4.9.6 1.4.2.5.4 1 .6 1.4.2.5.3.9.5 1.3l1.1-4.5 1.2.3-1.6 6.7-1.1-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M521.8 67.6c.8.5 1.4 1.1 1.6 1.7.3.6.2 1.2-.3 1.9-.2.3-.5.6-.7.8-.3.2-.6.3-.9.3-.3 0-.7-.1-1.1-.2-.4-.1-.8-.3-1.2-.6l-.5-.3-1.3 2-1.1-.7 3.7-5.7c.3.1.6.2.9.4.4.1.7.2.9.4zm-.5 1c-.3-.2-.5-.3-.7-.4l-1.3 2 .5.3c.5.3.9.5 1.3.5s.7-.1.9-.5c.1-.2.2-.4.2-.5 0-.2 0-.3-.1-.5s-.2-.3-.4-.5c0-.2-.2-.3-.4-.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M527.1 71.1c.8.6 1.3 1.2 1.6 1.8s.1 1.2-.3 1.8c-.5.8-1.3 1-2.2.8v1.6c0 .3 0 .6-.1.9 0 .3-.1.6-.1.9l-1.2-.8c0-.3.1-.5.1-.8V75c-.1 0-.1-.1-.2-.1s-.1-.1-.2-.1l-.5-.4-1.5 2.1-1-.7 4-5.6c.3.1.6.3.9.5.2 0 .4.2.7.4zm-.6.9c-.2-.2-.4-.3-.6-.4l-1.3 1.8.5.3c.3.2.5.3.7.4.2.1.4.2.6.2.2 0 .3 0 .5-.1s.3-.2.4-.4c.1-.2.2-.3.2-.5s0-.3-.1-.5-.2-.3-.3-.5c-.2 0-.4-.1-.6-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M533.7 80.4c-.4.5-.8.8-1.2 1.1-.4.3-.8.4-1.3.5-.4.1-.9 0-1.3-.1s-.8-.3-1.2-.6-.7-.6-.9-1c-.2-.4-.4-.8-.4-1.2-.1-.4 0-.9.1-1.4.1-.5.4-.9.7-1.4.4-.5.8-.8 1.2-1.1.4-.2.8-.4 1.3-.5.4-.1.9 0 1.3.1s.8.3 1.2.6c.4.3.7.6.9 1 .2.4.4.8.4 1.2s0 .9-.1 1.3c-.1.6-.3 1.1-.7 1.5zm-4.3-3.3c-.2.3-.4.6-.5.9-.1.3-.2.6-.2.9 0 .3.1.5.2.8.1.3.3.5.6.7.3.2.5.3.8.4.3.1.6.1.8 0 .3-.1.5-.2.8-.4.3-.2.5-.4.7-.7.2-.3.4-.6.5-.9s.2-.6.2-.9c0-.3-.1-.5-.2-.8-.1-.3-.3-.5-.6-.7-.3-.2-.5-.3-.8-.4-.3-.1-.6-.1-.8 0-.3.1-.5.2-.8.4-.2.2-.5.4-.7.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M539.1 85c-.4.5-.8.8-1.2 1-.4.2-.9.3-1.3.3-.5 0-.9-.1-1.4-.3s-.9-.5-1.4-.9c-.2-.2-.4-.4-.7-.6-.3-.2-.5-.5-.7-.8l4.3-5.2c.3.1.6.3.9.5.3.2.5.4.8.6.4.4.8.8 1.1 1.2.3.4.5.8.5 1.3.1.4 0 .9-.1 1.4s-.4 1-.8 1.5zm-5.1-1.1.2.2c.1.1.2.2.4.3.6.5 1.3.8 1.9.7.6-.1 1.1-.4 1.6-1s.7-1.2.7-1.8c0-.6-.4-1.1-1-1.7-.3-.2-.5-.4-.6-.5l-3.2 3.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M539.5 90.3c-.3-.3-.6-.6-.8-1-.2-.3-.2-.7-.2-1 0-.3.1-.7.2-1 .1-.3.4-.6.6-.9l2.9-3.2.9.9-2.9 3.1c-.2.2-.4.5-.5.7-.1.2-.1.4-.1.6 0 .2 0 .4.1.5.1.2.2.3.4.5s.3.3.5.3.4.1.6.1c.2 0 .4-.1.6-.2.2-.1.4-.3.6-.5l2.9-3.1.9.9-2.9 3.2c-.3.3-.6.5-.9.7-.3.2-.6.3-1 .3s-.7 0-1-.2c-.2-.1-.5-.3-.9-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M545.5 95.9c.1-.3.1-.7.2-1 0-.4.1-.7.1-1.1v-1.1c0-.4 0-.7-.1-1l-2.2 2.2-.9-.9 4.9-4.9.9.9-2 2h3.9l1.1 1.1c-.3 0-.7 0-1.1.1H547c0 .3.1.7.1 1.1v1.2c0 .4-.1.9-.2 1.3s-.2.8-.2 1.2l-1.2-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m555.7 96.6-.8.7-1.4-1.6-4.3 4-.9-.9 4.3-4-1.4-1.6.8-.7 3.7 4.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m556.5 97.6.8 1-5.3 4.4-.8-1 5.3-4.4z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M559.9 107.1c-.5.4-.9.6-1.4.8-.5.1-.9.2-1.3.2s-.8-.2-1.2-.4c-.4-.2-.7-.5-1-.9-.3-.4-.5-.7-.6-1.2-.1-.4-.2-.8-.1-1.3 0-.4.2-.8.4-1.3.2-.4.6-.8 1-1.2.5-.4.9-.6 1.4-.8.5-.1.9-.2 1.3-.1.4 0 .8.2 1.2.4.4.2.7.5 1 .8.3.3.5.7.6 1.1.1.4.2.8.1 1.3 0 .4-.2.9-.4 1.3-.2.5-.6.9-1 1.3zm-3.4-4.2c-.3.2-.5.5-.7.8-.2.3-.3.5-.4.8-.1.3 0 .5 0 .8s.2.5.4.8c.2.2.4.4.7.5s.5.2.8.2c.3 0 .6-.1.9-.2.3-.1.6-.3.9-.5.3-.2.5-.5.7-.8.2-.3.3-.5.4-.8.1-.3 0-.5 0-.8-.1-.3-.2-.5-.4-.8-.2-.2-.4-.4-.7-.5-.3-.1-.5-.2-.8-.2s-.6.1-.9.2c-.4.1-.6.3-.9.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M560.7 113.9c.2-.4.3-.9.5-1.3s.4-1 .5-1.5.3-1 .5-1.5c.1-.5.3-1 .4-1.4l-4 3-.7-1 5.5-4.2.6.8c-.1.4-.2.8-.3 1.3-.1.5-.3 1-.4 1.5s-.3 1-.5 1.5-.3.9-.5 1.3l3.7-2.8.8 1-5.5 4.2-.6-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M563.8 116.8c.3.4.5.6.7.7.2.1.5 0 .7-.1l.3-.3c.1-.1.1-.3.1-.4v-.5c0-.2-.1-.4-.2-.7-.1-.2-.1-.5-.2-.7v-.7c0-.2.1-.4.2-.6.1-.2.3-.4.6-.6.5-.4 1-.4 1.6-.3.5.2 1 .5 1.4 1.2.2.4.4.7.5 1 .1.3.2.6.2.8l-1.1.2c0-.3-.1-.5-.2-.8-.1-.3-.2-.5-.4-.8-.2-.3-.4-.5-.6-.5-.2-.1-.4 0-.7.1l-.3.3c-.1.1-.1.2-.1.4v.5c0 .2.1.4.1.5.1.3.1.6.2.9v.8c0 .3-.1.5-.3.7-.1.2-.3.4-.6.6-.5.4-1 .4-1.6.3-.5-.2-1-.6-1.5-1.3-.2-.2-.3-.5-.4-.7-.1-.2-.2-.4-.2-.6-.1-.2-.1-.3-.1-.5 0-.1 0-.3-.1-.4l1.1-.3c0 .2.1.5.2.8s.4.6.7 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m567.9 118.5 1.5 2.3-.9.6-1.5-2.3.9-.6z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M270 174.9c.1-.5.3-1 .5-1.3.2-.4.5-.7.9-.9s.8-.4 1.2-.4c.5-.1 1 0 1.6.1s1.1.3 1.5.6c.4.3.7.6 1 .9.2.4.4.8.5 1.2.1.4.1.9 0 1.3-.1.3-.1.5-.2.8l-.3.6c-.1.2-.2.3-.2.4-.1.1-.1.2-.2.2l-.9-.6c.1-.1.3-.3.4-.6l.3-.9c.1-.3.1-.6 0-.9-.1-.3-.2-.5-.3-.8-.2-.2-.4-.4-.7-.6-.3-.2-.6-.3-1-.4-.4-.1-.7-.1-1-.1-.3 0-.6.1-.9.2-.3.1-.5.3-.6.5-.2.2-.3.5-.4.9-.1.4-.1.8-.1 1.1 0 .3.1.5.1.7l-1.1.1c0-.1-.1-.2-.1-.3 0-.1 0-.3-.1-.5v-.6c0-.2.1-.5.1-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M272.1 184.8c-.6-.1-1.1-.2-1.5-.5-.4-.2-.8-.5-1-.9-.3-.3-.4-.7-.5-1.2-.1-.4-.1-.9 0-1.3s.2-.9.4-1.3.5-.7.8-1c.3-.3.8-.4 1.2-.6.5-.1 1-.1 1.6 0s1.1.3 1.5.5c.4.2.8.5 1 .9s.4.7.5 1.2c.1.4.1.9 0 1.3s-.2.9-.4 1.2c-.2.4-.5.7-.8 1s-.8.4-1.2.6c-.5.2-1 .2-1.6.1zm.8-5.3c-.4-.1-.7-.1-1 0-.3 0-.6.1-.8.3-.2.1-.4.3-.6.6-.2.2-.3.5-.3.8 0 .3 0 .6.1.9s.2.5.4.7c.2.2.4.4.7.5.3.1.6.2 1 .3.4.1.7.1 1 0 .3 0 .6-.1.8-.3.2-.1.4-.3.6-.6.2-.2.3-.5.3-.8 0-.3 0-.6-.1-.9-.1-.3-.2-.5-.4-.7-.2-.2-.4-.4-.7-.5s-.7-.3-1-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M268 190.4c.4-.2.8-.4 1.3-.6.5-.2.9-.5 1.4-.7.5-.2.9-.5 1.4-.8.4-.3.9-.5 1.2-.8l-4.9-.5.1-1.2 6.9.8-.1 1c-.3.2-.7.5-1.1.7-.4.3-.8.5-1.3.8-.4.3-.9.5-1.3.8-.4.2-.9.5-1.2.6l4.6.5-.1 1.2-6.9-.8v-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m274.3 198.4-1.1-.1.1-2.1-5.8-.4.1-1.3 5.8.4.1-2.1 1.1.1-.3 5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M274.3 201.4c0 1-.2 1.8-.6 2.3-.4.5-1 .8-1.7.7-.9 0-1.6-.5-1.9-1.4-.2.1-.3.3-.6.4-.2.2-.5.3-.7.5s-.5.3-.8.5-.5.3-.8.4v-1.4c.2-.1.5-.2.7-.4.2-.1.5-.3.7-.4.2-.1.5-.3.7-.4.2-.1.4-.3.6-.4v-1l-2.6-.1v-1.3l6.8.2c.1.3.1.6.1 1 .1.2.1.5.1.8zm-1.1 0v-.7l-2.2-.1v1.3c0 .2.1.4.2.6s.2.3.3.4c.1.1.3.1.6.1.2 0 .4 0 .5-.1.1-.1.3-.2.4-.3.1-.1.2-.3.2-.5v-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M270.8 212.1c-.6 0-1.1-.1-1.6-.2-.5-.2-.8-.4-1.1-.7-.3-.3-.5-.6-.7-1.1-.2-.4-.2-.8-.3-1.3 0-.5.1-.9.2-1.3s.4-.8.7-1.1c.3-.3.7-.6 1.1-.7.4-.2 1-.3 1.6-.3.6 0 1.1.1 1.6.2.5.2.8.4 1.1.7.3.3.5.7.7 1.1.2.4.2.8.3 1.3 0 .5-.1.9-.2 1.3s-.4.8-.7 1.1c-.3.3-.7.6-1.1.7-.5.1-1 .2-1.6.3zm-.1-5.4c-.4 0-.7.1-1 .2-.3.1-.6.2-.8.4-.2.2-.4.4-.5.7-.1.3-.2.5-.2.9 0 .3.1.6.2.8.1.3.3.5.5.6.2.2.5.3.8.4.3.1.7.1 1 .1.4 0 .7-.1 1-.2.3-.1.6-.2.8-.4.2-.2.4-.4.5-.7.1-.3.2-.5.2-.9 0-.3-.1-.6-.2-.9-.1-.3-.3-.5-.5-.6-.2-.2-.5-.3-.8-.4-.3 0-.6-.1-1 0z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m268.7 217.9-1.1.1-.2-4.4 6.9-.4.1 1.3-5.8.3.1 3.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m269.2 223.4-1.1.1-.4-4.4 6.9-.6.1 1.3-5.8.5.3 3.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m275.1 223.9.1 1.3-6.9.8-.1-1.3 6.9-.8z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M269.3 232.4c.3-.3.7-.6 1.1-.9.4-.3.8-.7 1.2-1.1.4-.4.8-.7 1.1-1.1l1-1-4.9.7-.2-1.2 6.9-1 .1 1c-.2.3-.5.6-.9 1-.3.4-.7.7-1 1.1l-1.1 1.1c-.4.3-.7.7-1 .9l4.6-.7.2 1.2-6.9 1-.2-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M276.2 237.2c-.1-.7-.5-1.2-1-1.5-.5-.3-1.1-.4-1.9-.2-.4.1-.7.2-1 .3-.3.1-.5.3-.7.5s-.3.5-.4.7-.1.6 0 .9c0 .2.1.4.1.6 0 .2.1.3.1.4l2.4-.5.2 1.2-3.3.6-.4-.8c-.2-.4-.3-.8-.4-1.4-.1-.5-.1-1 0-1.4.1-.4.2-.8.5-1.2.2-.3.6-.6 1-.9.4-.2.9-.4 1.5-.5s1.1-.1 1.6 0 .9.3 1.2.5c.4.2.7.5.9.9s.4.8.5 1.2c.1.3.1.6.1.9v.7c0 .2 0 .3-.1.5 0 .1-.1.2-.1.3l-1.1-.2c.1-.2.1-.5.2-.8.2-.1.2-.4.1-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M289.9 289.8c.2-.2.4-.4.6-.7s.4-.4.6-.7l-1.5-2.5c-.3.1-.6.1-.9.2-.3 0-.6.1-.8.2l-.6-1.1c.8-.1 1.5-.3 2.1-.4.7-.1 1.3-.2 1.9-.3.6-.1 1.2-.2 1.7-.2.5-.1 1.1-.1 1.6-.2l.6 1c-.3.4-.6.9-1 1.3s-.7.9-1.1 1.4l-1.2 1.5c-.4.5-.9 1.1-1.4 1.7l-.6-1.2zm3.8-4.5c-.4 0-.8.1-1.4.2-.5.1-1.1.2-1.7.3l1.1 2c.4-.5.8-.9 1.1-1.4.4-.5.7-.8.9-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M292.4 294.2c-.3-.4-.4-.8-.5-1.1-.1-.4 0-.7 0-1 .1-.3.3-.6.5-.9.2-.3.5-.5.9-.7l3.7-2.3.7 1.1-3.6 2.2c-.3.2-.5.3-.6.5-.2.2-.3.4-.3.5 0 .2-.1.4 0 .6 0 .2.1.4.2.6.1.2.2.3.4.5.2.1.3.2.5.2h.6c.2-.1.5-.2.7-.3l3.6-2.2.7 1.1-3.7 2.3c-.3.2-.7.4-1 .4-.3.1-.7.1-1 0-.3-.1-.6-.2-.9-.4-.4-.4-.7-.7-.9-1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m303.3 297.9-.9.6-1.2-1.8-4.8 3.3-.7-1.1 4.8-3.3-1.2-1.8.9-.6 3.1 4.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M304.8 305.6c-.5.4-.9.6-1.4.7-.5.1-.9.2-1.3.1s-.8-.2-1.2-.4c-.4-.2-.7-.5-1-.9s-.5-.8-.6-1.2c-.1-.4-.2-.8-.1-1.3.1-.4.2-.8.5-1.3.3-.4.6-.8 1.1-1.2.5-.4.9-.6 1.4-.7.5-.1.9-.2 1.3-.1s.8.2 1.2.4c.4.2.7.5 1 .9.3.4.5.8.6 1.2.1.4.1.8.1 1.3-.1.4-.2.8-.5 1.3-.2.5-.6.9-1.1 1.2zm-3.2-4.3c-.3.2-.6.5-.7.7-.2.3-.3.5-.4.8-.1.3-.1.5 0 .8.1.3.2.5.4.8.2.3.4.4.7.6.2.1.5.2.8.2.3 0 .6 0 .9-.1s.6-.3.9-.5.6-.5.7-.7.3-.5.4-.8.1-.5 0-.8c-.1-.3-.2-.5-.4-.8-.2-.3-.4-.5-.7-.6-.2-.1-.5-.2-.8-.2-.3 0-.6 0-.9.1-.3.1-.6.3-.9.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M309.2 305.6c-.1.3-.2.6-.4 1s-.4.8-.5 1.2-.4.8-.6 1.2c-.2.4-.4.8-.6 1.1l1.2-.3c.4-.1.9-.2 1.3-.4l1.2-.3c.4-.1.7-.2 1-.2l.7.9c-.4.4-.7.8-1.1 1.2-.4.4-.8.8-1.3 1.2-.4.4-.9.8-1.3 1.2-.4.4-.9.8-1.3 1.2l-.8-1c.6-.5 1.2-1.1 1.9-1.6.6-.6 1.2-1.1 1.8-1.7-.2 0-.4.1-.6.1-.2.1-.5.1-.7.2-.3.1-.5.1-.8.2-.3.1-.5.2-.8.2-.3.1-.5.1-.7.2-.2.1-.4.1-.6.2l-.6-.7c.1-.1.2-.3.3-.5.1-.2.2-.4.4-.7s.2-.5.4-.7c.1-.3.3-.5.4-.8.1-.2.2-.5.3-.7.1-.2.2-.4.3-.5-.7.4-1.3.9-2 1.4-.7.5-1.3 1-2 1.5l-.8-1c.5-.3.9-.7 1.4-1 .5-.4 1-.7 1.5-1.1.5-.3 1-.7 1.4-1 .5-.3.9-.6 1.3-.9l.7.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M311.8 319.1c.1-.3.3-.5.4-.8.1-.3.3-.5.4-.8l-2-2.2c-.3.1-.5.2-.8.4-.3.1-.5.2-.8.3l-.9-1c.7-.3 1.4-.6 2-.8s1.2-.5 1.8-.7c.6-.2 1.1-.4 1.6-.6.5-.2 1-.4 1.6-.5l.8.9-.6 1.5c-.2.5-.5 1-.7 1.6-.3.5-.5 1.1-.8 1.7-.3.6-.6 1.2-1 1.9l-1-.9zm2.7-5.4c-.4.1-.8.3-1.3.5s-1.1.4-1.6.7l1.5 1.7c.3-.6.6-1.1.8-1.6.3-.5.5-.9.6-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m321.2 318.9-.8.8-1.5-1.5-4.1 4.1-.9-.9 4.1-4.1-1.5-1.5.8-.8 3.9 3.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m322.1 319.7.9.9-4.8 5-.9-.9 4.8-5z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M321.4 327.2c.3.3.6.5.9.5.3 0 .5-.1.7-.3.1-.1.2-.3.2-.4v-.4c0-.2-.1-.3-.2-.5l-.3-.6c-.1-.2-.2-.5-.3-.7-.1-.2-.2-.5-.2-.7 0-.2 0-.5.1-.7.1-.2.2-.5.4-.7.4-.5.9-.7 1.5-.7s1.1.3 1.7.8c.3.3.6.6.8.9.2.3.3.6.4.8l-1 .5c-.1-.2-.2-.5-.4-.7-.2-.2-.3-.4-.6-.6-.3-.2-.5-.4-.7-.4-.2 0-.4.1-.6.2-.1.1-.2.2-.2.4v.4c0 .1.1.3.1.5.1.2.1.3.2.5.2.3.3.6.4.9.1.3.2.5.2.8 0 .2 0 .5-.1.7s-.2.5-.5.7c-.4.5-.9.7-1.5.6s-1.2-.4-1.8-.9c-.2-.2-.4-.4-.5-.6-.2-.2-.3-.4-.4-.5-.1-.2-.2-.3-.2-.4-.1-.1-.1-.2-.1-.3l1-.5c.1.2.2.4.3.7.1.1.3.4.7.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m328.3 325.4.9.8-4.6 5.2-.9-.8 4.6-5.2z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m326.1 332.7 4.4-5.4 3.5 2.8-.7.8-2.5-2-1.1 1.3 2.2 1.8-.7.8-2.2-1.8-1.3 1.6 2.7 2.2-.7.8-3.6-2.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M336.6 332.1c.8.6 1.3 1.2 1.5 1.8.2.6.1 1.2-.4 1.8-.6.7-1.3 1-2.3.7v1.6c0 .3-.1.6-.1.9 0 .3-.1.6-.2.9l-1.1-.9c0-.3.1-.5.1-.8 0-.3.1-.6.1-.8v-1.5c-.1-.1-.1-.1-.2-.1s-.1-.1-.2-.1l-.5-.4-1.6 2.1-1-.8 4.1-5.4c.3.1.6.3.9.5.4.1.7.3.9.5zm-.6.9c-.2-.2-.4-.3-.6-.4l-1.4 1.8.4.3c.2.2.5.3.7.4.2.1.4.2.6.2.2 0 .3 0 .5-.1s.3-.2.4-.4c.1-.2.2-.3.2-.5s0-.3-.1-.5-.2-.3-.3-.5c0 0-.2-.1-.4-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M338.1 342.1c-.4-.3-.7-.6-.9-.9-.2-.3-.3-.6-.4-1 0-.3 0-.7.1-1 .1-.3.3-.7.5-1l2.5-3.5 1 .7-2.4 3.5c-.2.3-.3.5-.4.7-.1.2-.1.4-.1.6 0 .2.1.4.2.5.1.2.2.3.4.4.2.1.4.2.5.3s.4.1.6 0c.2 0 .4-.1.6-.3.2-.1.4-.3.5-.6l2.4-3.5 1 .7-2.5 3.5c-.2.3-.5.6-.8.8-.3.2-.6.4-.9.4s-.7.1-1 0c-.1.1-.5-.1-.9-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M345.8 346.9v-3c0-.5-.1-1.1-.1-1.6s-.1-1-.2-1.4l-2.6 4.2-1.1-.7 3.7-5.9.9.5c.1.4.1.8.2 1.3s.1 1 .2 1.5.1 1 .1 1.5v1.4l2.4-3.9 1.1.7-3.7 5.9-.9-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M353.9 344.8c-.6-.3-1.2-.4-1.7-.2s-1 .6-1.4 1.3c-.2.3-.3.6-.4 1-.1.3-.1.6 0 .9s.2.5.3.8c.2.2.4.4.7.6.2.1.4.2.5.3.1.1.3.1.4.1l1.2-2.2 1.1.6-1.6 2.9c-.2 0-.5-.1-.9-.2s-.8-.3-1.3-.6c-.4-.2-.8-.5-1.1-.9-.3-.3-.5-.7-.6-1.1-.1-.4-.1-.8 0-1.3s.3-1 .5-1.5c.3-.5.6-.9 1-1.2.4-.3.8-.5 1.2-.6.4-.1.8-.1 1.3-.1.4.1.9.2 1.3.4.3.2.5.3.7.5.2.2.4.3.5.4s.2.3.3.4c.1.1.1.2.2.2l-.8.7c-.1-.2-.3-.4-.5-.6-.3-.3-.6-.5-.9-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M524.1 336.3c.3.2.6.5.9.7.3.3.6.5 1 .7.3.2.7.5 1 .7s.6.5.9.7c-.1-.4-.3-.7-.4-1.1s-.3-.8-.5-1.2c-.2-.4-.4-.9-.6-1.3-.2-.4-.4-.9-.6-1.3l1.1-.7c.5 1.2 1 2.3 1.4 3.4.4 1.1.8 2.2 1.1 3.3l-1 .7c-1.2-.8-2.4-1.7-3.7-2.8.3.8.5 1.6.7 2.3s.4 1.5.6 2.2l-1 .7c-.9-.7-1.8-1.4-2.7-2.2-.9-.8-1.8-1.6-2.7-2.5l1.1-.8 1 1 1 1c.3.3.7.6 1 .9.3.3.6.6.9.8-.1-.4-.2-.7-.3-1.1l-.3-1.2c-.1-.4-.2-.8-.4-1.2-.1-.4-.2-.8-.4-1.1l.9-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m527.8 332.6 1-.8 4.2 5.5-1 .8-4.2-5.5z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M531.8 329.4c.8-.6 1.5-1 2.1-1 .6-.1 1.2.2 1.7.8.6.7.6 1.5.1 2.4.2 0 .4.1.7.2.3.1.5.1.8.2l.9.3c.3.1.6.2.8.4l-1.1.9c-.3-.1-.5-.2-.8-.3-.3-.1-.5-.2-.8-.3-.3-.1-.5-.2-.8-.2-.2-.1-.5-.1-.7-.2l-.2.2c-.1 0-.1.1-.1.1l-.5.4 1.7 2-1 .8-4.3-5.3c.2-.2.4-.5.7-.7.4-.3.6-.5.8-.7zm.8.8c-.2.2-.4.3-.6.5l1.4 1.7.4-.3.6-.6c.2-.2.3-.3.3-.5.1-.2.1-.3.1-.5s-.1-.3-.3-.5c-.1-.2-.3-.3-.4-.3-.2-.1-.3-.1-.5-.1s-.3.1-.5.2c-.1.1-.3.2-.5.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m539.1 323.3.7.8-1.6 1.4 3.9 4.4-1 .8-3.9-4.4-1.6 1.4-.7-.8 4.2-3.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M545.5 325.5c.3-.3.5-.6.6-.8 0-.3 0-.5-.2-.7-.1-.1-.2-.2-.4-.2h-.4c-.2 0-.3.1-.5.1l-.6.3c-.2.1-.5.2-.7.3-.2.1-.5.1-.7.1-.2 0-.5 0-.7-.1-.2-.1-.4-.2-.6-.5-.4-.5-.6-1-.5-1.5.1-.6.4-1.1.9-1.6.3-.3.6-.5.9-.7.3-.2.6-.3.8-.3l.4 1c-.3.1-.5.2-.7.3s-.5.3-.7.5c-.2.2-.4.5-.4.7 0 .2 0 .4.2.6.1.1.2.2.3.2h.4c.1 0 .3-.1.5-.1.2-.1.3-.1.5-.2l.9-.3c.3-.1.5-.1.8-.1s.5.1.7.2c.2.1.5.3.7.5.4.5.6 1 .5 1.5-.1.6-.4 1.1-1.1 1.7-.2.2-.4.4-.6.5l-.6.3c-.2.1-.3.2-.5.2-.1.1-.2.1-.3.1l-.4-1c.2-.1.4-.1.7-.3.2-.2.5-.4.8-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M551.6 320.9c-.4.4-.7.7-1.1.8-.4.2-.8.3-1.2.3-.4 0-.8-.1-1.3-.3-.4-.2-.9-.5-1.3-.9s-.7-.8-.9-1.3c-.2-.4-.3-.9-.3-1.3s.1-.9.2-1.3c.2-.4.4-.8.7-1.1.2-.2.4-.4.6-.5.2-.1.4-.2.5-.3.2-.1.3-.2.4-.2s.2-.1.3-.1l.5 1c-.2 0-.4.1-.7.3-.3.2-.5.4-.8.6-.2.2-.4.5-.5.7-.1.3-.1.5-.1.8 0 .3.1.6.3.9.2.3.4.6.7.9.3.3.5.5.8.6.3.2.6.2.8.3s.6 0 .8-.1c.3-.1.5-.3.8-.6.3-.3.5-.6.7-.9.1-.3.2-.5.3-.6l1 .5c0 .1-.1.2-.1.3-.1.1-.1.3-.2.5s-.2.3-.3.5c-.2.2-.4.4-.6.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m551.8 310.3.8-.9 5.2 4.6-.8.9-2.3-2-2 2.3 2.3 2-.8.9-5.2-4.6.8-.9 2.1 1.8 2-2.3-2.1-1.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M562.1 308.7c-.3-.1-.5-.2-.8-.3-.3-.1-.5-.2-.8-.3l-1.8 2.3c.2.2.3.5.5.7s.3.5.5.7l-.8 1c-.4-.7-.8-1.3-1.1-1.8-.3-.6-.7-1.1-1-1.6-.3-.5-.6-1-.8-1.5-.3-.5-.5-1-.8-1.5l.7-.9c.5.1 1.1.3 1.6.4.5.1 1.1.3 1.7.5l1.8.6c.6.2 1.3.4 2.1.7l-1 1zm-5.6-1.9c.2.3.4.7.7 1.2l.9 1.5 1.4-1.8c-.6-.2-1.2-.4-1.7-.5-.5-.2-.9-.3-1.3-.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m564 306.4-5.6-4.1 2.6-3.5.9.6-1.9 2.5 1.4 1.1 1.7-2.2.9.6-1.7 2.2 2.4 1.8-.7 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m564.7 293.4.9.6-1.2 1.8 4.8 3.3-.7 1-4.8-3.3-1.2 1.8-.9-.6 3.1-4.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M591.8 234.9c.6.1 1.1.3 1.5.6.4.3.7.6 1 .9s.4.7.5 1.2c.1.4.1.9 0 1.3-.1.5-.2.9-.5 1.2-.2.4-.5.7-.9.9-.4.2-.8.4-1.3.5-.5.1-1 .1-1.6 0-.6-.1-1.1-.3-1.5-.6-.4-.3-.7-.6-1-.9-.2-.4-.4-.8-.5-1.2-.1-.4-.1-.9 0-1.3s.2-.9.5-1.2c.2-.4.5-.7.9-.9.4-.2.8-.4 1.3-.5.5-.2 1-.2 1.6 0zm-1 5.3c.4.1.7.1 1 .1.3 0 .6-.1.9-.2.2-.1.5-.3.6-.5.2-.2.3-.5.3-.8.1-.3.1-.6 0-.9s-.2-.5-.4-.7c-.2-.2-.4-.4-.7-.5-.3-.2-.6-.3-1-.3-.4-.1-.7-.1-1-.1-.3 0-.6.1-.9.2-.2.1-.5.3-.6.5-.2.2-.3.5-.3.8-.1.3-.1.6 0 .9s.2.5.4.7c.2.2.4.4.7.5.2.1.6.2 1 .3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M588.9 230.7c.2-1 .4-1.7.9-2.2.4-.5 1.1-.7 1.8-.5.4.1.7.2 1 .4.3.2.5.4.6.7.1.3.2.6.2 1.1 0 .4 0 .9-.1 1.4l-.1.6 2.4.4-.2 1.2-6.8-1v-1c.2-.5.3-.8.3-1.1zm1.1.1c0 .3-.1.6-.1.8l2.3.4.1-.6c.1-.6.1-1.1 0-1.4-.1-.3-.4-.6-.9-.6h-.6c-.2.1-.3.2-.4.3s-.2.3-.3.5-.1.3-.1.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m590.2 221.3 1.1.1-.2 2.1 5.8.6-.1 1.3-5.8-.6-.2 2.1-1.1-.1.5-5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m590.2 219.9.1-1.3 6.9.6-.1 1.3-6.9-.6z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M590.6 215.2c.3-.1.6-.3.9-.5.4-.2.8-.3 1.2-.5.4-.2.8-.3 1.3-.5.4-.2.8-.3 1.2-.5-.3-.2-.7-.4-1.1-.5l-1.2-.6c-.4-.2-.8-.4-1.1-.6-.4-.2-.7-.4-.9-.5v-1.1c.5 0 1-.1 1.6-.1.6 0 1.2-.1 1.8-.1h3.6l-.1 1.2h-2.5c-.9 0-1.7 0-2.5.1.2.1.3.2.5.3.2.1.4.2.7.3.2.1.5.2.8.4.3.1.5.3.8.4.2.1.5.2.7.3.2.1.4.2.5.3v.9c-.2.1-.3.1-.6.2-.2.1-.5.2-.7.3-.3.1-.5.2-.8.3s-.5.2-.8.3c-.2.1-.5.2-.7.3-.2.1-.4.2-.6.2.8.1 1.6.2 2.5.3.9.1 1.7.1 2.5.2v1.2c-.6-.1-1.2-.1-1.8-.2-.6-.1-1.2-.1-1.8-.2-.6-.1-1.2-.1-1.7-.2-.6-.1-1.1-.2-1.6-.2l-.1-1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="M590.8 207.7v-1.3h6.9v1.3h-6.9z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="m597.8 204.3-6.9.2-.1-4.5h1.1l.1 3.2 1.7-.1-.1-2.8h1l.1 2.8 2-.1-.1-3.4h1.1l.1 4.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M590.5 196.5c-.1-1 .1-1.8.4-2.3.3-.6.9-.9 1.6-.9.9-.1 1.6.4 2 1.3l.5-.5c.2-.2.4-.4.7-.5.2-.2.5-.4.8-.5.3-.2.5-.3.8-.5l.1 1.4c-.2.1-.5.3-.7.5-.2.2-.5.3-.7.5-.2.2-.4.3-.6.5-.2.2-.4.3-.5.4v1l2.6-.2.1 1.3-6.8.4c-.1-.3-.2-.6-.2-1-.1-.3-.1-.7-.1-.9zm1.1-.2c0 .3 0 .5.1.7l2.2-.1v-.5c0-.3-.1-.6-.1-.8 0-.2-.1-.4-.2-.6-.1-.2-.2-.3-.4-.3-.2-.1-.3-.1-.6-.1-.2 0-.4.1-.5.2-.1.1-.2.2-.3.4-.1.2-.1.3-.2.5v.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M597 188.3c.1.5 0 .9-.1 1.2-.1.4-.3.7-.5.9-.2.2-.5.4-.8.6s-.7.2-1.1.3l-4.3.5-.1-1.3 4.2-.5c.3 0 .6-.1.8-.2.2-.1.4-.2.5-.4.1-.1.2-.3.3-.5 0-.2.1-.4 0-.6 0-.2-.1-.4-.2-.6-.1-.2-.2-.3-.4-.4-.2-.1-.3-.2-.6-.2h-.8l-4.2.5-.1-1.3 4.3-.5h1.1c.3.1.6.2.9.4.3.2.5.5.7.8.2.4.3.8.4 1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M595.5 178.9c-.3.3-.7.6-1.1.9-.4.3-.8.7-1.2 1.1-.4.4-.8.7-1.1 1.1-.4.4-.7.7-1 1.1l4.9-.8.2 1.2-6.8 1.1-.2-1c.2-.3.5-.6.8-1 .3-.4.7-.7 1-1.1l1.1-1.1c.4-.4.7-.7 1-.9l-4.5.7-.2-1.2 6.8-1.1.3 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M588.5 173.7c.1.7.5 1.2 1 1.5.5.3 1.2.3 1.9.2.4-.1.7-.2 1-.3.3-.2.5-.3.7-.6.2-.2.3-.5.4-.8.1-.3.1-.6 0-.9 0-.2-.1-.4-.1-.6 0-.2-.1-.3-.1-.4l-2.4.5-.3-1.2 3.3-.7.4.8c.2.4.3.8.4 1.4.1.5.1 1 0 1.4-.1.4-.2.8-.5 1.2-.2.3-.6.6-1 .9-.4.2-.9.4-1.5.5s-1.1.1-1.6.1c-.5-.1-.9-.2-1.3-.5-.4-.2-.7-.5-.9-.9-.2-.4-.4-.8-.5-1.2-.1-.3-.1-.6-.1-.9v-.7c0-.2 0-.3.1-.5 0-.1.1-.2.1-.3l1.1.2c-.1.2-.1.5-.1.8-.1.4-.1.7 0 1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M526 82.6c.8.6 1.3 1.2 1.5 1.9s.1 1.2-.4 1.9c-.2.3-.5.6-.8.7-.3.1-.6.2-.9.2s-.7-.1-1-.3c-.4-.2-.8-.4-1.2-.7l-.5-.4-1.5 2-1-.8 4.2-5.5c.3.1.6.3.9.5.2.1.5.3.7.5zm-.6.9c-.3-.2-.5-.3-.7-.5l-1.4 1.9.5.4c.5.4.9.6 1.3.7.4.1.7-.1 1-.5.1-.2.2-.4.2-.5 0-.2 0-.3-.1-.5s-.2-.3-.3-.5c-.1-.2-.3-.4-.5-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m529.1 92.6-.7.8-3.4-2.8 4.4-5.3 1 .8-3.7 4.5 2.4 2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M532.7 97.3c.1-.3.2-.5.3-.8.1-.3.2-.5.3-.8l-2.2-2c-.3.1-.5.3-.8.4s-.5.3-.8.4l-1-.9c.7-.4 1.3-.7 1.9-1 .6-.3 1.2-.6 1.7-.9.5-.3 1.1-.5 1.6-.7.5-.2 1-.4 1.5-.7l.9.8c-.2.5-.3 1-.5 1.6-.2.5-.4 1.1-.6 1.6-.2.6-.4 1.2-.7 1.8-.2.6-.5 1.3-.8 2l-.8-.8zm2.2-5.5c-.4.2-.8.4-1.3.6-.5.2-1 .5-1.6.8l1.7 1.5c.2-.6.5-1.1.6-1.6.3-.5.5-1 .6-1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M537.6 102.1c.1-.4.2-.9.3-1.4.1-.5.2-1 .3-1.6.1-.5.2-1 .3-1.6s.1-1 .2-1.4l-3.5 3.5-.9-.9 4.9-4.9.7.7c0 .4 0 .8-.1 1.3s-.1 1-.2 1.5-.1 1-.2 1.5-.2 1-.3 1.4l3.2-3.3.9.9-4.9 4.9-.7-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M541.1 105.9c-.3-.3-.5-.7-.7-1s-.2-.7-.1-1c0-.3.1-.6.3-1 .2-.3.4-.6.7-.9l3.2-2.9.9.9-3.1 2.9c-.2.2-.4.4-.5.6-.1.2-.2.4-.2.6s0 .4.1.5c.1.2.2.3.3.5.1.2.3.3.5.4.2.1.4.1.5.1.2 0 .4 0 .6-.1.2-.1.4-.3.7-.5l3.1-2.9.9.9-3.2 2.9c-.3.3-.6.5-.9.6-.3.1-.6.2-1 .2-.3 0-.7-.1-1-.2-.5 0-.8-.2-1.1-.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M546.9 112.3c.1-.4.3-.9.5-1.4.2-.5.3-1 .5-1.5.1-.5.3-1 .4-1.5.1-.5.2-1 .3-1.4l-3.8 3.2-.8-.9 5.3-4.5.7.8c0 .4-.1.8-.2 1.3l-.3 1.5c-.1.5-.2 1-.4 1.5s-.3.9-.4 1.3l3.5-3 .8 1-5.3 4.5-.8-.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M555.2 113.2c-.4-.6-.9-.9-1.5-.9s-1.2.2-1.8.7c-.3.2-.5.5-.7.7-.2.3-.3.5-.4.8-.1.3-.1.6 0 .8.1.3.2.6.4.9.1.2.3.3.4.4l.3.3 2-1.5.8 1-2.7 2c-.2-.1-.4-.3-.7-.6-.3-.3-.6-.6-1-1.1-.3-.4-.5-.8-.6-1.2-.1-.4-.2-.9-.1-1.3s.2-.8.5-1.2.6-.8 1.1-1.1c.5-.4.9-.6 1.4-.7.5-.1.9-.2 1.3-.1s.8.2 1.2.4c.4.2.7.5 1 .9.2.3.4.5.5.7l.3.6c.1.2.1.3.1.5v.3l-1.1.3c0-.2-.1-.5-.2-.8s-.3-.5-.5-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M314.3 295.8c.6.8.9 1.5 1 2.2 0 .6-.3 1.2-.9 1.7-.3.2-.6.4-1 .5-.3.1-.6 0-.9-.1-.3-.1-.6-.3-.9-.5-.3-.3-.6-.6-.9-1l-.4-.5-1.9 1.5-.8-1 5.4-4.2c.2.2.5.4.7.7.2.3.4.5.6.7zm-.8.8c-.2-.3-.4-.5-.5-.6l-1.9 1.4.4.5c.4.5.7.8 1.1 1 .3.2.7.1 1.1-.2.2-.1.3-.3.4-.4.1-.2.1-.3.1-.5s-.1-.4-.2-.5c-.2-.3-.4-.5-.5-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M318.1 300.6c.6.8 1 1.5 1 2.1.1.6-.2 1.2-.8 1.7-.7.6-1.5.7-2.4.2 0 .2-.1.4-.2.7-.1.3-.1.5-.2.8l-.3.9c-.1.3-.2.6-.3.8l-.9-1.1c.1-.3.2-.5.3-.8s.2-.5.3-.8c.1-.3.2-.5.2-.8.1-.2.1-.5.2-.7l-.2-.2c0-.1-.1-.1-.1-.1l-.4-.5-2 1.7-.8-1 5.3-4.4c.2.2.5.4.7.7s.4.6.6.8zm-.8.8c-.2-.2-.3-.4-.5-.6l-1.7 1.4.4.4.6.6c.2.2.3.3.5.3.2.1.3.1.5 0s.3-.1.5-.3c.2-.1.3-.3.3-.4s.1-.3 0-.5c0-.2-.1-.3-.2-.5-.1-.1-.3-.2-.4-.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M322.5 310.9c-.4.4-.9.7-1.3.9-.5.2-.9.3-1.3.2-.4 0-.8-.1-1.2-.3-.4-.2-.7-.5-1-.8-.3-.3-.5-.7-.7-1.1-.2-.4-.2-.8-.2-1.3 0-.4.1-.9.3-1.3s.5-.9 1-1.3c.4-.4.9-.7 1.3-.9.5-.2.9-.2 1.3-.2s.8.1 1.2.3c.4.2.7.5 1 .8.3.3.5.7.7 1.1.2.4.2.8.2 1.3 0 .4-.1.9-.3 1.3-.2.5-.6.9-1 1.3zm-3.7-3.9c-.3.3-.5.5-.7.8-.2.3-.3.6-.3.8 0 .3 0 .5.1.8.1.3.2.5.4.8.2.2.4.4.7.5.3.1.5.2.8.1.3 0 .6-.1.9-.2.3-.1.6-.3.9-.6.3-.3.5-.5.7-.8.2-.3.3-.6.3-.8 0-.3 0-.5-.1-.8-.1-.3-.2-.5-.4-.7-.2-.2-.5-.4-.7-.5-.3-.1-.5-.1-.8-.1-.3 0-.6.1-.9.2-.3 0-.6.2-.9.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M328.3 313.2c-.3 0-.7 0-1.2.1s-1 .1-1.6.2c-.6.1-1.1.2-1.7.3-.6.1-1.1.2-1.6.4l2.6 2.6-.8.8-3.7-3.7.6-.6c.3-.1.6-.2.9-.2.3-.1.7-.2 1-.2.4-.1.7-.1 1.1-.2.4-.1.7-.1 1.1-.2s.7-.1 1-.1c.3 0 .6-.1.9-.1l-2.4-2.3.8-.8 3.5 3.5-.5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m325.1 318.5 4.7-5.1 3.3 3-.7.8-2.3-2.2-1.2 1.3 2.1 1.9-.7.8-2.1-1.9-1.4 1.5 2.5 2.3-.7.8-3.5-3.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M331.5 323c.3.3.6.5.9.5.3 0 .5-.1.7-.3.1-.1.2-.3.2-.4v-.4c0-.1-.1-.3-.2-.5l-.3-.6c-.1-.2-.2-.4-.3-.7-.1-.2-.2-.5-.2-.7 0-.2 0-.5.1-.7.1-.2.2-.5.4-.7.4-.5.9-.7 1.5-.7s1.1.3 1.7.8c.3.3.6.6.8.9.2.3.3.5.4.8l-1 .5c-.1-.2-.2-.5-.4-.7-.2-.2-.3-.4-.6-.6-.3-.2-.5-.3-.7-.4-.2 0-.4.1-.6.3-.1.1-.2.2-.2.4v.4c0 .1.1.3.1.5.1.2.2.3.2.5.2.3.3.6.4.9.1.3.2.5.2.8 0 .2 0 .5-.1.7-.1.2-.2.5-.4.7-.4.5-.9.7-1.5.7s-1.2-.3-1.8-.9l-.6-.6c-.2-.2-.3-.4-.4-.5-.1-.2-.2-.3-.2-.4-.1-.1-.1-.2-.1-.3l1-.5c.1.2.2.4.3.7.1-.1.3.2.7.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M335.9 326.6c.4.3.7.4.9.4.3 0 .5-.1.6-.3.1-.1.2-.3.2-.4v-.4c0-.2-.1-.3-.2-.5l-.3-.6c-.1-.2-.3-.4-.4-.7-.1-.2-.2-.4-.2-.7v-.7c.1-.2.2-.5.4-.7.4-.5.9-.7 1.4-.8.6 0 1.1.2 1.7.7.3.3.6.5.8.8.2.3.3.5.4.7l-.9.6c-.1-.2-.2-.5-.4-.7l-.6-.6c-.3-.2-.5-.3-.8-.3-.2 0-.4.1-.6.3-.1.1-.2.2-.2.4v.4c0 .1.1.3.2.4.1.2.2.3.3.5.2.3.3.6.5.8.1.3.2.5.2.8 0 .2 0 .5-.1.7-.1.2-.2.5-.4.7-.4.5-.9.7-1.4.7s-1.2-.3-1.8-.8c-.2-.2-.4-.4-.6-.5-.2-.2-.3-.3-.4-.5-.1-.2-.2-.3-.3-.4-.1-.1-.1-.2-.2-.3l.9-.6c.1.2.2.4.4.7.3.4.5.6.9.9z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m340.3 326.9 2.2 1.6-.7.9-2.2-1.6.7-.9z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M578.7 231.7c.2-1 .5-1.7.9-2.2.5-.5 1.1-.6 1.8-.5.9.2 1.5.7 1.7 1.7l.6-.3c.2-.1.5-.2.8-.4l.9-.3.9-.3-.2 1.4c-.3.1-.5.2-.8.3-.3.1-.5.2-.8.3-.3.1-.5.2-.7.3l-.6.3v.4l-.1.6 2.6.4-.2 1.2-6.8-1.2v-1c-.1-.2-.1-.5 0-.7zm1.1.1c0 .3-.1.5-.1.7l2.2.4.1-.5c.1-.3.1-.6.1-.8s0-.4-.1-.6c-.1-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.2h-.6c-.2 0-.3.1-.4.3-.1.1-.2.3-.3.5-.1.1-.1.3-.1.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M583.7 221.1c.6.1 1.1.2 1.5.5.4.2.8.5 1 .8.3.3.4.7.5 1.1.1.4.1.9.1 1.3-.1.5-.2.9-.4 1.3s-.5.7-.8 1c-.3.3-.7.5-1.2.6-.5.1-1 .2-1.6.1-.6-.1-1.1-.2-1.5-.5-.4-.2-.8-.5-1-.9-.3-.3-.5-.7-.6-1.1-.1-.4-.1-.9-.1-1.3.1-.4.2-.9.4-1.2.2-.4.5-.7.8-1 .3-.3.7-.5 1.2-.6.6-.1 1.1-.1 1.7-.1zm-.6 5.4h1c.3-.1.6-.2.8-.3.2-.1.4-.3.6-.6.1-.2.2-.5.3-.8 0-.3 0-.6-.1-.9-.1-.3-.2-.5-.4-.7-.2-.2-.4-.4-.7-.5s-.6-.2-1-.3h-1c-.3.1-.6.2-.8.3-.2.1-.4.3-.6.6s-.2.5-.3.8c0 .3 0 .6.1.9.1.3.2.5.4.7.2.2.4.4.7.5.2.2.6.3 1 .3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m580.7 214.9.1-1.3 6.9.4-.1 1.3-3.1-.2-.2 3 3.1.2-.1 1.3-6.9-.4.1-1.3 2.8.2.2-3-2.8-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M586.9 210.3c0-.5-.1-.8-.2-1s-.4-.3-.6-.3c-.2 0-.3 0-.4.1l-.3.3c-.1.1-.2.3-.3.5l-.3.6c-.1.2-.2.5-.3.7-.1.2-.2.4-.4.6-.2.2-.3.3-.6.4-.2.1-.5.1-.8.1-.6 0-1.1-.2-1.5-.7-.3-.4-.5-1-.5-1.8 0-.4.1-.8.2-1.2.1-.3.2-.6.3-.8l1 .4c-.1.2-.2.5-.3.7-.1.3-.1.5-.1.8 0 .3.1.6.2.8.1.2.3.3.6.3.2 0 .3 0 .4-.1.1-.1.2-.1.3-.3.1-.1.2-.2.3-.4.1-.2.2-.3.2-.5.1-.3.3-.6.4-.9.1-.3.3-.5.5-.6s.4-.3.6-.4c.2-.1.5-.1.8-.1.6 0 1.1.3 1.4.7.3.5.5 1.1.5 2 0 .3 0 .5-.1.8 0 .2-.1.4-.2.6-.1.2-.1.3-.2.5s-.1.2-.2.3l-1-.4c.1-.2.2-.4.3-.7.2-.2.2-.6.3-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M580.9 201.2h1.1v2.1l5.8-.1v1.3l-5.8.1v2.1h-1.1v-5.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M583.9 193.4c.6 0 1.1 0 1.6.2s.9.4 1.2.6.6.6.8 1c.2.4.3.8.3 1.3s0 .9-.1 1.3-.3.8-.6 1.1-.6.6-1.1.8c-.4.2-1 .3-1.5.4-.6 0-1.1 0-1.6-.2s-.9-.4-1.2-.7c-.3-.3-.6-.6-.8-1-.2-.4-.3-.8-.3-1.3s0-.9.1-1.3.3-.8.6-1.1c.3-.3.6-.6 1.1-.8.4-.1.9-.2 1.5-.3zm.3 5.4c.4 0 .7-.1 1-.2.3-.1.6-.3.8-.5.2-.2.4-.4.5-.7.1-.3.1-.5.1-.9 0-.3-.1-.6-.2-.8-.1-.2-.3-.4-.5-.6-.2-.2-.5-.3-.8-.4s-.7-.1-1-.1c-.4 0-.7.1-1 .2-.3.1-.6.3-.8.5-.2.2-.4.4-.5.7-.1.3-.1.5-.1.9 0 .3.1.6.2.8s.3.4.5.6.5.3.8.4c.3.1.6.1 1 .1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m587.2 191.3-6.9.8-.5-4.4 1.1-.1.3 3.1 1.8-.2-.3-2.8 1.1-.1.3 2.8 3-.3.1 1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m586.5 185.3-6.9 1-.6-4.3 1.1-.2.5 3.1 1.8-.3-.4-2.7 1.1-.2.4 2.7 3-.4v1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m582.3 180.4-.5-2.6 1.1-.2.5 2.6-1.1.2z" className="st3" />
    </g>
    <defs>
      <path id="SVGID_47_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_48_">
      <use
        xlinkHref="#SVGID_47_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <g
      style={{
        clipPath: "url(#SVGID_48_)",
      }}
    >
      <path
        d="M353.5 243.6c8.8 19.5 23.7 33.6 43.2 42.3m6.3 2.5c9.7 3.7 18.4 5.1 29.4 5.1 10.6 0 21.2-1.9 31.1-5.7m4.7-2 .6-.2c19.2-8.8 34.6-24.3 43.3-43.6v-.1m2.5-6.3c3.7-9.7 5.1-18.4 5.1-29.4 0-10.6-1.9-21.2-5.7-31.1m-2.7-6.3c-8.8-19.5-23.7-33.6-43.2-42.3m-73.1.7c-19.5 8.8-33.6 23.7-42.3 43.2m-2.6 6.4c-3.7 9.7-5.1 18.4-5.1 29.4 0 10.6 1.9 21.2 5.7 31.1"
        className="st34"
      />
      <path
        d="m353 183.9-2.9-7.1-6.9 3.4M392 134.3l3-7.1-7.2-2.4M504.3 165.8l7.1 3 2.4-7.3M511.8 228.5l2.9 7.1 6.8-3.4M471.2 278.8l-3 7 7.3 2.5M410.1 285.6l-7.1 2.8 3.4 6.9M360.5 246.5l-7-2.9-2.5 7.2M461.8 123.9c-9.7-3.7-18.4-5.1-29.4-5.1-10.2-.2-20.4 1.6-29.9 5.3"
        className="st34"
      />
      <path
        d="m454.7 126.8 7.1-2.9-3.4-6.9M404.5 129.4l-4-10.5"
        className="st34"
      />
      <path
        d="M386.5 203.9c0-.3-.1-.7-.2-1-.3-1.1-1.3-1.8-2.5-1.7-.4 0-.8.1-1.2.2-.3.1-.6.4-.8.6-.2.3-.4.6-.5.9-.1.3-.2.7-.2 1h5.4zm-9.5 1.6c0-1.1.1-2.3.5-3.3.3-.9.9-1.7 1.5-2.4.6-.6 1.4-1.1 2.2-1.5.8-.3 1.7-.5 2.5-.5 1.8-.1 3.6.6 4.9 1.8 1.3 1.5 1.9 3.5 1.8 5.5v1.6l-9.2.1c.1.8.5 1.6 1.2 2 .8.5 1.8.8 2.8.7.7 0 1.5-.1 2.2-.2.6-.1 1.2-.3 1.8-.5l.6 3.3-.9.3-1.2.3c-.4.1-.9.1-1.4.2s-1 .1-1.5.1c-1.2 0-2.3-.1-3.4-.5-.9-.3-1.7-.9-2.4-1.6-.6-.7-1.1-1.5-1.4-2.3-.4-1.1-.6-2.1-.6-3.1M398.3 212.6c-1 0-1.9-.1-2.9-.4-.7-.2-1.3-.5-1.8-1-.4-.4-.7-1-.9-1.6-.2-.7-.2-1.3-.2-2l-.1-15.7 4.1-.7.1 15.6c0 .3 0 .7.1 1 0 .3.2.5.3.7.2.2.4.4.7.5.4.1.8.2 1.2.2l-.6 3.4zM399.8 194.5l4.1-.7v4.2h4.9v3.4h-4.9v5c0 .7.1 1.4.5 2 .4.6 1.1.9 1.8.8.5 0 .9-.1 1.4-.1.4-.1.9-.2 1.3-.4l.6 3.1c-.5.2-1.1.4-1.6.5-.7.2-1.5.2-2.2.2-.9 0-1.9-.1-2.8-.4-.7-.3-1.3-.7-1.8-1.2-.5-.6-.8-1.2-.9-1.9-.2-.8-.3-1.7-.3-2.5l-.1-12zM415.8 209.3c.5 0 1.1 0 1.6-.2.3-.2.5-.5.5-.8 0-.4-.3-.7-.6-.9-.6-.3-1.2-.6-1.8-.8-.6-.2-1.2-.5-1.7-.7-.5-.2-.9-.5-1.3-.9-.4-.3-.7-.8-.9-1.2-.2-.6-.3-1.2-.3-1.8-.1-1.2.5-2.4 1.5-3.2 1.2-.9 2.6-1.3 4.1-1.2.8 0 1.7.1 2.5.2.6.1 1.3.3 1.9.5l-.7 3.2c-.5-.2-1-.3-1.5-.4-.6-.1-1.2-.2-1.9-.2-1.3 0-1.9.4-1.9 1.1 0 .2 0 .3.1.4.1.1.2.3.3.4.2.1.4.3.7.4.3.1.6.3 1.1.4.8.3 1.5.6 2.2 1 .5.3 1 .6 1.4 1 .3.3.6.8.7 1.2.1.5.2 1 .2 1.6.1 1.3-.5 2.5-1.6 3.2-1.4.8-2.9 1.2-4.5 1.1-1.1 0-2.1-.1-3.2-.3-.6-.1-1.2-.3-1.8-.5l.6-3.3c.7.3 1.4.5 2.1.6.8 0 1.5.1 2.2.1M423.9 212.1l-.2-20.4 4.1-.7.1 6.9c.3-.1.7-.2 1-.3.4-.1.8-.1 1.2-.1 1 0 2 .1 2.9.4.7.3 1.4.7 1.9 1.3.5.6.8 1.3 1 2.1.2.9.3 1.8.3 2.7l.1 8.1h-4.1l-.1-7.6c.1-1-.1-1.9-.5-2.8-.4-.6-1.2-.9-1.9-.8-.3 0-.7 0-1 .1l-.9.2.1 10.9h-4zM448.1 204.7c0-1-.2-2.1-.8-2.9-.5-.7-1.3-1.1-2.1-1.1-.9 0-1.7.4-2.1 1.1-.6.9-.8 1.9-.7 3-.1 1.1.2 2.1.8 3 .9 1.2 2.5 1.5 3.7.6l.6-.6c.4-.9.6-1.9.6-3.1m4.1.1c0 1-.1 2.1-.5 3.1-.3.9-.8 1.7-1.4 2.4-.6.7-1.4 1.2-2.2 1.6-1.9.7-3.9.7-5.8 0-.8-.3-1.6-.9-2.2-1.5-.6-.7-1.1-1.5-1.5-2.4-.4-1-.6-2-.5-3.1 0-1 .2-2.1.5-3.1.3-.9.8-1.7 1.5-2.4.6-.7 1.4-1.2 2.2-1.5 1.8-.7 3.9-.7 5.7 0 .8.3 1.6.8 2.2 1.5.6.7 1.1 1.5 1.5 2.4.3.9.5 2 .5 3M463.5 204.7c0-1.1-.3-2.1-.9-3-.6-.8-1.5-1.2-2.5-1.1h-1c-.3 0-.5.1-.8.1l.1 7.3c.3.2.6.3 1 .4.4.1.8.2 1.2.1 1.9.1 2.9-1.2 2.9-3.8m4.1-.2c0 1-.1 2-.4 3-.2.9-.6 1.6-1.2 2.4-.5.7-1.2 1.2-2 1.5-.8.4-1.8.6-2.7.6-.5 0-1.1 0-1.6-.1s-1-.3-1.4-.4v5.4h-4.1l-.2-18.8c.4-.1.8-.2 1.3-.3l1.5-.3c.5-.1 1-.1 1.6-.2s1-.1 1.5-.1c1.1 0 2.2.1 3.2.5.9.3 1.7.8 2.4 1.5s1.2 1.5 1.5 2.3c.4.9.6 2 .6 3"
        className="st1"
      />
      <path
        d="M482.3 211.9c-.4 0-.8 0-1.2-.1-.4 0-.8-.1-1.2-.2-.4-.1-.7-.2-1.1-.2-.3-.1-.5-.2-.8-.3l.6-2.6c.5.2.9.3 1.4.5.7.2 1.4.3 2.1.2.7.1 1.5-.1 2.1-.6.4-.4.7-.9.6-1.4 0-.3-.1-.7-.2-.9-.2-.3-.4-.5-.7-.6-.3-.2-.6-.3-1-.3-.4-.1-.8-.1-1.2-.1h-1.2v-2.5h1.4c.3 0 .6 0 .9-.1.3-.1.5-.1.8-.3.2-.1.4-.3.5-.5.1-.3.2-.6.2-.9 0-.2-.1-.5-.2-.7-.1-.2-.3-.4-.4-.5l-.6-.3c-.2-.1-.5-.1-.7-.1-.6 0-1.1.1-1.6.3-.5.2-.9.4-1.4.7l-1.1-2.2c.2-.1.5-.3.8-.4.3-.2.7-.3 1-.4.4-.1.8-.2 1.1-.3.4-.1.9-.1 1.3-.1.7 0 1.5.1 2.2.3.6.2 1.1.5 1.5.8.4.3.7.8.9 1.3.2.5.3 1.1.3 1.6 0 1.2-.7 2.3-1.7 2.9 1.5.5 2.4 1.9 2.4 3.5 0 .6-.1 1.2-.3 1.8-.2.6-.6 1.1-1 1.4-.5.4-1.1.8-1.8 1-.9.2-1.8.4-2.7.3M494.2 204.8c-.3 0-.7 0-1 .1-.3 0-.6.1-.8.2v.5c0 .5 0 .9.1 1.4.1.4.2.8.4 1.1.2.3.4.6.7.8.3.2.6.3 1 .3.3 0 .6-.1.9-.2.2-.1.4-.3.6-.6.2-.2.3-.5.4-.7.1-.3.1-.5.1-.8 0-.6-.2-1.2-.5-1.6-.7-.4-1.3-.6-1.9-.5m.3-2.4c.8 0 1.6.1 2.3.3.6.2 1.1.6 1.5 1 .4.4.7.9.9 1.4.2.6.3 1.2.3 1.8 0 .6-.1 1.2-.3 1.7-.2.6-.5 1.1-.9 1.6s-1 .9-1.5 1.2c-.7.3-1.5.5-2.2.5-1.5.1-3-.5-4-1.6-1-1.3-1.5-2.9-1.4-4.5 0-1.2.2-2.5.6-3.6.4-1 1-1.9 1.8-2.7.8-.8 1.8-1.3 2.9-1.7 1.2-.4 2.5-.6 3.8-.6 0 .4.1.9.1 1.2s.1.8.1 1.3c-.7 0-1.3.1-2 .2-.6.1-1.1.3-1.7.6-.5.3-.9.6-1.3 1s-.7.9-.9 1.4l.9-.3c.4-.1.7-.1 1-.2M507.3 207.2c0-.4-.1-.7-.3-1.1-.2-.3-.6-.6-.9-.8-.6-.2-1.2-.4-1.8-.5-.9-.1-1.9-.2-2.8-.1.1-1.3.3-2.6.3-3.9s.1-2.6.2-3.7l7.8-.1v2.6h-5.2c0 .5 0 1-.1 1.4s-.1.9-.1 1.2c1.6 0 3.2.5 4.5 1.4 1 .8 1.5 2.1 1.5 3.3 0 .6-.1 1.2-.3 1.8-.2.6-.6 1.1-1 1.5-.5.5-1.1.8-1.8 1-.8.3-1.7.4-2.5.4-.4 0-.8 0-1.2-.1-.4 0-.8-.1-1.2-.2s-.7-.1-1-.2c-.2-.1-.5-.1-.7-.2l.5-2.5c.4.2.9.3 1.4.4.7.1 1.3.2 2 .2.7.1 1.5-.2 2.1-.6.3-.2.5-.7.6-1.2"
        className="st12"
      />
    </g>
    <path d="m472.553 197.01.6-.005.13 14.9-.6.005z" className="st12" />
    <path d="m355.393 208.026 4.2-.037.042 4.9-4.2.037z" className="st1" />
    <defs>
      <path id="SVGID_49_" d="M45.5 7.3H794v585.9H45.5z" />
    </defs>
    <clipPath id="SVGID_50_">
      <use
        xlinkHref="#SVGID_49_"
        style={{
          overflow: "visible",
        }}
      />
    </clipPath>
    <path
      d="M359.5 206.9v-5.3c.2-.1.5-.1.7-.1.3 0 .5 0 .8-.1.7-.1 1.3.2 1.7.8.4.9.6 1.8.5 2.8v1.8h4.2v-2.1c0-.5 0-1-.1-1.5 0-.4-.1-.9-.3-1.3.3-.2.6-.3 1-.4.3-.1.6-.2.9-.2.7-.1 1.3.2 1.7.8.4.9.5 1.8.5 2.8v1.9h4.2v-2.3c0-.9-.1-1.8-.3-2.6-.1-.7-.5-1.4-.9-2.1-.5-.6-1.1-1.1-1.8-1.3-2.3-.8-4.9-.5-6.9.9-.5-.4-1-.7-1.6-.9-.8-.3-1.7-.4-2.5-.4-.5 0-1.1 0-1.6.1s-1.1.1-1.6.2l-1.5.3c-.5.1-.7.2-1.2.3l.1 8 4-.1z"
      className="st1"
      style={{
        clipPath: "url(#SVGID_50_)",
      }}
    />
    <path
      d="m363.193 207.926 4.2-.036.042 4.9-4.2.036zM370.993 207.826l4.2-.036.042 4.9-4.2.036z"
      className="st1"
    />
    <g className="st2">
      <path
        d="M401.9 368.8c-.5-.1-.8-.2-1.2-.4-.3-.2-.5-.4-.7-.7-.2-.3-.3-.6-.3-.9v-1.1l.8-4.2 1.2.2-.8 4.1c-.1.3-.1.6 0 .8s.1.4.2.6c.1.2.2.3.4.4.2.1.3.2.6.2h.6c.2 0 .4-.1.5-.2.2-.1.3-.3.4-.5.1-.2.2-.5.2-.8l.8-4.1 1.2.2-.8 4.2c-.1.4-.2.7-.4 1-.2.3-.4.6-.6.8-.3.2-.6.3-.9.4s-.7.1-1.2 0z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M410.9 370.1c-.2-.4-.4-.8-.6-1.3-.2-.5-.4-.9-.7-1.4s-.5-1-.7-1.4c-.2-.5-.5-.9-.7-1.2l-.7 4.9-1.2-.2 1-6.9 1 .1c.2.3.5.7.7 1.1.2.4.5.9.7 1.3.2.5.5.9.7 1.4.2.5.4.9.6 1.3l.7-4.6 1.2.2-1 6.9-1-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M419.9 367.5c-.1.6-.2 1.1-.4 1.5-.2.4-.5.8-.9 1-.4.3-.8.4-1.3.5-.5.1-1 .1-1.6.1-.3 0-.6-.1-.9-.1-.4-.1-.7-.1-1-.2l.7-6.7c.3 0 .7-.1 1 0 .4 0 .7 0 1 .1.6.1 1.1.2 1.6.4s.9.4 1.2.8c.3.3.5.7.7 1.2s0 .8-.1 1.4zm-4.9 2h.3c.1 0 .3 0 .5.1.8.1 1.5-.1 2-.5s.7-1 .8-1.7c.1-.8-.1-1.4-.4-1.9-.4-.5-1-.7-1.8-.8-.4 0-.6-.1-.8 0l-.6 4.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m423.3 371.2.3-6.9 4.4.2v1.1l-3.2-.1-.1 1.7 2.8.1v1l-2.8-.1-.1 2 3.4.1v1.1l-4.7-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="M429.5 364.5h1.3l-.1 6.9h-1.3l.1-6.9z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M437.1 371.4c-.2-.4-.5-.8-.8-1.2-.3-.4-.6-.9-.9-1.3-.3-.4-.6-.9-.9-1.3-.3-.4-.6-.8-.9-1.1l.1 5h-1.2l-.1-6.9h1c.3.3.6.6.9 1l.9 1.2.9 1.2c.3.4.6.8.8 1.1l-.1-4.6h1.2l.1 6.9h-1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M441.6 370.3c.5 0 .8-.1 1-.3.2-.2.3-.4.3-.7 0-.2-.1-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.5-.2-.2-.1-.4-.1-.7-.2-.2-.1-.5-.2-.7-.2-.2-.1-.4-.2-.6-.4-.2-.1-.3-.3-.4-.5-.1-.2-.2-.5-.2-.8 0-.6.2-1.1.6-1.5.4-.4 1-.6 1.7-.6.4 0 .8 0 1.2.1.3.1.6.2.8.3l-.3 1c-.2-.1-.5-.2-.8-.2s-.6-.1-.8-.1c-.3 0-.6.1-.8.3-.2.1-.3.4-.3.6 0 .2 0 .3.1.4l.3.3c.1.1.3.2.4.2s.3.1.5.2l.9.3c.3.1.5.2.7.4.2.2.3.4.4.6.1.2.2.5.2.8 0 .6-.2 1.1-.6 1.5s-1.1.6-1.9.6h-.8c-.2 0-.5-.1-.6-.1-.2 0-.3-.1-.5-.1-.1 0-.2-.1-.3-.1l.3-1c.2.1.4.2.7.3.3-.2.7-.2 1.1-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M450.4 370.5c-.1-.3-.2-.5-.4-.8-.1-.3-.3-.5-.4-.8l-2.9.3c-.1.3-.1.6-.2.9-.1.3-.1.6-.2.8l-1.3.1c.2-.8.4-1.5.5-2.1.2-.6.3-1.3.5-1.8.2-.6.3-1.1.5-1.7.2-.5.3-1.1.5-1.6l1.2-.1c.3.5.6.9.8 1.4.3.5.5 1 .8 1.5.3.5.6 1.1.9 1.7.3.6.6 1.3 1 2l-1.3.2zm-2.7-5.4c-.1.4-.2.8-.4 1.3-.1.5-.3 1.1-.5 1.7l2.3-.2c-.3-.6-.5-1.1-.8-1.6-.2-.4-.4-.9-.6-1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m455.9 362.8.1 1.1-2.1.3.8 5.8-1.3.2-.8-5.8-2.1.3-.1-1.1 5.5-.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M461.7 362.8c-.2.3-.4.6-.6 1.1-.2.4-.5.9-.7 1.4-.3.5-.5 1-.7 1.5l-.6 1.5 3.7-.6.2 1.1-5.2.9-.1-.8.3-.9c.1-.3.3-.6.4-1s.3-.7.5-1c.2-.3.3-.7.5-1 .2-.3.3-.6.5-.9.2-.3.3-.6.4-.8l-3.3.6-.2-1.1 4.9-.8v.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m462.7 365.2 2.6-.5.2 1.1-2.6.5-.2-1.1z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M388.6 354.3c.4.1.8.1 1 .1.2-.1.4-.3.5-.5 0-.2.1-.3 0-.4s-.1-.3-.2-.4c-.1-.1-.2-.3-.4-.4-.2-.1-.3-.3-.5-.4-.2-.2-.4-.3-.6-.5l-.5-.5c-.1-.2-.2-.4-.2-.6 0-.2 0-.5.1-.8.2-.6.5-1 1-1.2.5-.2 1.1-.2 1.8 0 .4.1.8.3 1.1.5.3.2.5.4.7.5l-.7.9c-.2-.2-.4-.3-.6-.5-.2-.1-.5-.2-.8-.3-.3-.1-.6-.1-.8 0-.2.1-.4.2-.4.5v.4c0 .1.1.2.2.4l.3.3c.1.1.3.2.4.3.3.2.5.4.7.6.2.2.4.4.5.6.1.2.2.4.2.7 0 .2 0 .5-.1.8-.2.6-.5 1-1 1.2-.5.2-1.2.2-2-.1-.3-.1-.5-.2-.7-.3l-.6-.3c-.2-.1-.3-.2-.4-.3-.1-.1-.2-.2-.3-.2l.6-.9c.1.1.4.3.6.5.3 0 .7.1 1.1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M395.2 357.2c-.5-.1-.9-.3-1.3-.6s-.6-.6-.8-.9c-.2-.4-.3-.8-.4-1.3 0-.5 0-1 .2-1.5.1-.6.4-1 .6-1.4s.6-.7 1-.9.8-.4 1.2-.4c.4-.1.9 0 1.3.1.3.1.5.2.7.3l.6.3c.2.1.3.2.4.3.1.1.2.1.2.2l-.6.9c-.1-.1-.3-.3-.6-.4-.3-.2-.6-.3-.9-.4-.3-.1-.6-.1-.9-.1s-.5.1-.8.3l-.6.6c-.2.3-.3.6-.4 1-.1.4-.1.7-.1 1 0 .3.1.6.2.9.1.3.3.5.5.7.2.2.5.3.9.4.4.1.8.2 1.1.1.3 0 .5 0 .7-.1l.1 1.1c-.1 0-.2.1-.4.1H396c-.3-.2-.5-.2-.8-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m404.1 351.9 1.2.3-1.4 6.8-1.2-.3.6-3-2.9-.6-.6 3-1.2-.3 1.4-6.8 1.2.3-.6 2.7 2.9.6.6-2.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M408.1 352.6c.1.3.2.6.3 1 .1.4.3.8.4 1.2.1.4.2.9.4 1.3l.3 1.2c.2-.3.4-.7.7-1.1s.5-.8.7-1.1c.2-.4.5-.7.7-1.1.2-.3.4-.6.6-.8l1.1.2c0 .5 0 1.1-.1 1.6 0 .6-.1 1.2-.1 1.8 0 .6-.1 1.2-.1 1.8-.1.6-.1 1.2-.2 1.8l-1.2-.2c.1-.8.2-1.6.3-2.5.1-.8.2-1.7.2-2.5-.1.1-.2.3-.3.5-.1.2-.3.4-.4.6-.1.2-.3.5-.5.7-.2.2-.3.5-.4.7-.1.2-.3.4-.4.6s-.2.4-.3.5l-.9-.1c0-.2-.1-.4-.2-.6-.1-.2-.1-.5-.2-.7-.1-.3-.1-.5-.2-.8-.1-.3-.2-.6-.2-.8-.1-.3-.1-.5-.2-.7-.1-.2-.1-.4-.2-.6-.2.8-.4 1.6-.5 2.4-.2.8-.3 1.7-.5 2.4l-1.2-.2c.1-.6.2-1.1.4-1.7.1-.6.3-1.2.4-1.8s.3-1.2.4-1.7.3-1.1.4-1.5l1 .2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m414.4 360.5.7-6.9 4.5.4-.1 1.1-3.2-.3-.2 1.7 2.8.3-.1 1.1-2.8-.3-.2 2 3.4.3-.1 1.1-4.7-.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m424.9 360.3-.1 1.1-4.4-.3.4-6.9 1.3.1-.4 5.8 3.2.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M430.9 355.5c-.2.2-.5.5-.8.9-.3.4-.7.8-1 1.2-.3.4-.7.9-1 1.4s-.6.9-.9 1.3l3.7.1v1.1l-5.2-.2v-.8c.1-.2.3-.5.5-.8l.6-.9c.2-.3.4-.6.7-.9.2-.3.4-.6.7-.9.2-.3.4-.6.6-.8.2-.3.4-.5.6-.7l-3.3-.1v-1.1l5 .1-.2 1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M434 354.5c1 0 1.8.2 2.3.5s.8.9.8 1.7c0 .4-.1.8-.2 1-.1.3-.3.5-.6.7-.3.2-.6.3-1 .4-.4.1-.8.1-1.3.2h-.6v2.4h-1.3l-.1-6.8c.3-.1.6-.1 1-.2.4.2.7.1 1 .1zm.1 1.1h-.8v2.4h.6c.6 0 1.1-.1 1.4-.3.3-.2.5-.5.5-1 0-.2-.1-.4-.1-.6-.1-.2-.2-.3-.4-.4-.2-.1-.3-.1-.5-.2-.2.1-.4.1-.7.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m442.9 360.1.1 1.1-4.4.2-.4-6.9 1.3-.1.3 5.8 3.1-.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M449.1 360.7c-.1-.3-.2-.5-.4-.8-.1-.3-.3-.5-.4-.8l-2.9.3c-.1.3-.1.6-.2.9-.1.3-.1.6-.2.8l-1.3.1c.2-.8.4-1.5.5-2.1.2-.6.3-1.3.5-1.8.2-.6.3-1.1.5-1.7.2-.5.3-1.1.5-1.6l1.2-.1c.3.5.6.9.8 1.4s.5 1 .8 1.5c.3.5.6 1.1.9 1.7.3.6.6 1.3 1 2l-1.3.2zm-2.6-5.4c-.1.4-.2.8-.4 1.3-.1.5-.3 1.1-.5 1.7l2.3-.2c-.3-.6-.5-1.1-.8-1.6-.2-.5-.4-.9-.6-1.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M456.2 359.7c-.3-.3-.6-.7-.9-1.1-.3-.4-.7-.8-1.1-1.2-.4-.4-.7-.8-1.1-1.1l-1-1 .7 4.9-1.2.2-1-6.9 1-.1c.3.2.6.5 1 .9.4.3.7.7 1.1 1l1.1 1.1c.3.4.7.7.9 1l-.7-4.6 1.2-.2 1 6.9-1 .2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M461.7 359c-.5.1-.9.1-1.2 0-.4-.1-.7-.2-.9-.4-.3-.2-.5-.5-.7-.8s-.3-.7-.4-1l-.8-4.2 1.2-.2.8 4.1c.1.3.1.6.3.8s.2.4.4.5.3.2.5.2h.6c.2 0 .4-.1.6-.2.2-.1.3-.2.4-.4.1-.2.2-.4.2-.6 0-.2 0-.5-.1-.8l-.8-4.1 1.2-.2.8 4.3c.1.4.1.8 0 1.1 0 .3-.2.7-.3.9-.2.3-.4.5-.7.7s-.7.2-1.1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m470.4 356.9-1-1c-.3-.3-.8-.7-1.2-1.1-.4-.4-.8-.7-1.2-1s-.8-.6-1.1-.9l1.2 4.8-1.2.3-1.6-6.7 1-.2c.3.2.7.5 1.1.8l1.2.9c.4.3.8.7 1.2 1 .4.3.7.7 1 .9l-1.1-4.5 1.2-.3 1.6 6.7-1.1.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M474.6 349.5c-.7.2-1.1.6-1.4 1.1-.2.5-.2 1.2 0 1.9.1.4.2.7.4.9.2.3.4.5.6.7.2.2.5.3.8.3s.6 0 .9-.1c.2-.1.4-.1.5-.2.1-.1.3-.1.3-.2l-.7-2.4 1.2-.4.9 3.2c-.1.1-.4.3-.8.5s-.8.4-1.3.5c-.5.1-.9.2-1.4.2-.4 0-.8-.2-1.2-.4-.4-.2-.7-.5-1-.9-.3-.4-.5-.9-.7-1.4-.2-.6-.2-1.1-.2-1.6s.2-.9.4-1.3.5-.7.8-1c.4-.3.8-.5 1.2-.6.3-.1.6-.2.8-.2h1.2c.2 0 .2 0 .3.1l-.1 1.1c-.2-.1-.5-.1-.8-.1-.1.2-.4.3-.7.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M401.5 378.7c-.4-.1-.7-.1-1.1-.2-.4-.1-.7-.2-.9-.3l1.1-6.7h1c.2 0 .3 0 .5.1.2 0 .3 0 .5.1.4.1.8.2 1.1.3s.6.3.9.5c.2.2.4.4.5.7.1.3.1.6.1.9-.1.3-.2.6-.4.8-.2.2-.4.4-.7.4.4.2.7.5.8.8.2.3.2.7.1 1.1-.1.7-.5 1.2-1 1.5-.6.2-1.4.2-2.5 0zm-.3-3.3-.4 2.1c.1 0 .3.1.4.1.2 0 .3.1.4.1.3 0 .5.1.7.1.2 0 .4 0 .6-.1s.3-.1.4-.3c.1-.1.2-.3.2-.5.1-.4 0-.7-.3-.9-.3-.2-.6-.3-1.1-.4l-.9-.2zm.2-1 .9.2c.5.1.9.1 1.2 0 .3-.1.5-.3.5-.7.1-.3 0-.6-.3-.8-.3-.2-.6-.3-1.1-.4-.2 0-.4-.1-.5-.1h-.4l-.3 1.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m406.1 379.4.9-6.9 4.4.6-.1 1.1-3.2-.4-.2 1.7 2.8.4-.1 1-2.8-.4-.3 2 3.4.5-.1 1.1-4.7-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M414.6 373.4c1 .1 1.7.4 2.2.8.5.4.7 1 .6 1.8-.1.9-.6 1.5-1.6 1.8.1.2.2.4.4.6.1.2.3.5.4.8.1.3.3.6.4.8.1.3.2.6.3.8l-1.4-.1c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.4-.8-.1-.2-.3-.5-.4-.7-.1-.2-.2-.4-.4-.6h-.4l-.6-.1-.3 2.6-1.3-.1.7-6.8h2.1zm0 1.1h-.7l-.2 2.2.5.1h.8c.2 0 .4-.1.6-.1.2-.1.3-.2.4-.3.1-.1.2-.3.2-.5s0-.4-.1-.6c-.1-.2-.2-.3-.3-.4-.1-.1-.3-.2-.5-.2-.2-.1-.4-.2-.7-.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m418.6 380.9.4-6.9 4.4.3-.1 1.1-3.2-.2-.1 1.7 2.8.2-.1 1-2.8-.2-.1 2 3.4.2-.1 1.1-4.5-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M427.7 381.5c-.5 0-1-.1-1.4-.3-.4-.2-.8-.4-1-.7-.3-.3-.5-.7-.6-1.2-.1-.5-.2-1-.2-1.5s.1-1.1.3-1.5c.2-.4.4-.8.8-1.1.3-.3.7-.5 1.1-.7.4-.1.9-.2 1.3-.2.3 0 .5 0 .8.1.2.1.4.1.6.2.2.1.3.1.4.2.1.1.2.1.2.1l-.4 1c-.2-.1-.4-.2-.7-.3s-.6-.2-1-.2c-.3 0-.6 0-.8.1s-.5.2-.7.4c-.2.2-.4.5-.5.8-.1.3-.2.7-.2 1.1 0 .4 0 .7.1 1 .1.3.2.6.4.8s.4.4.6.5c.3.1.6.2 1 .2s.8 0 1.1-.1c.3-.1.5-.2.7-.2l.3 1c-.1.1-.2.1-.3.2-.1 0-.3.1-.5.1s-.4.1-.6.1c-.3.1-.5.1-.8.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M435.3 374.4h1.3v6.9h-1.3v-3.1h-3v3.1H431v-6.9h1.3v2.8h3v-2.8z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M443 381.1c-.2-.4-.5-.8-.8-1.2-.3-.4-.6-.8-.9-1.3-.3-.4-.6-.8-1-1.2-.3-.4-.6-.8-.9-1.1l.2 5-1.2.1-.3-6.9 1-.1c.3.3.6.6.9 1 .3.4.7.8 1 1.1.3.4.7.8 1 1.2.3.4.6.8.8 1.1l-.2-4.6 1.2-.1.3 6.9-1.1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M448.5 380.8c-.5 0-.9 0-1.2-.1s-.6-.3-.9-.5-.4-.5-.6-.8c-.1-.3-.2-.7-.3-1.1l-.4-4.3 1.3-.1.4 4.2c0 .3.1.6.2.8.1.2.2.4.3.5.1.1.3.2.5.3.2.1.4.1.6 0 .2 0 .4-.1.6-.2.2-.1.3-.2.4-.3.1-.2.2-.3.3-.6.1-.2.1-.5 0-.8l-.4-4.2 1.3-.1.4 4.3c0 .4 0 .8-.1 1.1s-.2.6-.4.9c-.2.3-.5.5-.8.6-.3.3-.7.4-1.2.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M457.4 379.6c-.3-.3-.6-.7-.9-1.1-.3-.4-.7-.8-1-1.2-.4-.4-.7-.8-1.1-1.2l-1-1 .6 4.9-1.2.2-.9-6.9 1-.1c.3.2.6.5 1 .9.4.3.7.7 1.1 1.1l1.1 1.1c.3.4.6.7.9 1.1l-.6-4.6 1.2-.2.9 6.9-1.1.1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M462.4 372.7c-.7.1-1.2.4-1.5.9-.3.5-.4 1.1-.2 1.9.1.4.2.7.3 1 .1.3.3.5.5.7.2.2.5.3.7.4.3.1.6.1.9 0 .2 0 .4-.1.6-.1.2 0 .3-.1.4-.1l-.4-2.5 1.2-.2.6 3.3-.8.4c-.4.1-.9.3-1.4.4-.5.1-1 .1-1.4 0s-.8-.3-1.2-.5c-.3-.3-.6-.6-.9-1-.2-.4-.4-.9-.5-1.5-.1-.6-.1-1.1 0-1.6s.3-.9.5-1.2c.2-.4.6-.7.9-.9.4-.2.8-.4 1.3-.5.3-.1.6-.1.9-.1h.7c.2 0 .3.1.5.1s.2.1.3.1l-.2 1.1c-.2-.1-.5-.1-.8-.2-.3.1-.6.1-1 .1z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M518.7 327c.3.1.6.3.9.5s.7.4 1.1.6c.4.2.8.4 1.2.7.4.2.8.4 1.1.6l-.3-1.2c-.1-.4-.2-.9-.3-1.3-.1-.4-.2-.9-.2-1.3-.1-.4-.1-.7-.1-1l.9-.7c.3.4.7.8 1.1 1.2s.8.9 1.1 1.3c.4.5.8.9 1.2 1.4s.8.9 1.1 1.4l-1 .7c-.5-.6-1-1.3-1.5-2s-1.1-1.3-1.6-1.9c0 .2.1.4.1.6 0 .2.1.5.2.8.1.3.1.5.2.8s.1.6.2.8c.1.3.1.5.2.7.1.2.1.4.1.6l-.8.6c-.1-.1-.3-.2-.5-.3-.2-.1-.4-.3-.7-.4s-.5-.3-.7-.4c-.3-.1-.5-.3-.7-.4-.2-.1-.5-.3-.7-.4-.2-.1-.4-.2-.5-.3.4.7.8 1.4 1.3 2.1.5.7.9 1.4 1.4 2.1l-1 .7c-.3-.5-.6-1-1-1.5-.3-.5-.7-1-1-1.5l-.9-1.5c-.3-.5-.5-.9-.8-1.4l.9-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M532.7 325c-.2-.2-.5-.3-.7-.4-.2-.1-.5-.3-.7-.5L529 326c.1.3.2.5.3.8.1.3.2.5.3.8l-1 .8c-.3-.7-.5-1.4-.7-2.1l-.6-1.8c-.2-.6-.3-1.1-.5-1.7-.2-.5-.3-1.1-.4-1.6l.9-.8c.5.2 1 .5 1.5.7.5.3 1 .5 1.5.8.5.3 1.1.6 1.7.9s1.2.7 1.9 1.1l-1.2 1.1zm-5.1-3.1c.1.4.2.8.4 1.3s.4 1.1.6 1.7l1.8-1.4c-.5-.3-1.1-.6-1.5-.9-.6-.3-1-.5-1.3-.7z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m533.3 315.2.7.8-1.6 1.4 3.9 4.3-.9.8-3.9-4.3-1.6 1.4-.7-.8 4.1-3.6z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m539.1 319.2-4.8-5 3.2-3.1.7.8-2.3 2.2 1.2 1.2 2-2 .7.8-2 2 1.4 1.5 2.5-2.4.7.8-3.3 3.2z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="M539.9 308.5c.7-.7 1.3-1.2 2-1.3.6-.1 1.2.1 1.8.6.7.6.8 1.4.4 2.3.2 0 .4 0 .7.1.3 0 .6.1.9.1s.6.1.9.2c.3.1.6.2.9.2l-1 1c-.3-.1-.5-.1-.8-.2-.3-.1-.6-.1-.8-.2-.3 0-.5-.1-.8-.1-.2 0-.5-.1-.7-.1l-.2.2-.1.1-.4.4 1.9 1.8-.9.9-5-4.7c.2-.3.4-.5.6-.8s.5-.3.6-.5zm.9.7c-.2.2-.3.4-.5.6l1.6 1.5.4-.4c.2-.2.4-.4.5-.6.1-.2.2-.4.3-.5v-.5c-.1-.2-.2-.3-.3-.5-.2-.1-.3-.2-.5-.3s-.3 0-.5 0-.3.1-.5.3c-.2 0-.3.2-.5.4z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m543.3 305 .8-.9 5.2 4.6-.8.9-5.2-4.6z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M553.7 303.4c-.3-.1-.5-.2-.8-.3-.3-.1-.5-.2-.8-.3l-1.9 2.3c.2.2.3.5.5.7.1.2.3.5.4.7l-.8 1c-.4-.7-.8-1.3-1.1-1.9-.3-.6-.7-1.1-.9-1.7-.3-.5-.6-1-.8-1.5-.3-.5-.5-1-.7-1.5l.8-.9c.5.1 1.1.3 1.6.4.5.2 1.1.3 1.7.5l1.8.6c.6.2 1.3.5 2.1.7l-1.1 1.2zm-5.6-2c.2.3.4.8.7 1.2l.9 1.5 1.4-1.8c-.6-.2-1.2-.4-1.7-.6-.5 0-1-.2-1.3-.3z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path
        d="m557.3 296.9.9.7-2.6 3.5-5.5-4.2.8-1 4.7 3.5 1.7-2.5z"
        className="st3"
      />
    </g>
    <g className="st2">
      <path d="m555.8 295 1.6-2.2.9.6-1.6 2.2-.9-.6z" className="st3" />
    </g>
    <g className="st2">
      <path
        d="M607 77.3v-6.9h4.5v1.1h-3.2v1.7h2.8v1.1h-2.8v2h3.4v1.1H607zM614.8 70.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .9-.5 1.6-1.4 1.9.1.2.3.3.4.6.2.2.3.5.5.7.2.3.3.5.5.8.2.3.3.5.4.8h-1.4c-.1-.2-.3-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.7-.1-.2-.3-.4-.4-.5h-1v2.6H613v-6.8c.3-.1.6-.1 1-.1s.5-.1.8-.1zm.1 1.1h-.7v2.2h.5c.3 0 .6 0 .8-.1.2 0 .4-.1.6-.2.2-.1.3-.2.4-.3s.1-.3.1-.6c0-.2 0-.4-.1-.5-.1-.1-.2-.3-.3-.3-.2-.1-.3-.1-.5-.2h-.8zM621.2 70.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .4-.1.8-.2 1s-.4.5-.6.7c-.3.2-.6.3-1 .4-.4.1-.8.1-1.3.1h-.6v2.4h-1.3v-6.8c.3-.1.6-.1 1-.1.3.1.6.1.9.1zm.1 1.1h-.8v2.4h.6c.6 0 1.1-.1 1.4-.3.3-.2.5-.5.5-1 0-.2 0-.4-.1-.6s-.2-.3-.4-.4-.3-.1-.5-.2c-.2.1-.4.1-.7.1z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M611.6 89.3c-.1-.3-.2-.5-.3-.8s-.2-.5-.3-.8h-2.9c-.1.3-.2.6-.3.8-.1.3-.2.5-.3.8h-1.3c.3-.7.5-1.4.7-2 .2-.6.5-1.2.7-1.8.2-.6.4-1.1.7-1.6s.4-1 .7-1.5h1.2c.2.5.5 1 .7 1.5s.4 1 .7 1.6c.2.6.5 1.2.7 1.8.2.6.5 1.3.7 2h-1.4zm-2-5.6c-.2.4-.3.8-.5 1.3s-.4 1.1-.6 1.6h2.3c-.2-.6-.4-1.1-.6-1.7-.3-.4-.5-.8-.6-1.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M616.7 89.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6s-.4-.5-.5-.9-.2-.7-.2-1.1v-4.3h1.3v4.2c0 .3 0 .6.1.8.1.2.2.4.3.5s.3.2.5.3c.2.1.4.1.6.1s.4 0 .6-.1c.2-.1.3-.2.5-.3.1-.1.2-.3.3-.5.1-.2.1-.5.1-.8v-4.2h1.3v4.3c0 .4-.1.8-.2 1.1-.1.3-.3.6-.5.9-.2.2-.5.4-.9.6s-.8.2-1.3.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M621.1 89.3v-6.9h4.4v1.1h-3.1v1.8h2.8v1.1h-2.8v3h-1.3z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M631.9 82.4v1.1h-2.1v5.8h-1.3v-5.8h-2.1v-1.1h5.5z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M635.1 82.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .9-.5 1.6-1.4 1.9.1.2.3.3.4.6.2.2.3.5.5.7.2.3.3.5.5.8.2.3.3.5.4.8h-1.4c-.1-.2-.3-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.7-.1-.2-.3-.4-.4-.5h-1v2.6h-1.3v-6.8c.3-.1.6-.1 1-.1s.5-.1.8-.1zm.1 1.1h-.7v2.2h.5c.3 0 .6 0 .8-.1.2 0 .4-.1.6-.2.2-.1.3-.2.4-.3s.1-.3.1-.6c0-.2 0-.4-.1-.5-.1-.1-.2-.3-.3-.3-.2-.1-.3-.1-.5-.2h-.8z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M644.8 89.3c-.1-.3-.2-.5-.3-.8s-.2-.5-.3-.8h-2.9c-.1.3-.2.6-.3.8-.1.3-.2.5-.3.8h-1.3c.3-.7.5-1.4.7-2 .2-.6.5-1.2.7-1.8.2-.6.4-1.1.7-1.6s.4-1 .7-1.5h1.2c.2.5.5 1 .7 1.5s.4 1 .7 1.6c.2.6.5 1.2.7 1.8.2.6.5 1.3.7 2h-1.4zm-3.1-7.7c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.3.1.5.2.2.3.2.5-.1.4-.2.5c-.2.2-.3.2-.5.2zm1 2.1c-.2.4-.3.8-.5 1.3s-.4 1.1-.6 1.6h2.3c-.2-.6-.4-1.1-.6-1.7l-.6-1.2zm1.1-2.1c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s.1-.4.2-.5.3-.2.5-.2.3.1.5.2c.1.1.2.3.2.5s-.1.4-.2.5c-.2.2-.4.2-.5.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M650.4 83.3c-.7 0-1.3.2-1.6.7-.4.4-.6 1.1-.6 1.8 0 .4 0 .7.1 1 .1.3.2.6.4.8.2.2.4.4.7.5.3.1.6.2.9.2h.6c.2 0 .3 0 .4-.1v-2.5h1.3V89c-.2.1-.5.1-.9.2s-.9.1-1.4.1c-.5 0-1-.1-1.4-.2-.4-.2-.8-.4-1.1-.7s-.5-.7-.7-1.1c-.2-.4-.2-1-.2-1.5s.1-1.1.3-1.5c.2-.4.4-.8.7-1.1.3-.3.7-.5 1.1-.7.4-.2.9-.2 1.3-.2.3 0 .6 0 .9.1.2 0 .5.1.6.1.2.1.3.1.4.2.1.1.2.1.2.1l-.4 1c-.2-.1-.4-.2-.7-.3-.3-.1-.6-.2-.9-.2zM654 89.3v-6.9h4.5v1.1h-3.2v1.7h2.8v1.1h-2.8v2h3.4v1.1H654z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M180.9 77.3v-6.9h4.4v1.1h-3.2v1.7h2.8v1.1h-2.8v2h3.4v1.1h-4.6zM188.6 70.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .9-.5 1.6-1.4 1.9.1.2.3.3.4.6.2.2.3.5.5.7s.3.5.5.8c.2.3.3.5.4.8h-1.4c-.1-.2-.3-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.7-.1-.2-.3-.4-.4-.5H188v2.6h-1.3v-6.8c.3-.1.6-.1 1-.1s.7-.1.9-.1zm.1 1.1h-.7v2.2h.6c.3 0 .6 0 .8-.1.2 0 .4-.1.6-.2.2-.1.3-.2.4-.3s.1-.3.1-.6c0-.2 0-.4-.1-.5-.1-.1-.2-.3-.3-.3s-.3-.1-.5-.2h-.9zM195.1 70.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .4-.1.8-.2 1-.1.3-.4.5-.6.7-.3.2-.6.3-1 .4-.4.1-.8.1-1.3.1h-.6v2.4h-1.3v-6.8c.3-.1.6-.1 1-.1.3.1.6.1.9.1zm.1 1.1h-.8v2.4h.6c.6 0 1.1-.1 1.4-.3s.5-.5.5-1c0-.2 0-.4-.1-.6-.1-.2-.2-.3-.4-.4s-.3-.1-.5-.2c-.2.1-.5.1-.7.1z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M207.1 77.3c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8h-2.9c-.1.3-.2.6-.3.8-.1.3-.2.5-.3.8h-1.3c.3-.7.5-1.4.7-2s.5-1.2.7-1.8c.2-.6.4-1.1.7-1.6s.4-1 .7-1.5h1.2c.2.5.5 1 .7 1.5.2.5.4 1 .7 1.6.2.6.5 1.2.7 1.8s.5 1.3.7 2h-1.4zm-2.1-5.6c-.2.4-.3.8-.5 1.3s-.4 1.1-.6 1.6h2.3c-.2-.6-.4-1.1-.6-1.7-.3-.4-.4-.8-.6-1.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M212.1 77.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9s-.2-.7-.2-1.1v-4.3h1.3v4.2c0 .3 0 .6.1.8.1.2.2.4.3.5s.3.2.5.3c.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.3-.2.5-.3.1-.1.2-.3.3-.5s.1-.5.1-.8v-4.2h1.3v4.3c0 .4-.1.8-.2 1.1s-.3.6-.5.9c-.2.2-.5.4-.9.6s-.8.2-1.3.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M216.5 77.3v-6.9h4.4v1.1h-3.1v1.8h2.8v1.1h-2.8v3h-1.3z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M227.3 70.4v1.1h-2.1v5.8h-1.3v-5.8h-2.1v-1.1h5.5z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M230.5 70.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .9-.5 1.6-1.4 1.9.1.2.3.3.4.6.2.2.3.5.5.7s.3.5.5.8c.2.3.3.5.4.8h-1.4c-.1-.2-.3-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.7-.1-.2-.3-.4-.4-.5h-1v2.6h-1.3v-6.8c.3-.1.6-.1 1-.1s.6-.1.8-.1zm.1 1.1h-.7v2.2h.6c.3 0 .6 0 .8-.1.2 0 .4-.1.6-.2.2-.1.3-.2.4-.3s.1-.3.1-.6c0-.2 0-.4-.1-.5-.1-.1-.2-.3-.3-.3s-.3-.1-.5-.2h-.9z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M240.2 77.3c-.1-.3-.2-.5-.3-.8-.1-.3-.2-.5-.3-.8h-2.9c-.1.3-.2.6-.3.8-.1.3-.2.5-.3.8h-1.3c.3-.7.5-1.4.7-2s.5-1.2.7-1.8c.2-.6.4-1.1.7-1.6s.4-1 .7-1.5h1.2c.2.5.5 1 .7 1.5.2.5.4 1 .7 1.6.2.6.5 1.2.7 1.8s.5 1.3.7 2h-1.4zm-2-5.6c-.2.4-.3.8-.5 1.3s-.4 1.1-.6 1.6h2.3c-.2-.6-.4-1.1-.6-1.7-.3-.4-.5-.8-.6-1.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M245.8 71.3c-.7 0-1.3.2-1.6.7-.4.4-.6 1.1-.6 1.8 0 .4 0 .7.1 1 .1.3.2.6.4.8.2.2.4.4.7.5s.6.2.9.2h.6c.2 0 .3 0 .4-.1v-2.5h1.3V77c-.2.1-.5.1-.9.2s-.9.1-1.4.1c-.5 0-1-.1-1.4-.2-.4-.2-.8-.4-1.1-.7s-.5-.7-.7-1.1c-.2-.4-.2-1-.2-1.5s.1-1.1.3-1.5c.2-.4.4-.8.7-1.1.3-.3.7-.5 1.1-.7.4-.2.9-.2 1.3-.2.3 0 .6 0 .9.1.2 0 .5.1.6.1s.3.1.4.2.2.1.2.1l-.4 1c-.2-.1-.4-.2-.7-.3-.3-.1-.6-.2-.9-.2z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M251.3 76.4c.5 0 .8-.1 1-.2s.3-.4.3-.7c0-.2 0-.3-.1-.4l-.3-.3c-.1-.1-.3-.2-.5-.3-.2-.1-.4-.2-.6-.2-.2-.1-.5-.2-.7-.3-.2-.1-.4-.2-.6-.4s-.3-.3-.4-.5c-.1-.2-.2-.5-.2-.8 0-.6.2-1.1.6-1.5.4-.4 1-.5 1.8-.5.4 0 .8 0 1.2.1.3.1.6.2.8.3l-.4 1c-.2-.1-.5-.2-.7-.3-.3-.1-.5-.1-.8-.1-.3 0-.6.1-.8.2s-.3.3-.3.6c0 .2 0 .3.1.4l.3.3c.1.1.3.2.4.2.2.1.3.1.5.2.3.1.6.2.9.4.3.1.5.3.7.4.2.2.3.4.4.6.1.2.1.5.1.8 0 .6-.2 1.1-.7 1.5-.4.3-1.1.5-1.9.5-.3 0-.5 0-.8-.1-.2 0-.4-.1-.6-.1-.2-.1-.3-.1-.5-.2-.1-.1-.2-.1-.3-.2l.4-1c.2.1.4.2.7.3.2.2.5.3 1 .3z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path d="M255.1 73.9h2.7V75h-2.7v-1.1z" className="st1" />
    </g>
    <g className="st2">
      <path
        d="M182.8 82.3c1 0 1.8.2 2.3.5.5.4.8.9.8 1.7 0 .9-.5 1.6-1.4 1.9.1.2.3.3.4.6.2.2.3.5.5.7s.3.5.5.8c.2.3.3.5.4.8h-1.4c-.1-.2-.3-.5-.4-.7-.1-.2-.3-.5-.4-.7-.1-.2-.3-.4-.4-.7-.1-.2-.3-.4-.4-.5h-1v2.6H181v-6.8c.3-.1.6-.1 1-.1s.5-.1.8-.1zm.1 1.1h-.7v2.2h.6c.3 0 .6 0 .8-.1.2 0 .4-.1.6-.2.2-.1.3-.2.4-.3s.1-.3.1-.6c0-.2 0-.4-.1-.5-.1-.1-.2-.3-.3-.3s-.3-.1-.5-.2h-.9z"
        className="st1"
      />
    </g>
    <g className="st2">
      <path
        d="M190.1 89.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9s-.2-.7-.2-1.1v-4.3h1.3v4.2c0 .3 0 .6.1.8.1.2.2.4.3.5s.3.2.5.3c.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.3-.2.5-.3.1-.1.2-.3.3-.5s.1-.5.1-.8v-4.2h1.3v4.3c0 .4-.1.8-.2 1.1s-.3.6-.5.9c-.2.2-.5.4-.9.6s-.8.2-1.3.2zm-1-7.9c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s.1-.4.2-.5.3-.2.5-.2.3.1.5.2.2.3.2.5-.1.4-.2.5c-.1.2-.3.2-.5.2zm2.1 0c-.2 0-.3-.1-.5-.2-.1-.1-.2-.3-.2-.5s.1-.4.2-.5c.1-.1.3-.2.5-.2s.3.1.5.2.2.3.2.5-.1.4-.2.5c-.2.2-.3.2-.5.2zM197.6 89.5c-.5 0-1-.1-1.4-.2-.4-.2-.8-.4-1-.7-.3-.3-.5-.7-.7-1.1-.2-.4-.2-1-.2-1.5s.1-1.1.3-1.5c.2-.4.4-.8.7-1.1.3-.3.7-.5 1.1-.7.4-.2.9-.2 1.3-.2.3 0 .5 0 .8.1.2 0 .4.1.6.1s.3.1.4.2.2.1.2.1l-.4 1c-.2-.1-.4-.2-.7-.3-.3-.1-.6-.1-1-.1-.3 0-.6.1-.8.2-.3.1-.5.3-.7.5-.2.2-.3.5-.4.8-.1.3-.2.7-.2 1.1 0 .4 0 .7.1 1 .1.3.2.6.4.8s.4.4.7.5c.3.1.6.2 1 .2s.8 0 1.1-.1c.3-.1.5-.2.6-.3l.3 1c-.1.1-.2.1-.3.2s-.3.1-.5.2c-.2 0-.4.1-.6.1-.2-.4-.4-.3-.7-.3zM205 89.3c-.2-.3-.4-.5-.6-.8-.2-.3-.5-.6-.7-.9-.2-.3-.5-.5-.8-.8-.3-.2-.5-.5-.8-.6v3.1h-1.3v-6.9h1.3v2.9l.7-.7c.2-.2.5-.5.7-.8.2-.3.5-.5.7-.7.2-.2.4-.5.6-.6h1.5c-.2.3-.5.5-.7.8s-.5.5-.8.8c-.3.3-.5.6-.8.8l-.8.8c.3.2.6.5.9.7l.9.9c.3.3.5.7.8 1s.5.7.7 1H205zM208.9 82.4c.1.3.3.6.5.9.2.4.4.8.5 1.2l.6 1.2c.2.4.4.8.5 1.2.2-.4.3-.7.5-1.2l.6-1.2c.2-.4.4-.8.5-1.2.2-.4.3-.7.5-.9h1.1c.1.5.1 1 .2 1.6.1.6.1 1.2.1 1.8 0 .6.1 1.2.1 1.8 0 .6.1 1.2.1 1.8h-1.2c0-.8-.1-1.6-.1-2.5 0-.9-.1-1.7-.2-2.5-.1.2-.2.3-.3.5-.1.2-.2.4-.3.7s-.2.5-.3.8-.2.5-.3.8-.2.5-.3.7c-.1.2-.2.4-.2.6h-.9c-.1-.2-.1-.3-.2-.6-.1-.2-.2-.5-.3-.7-.1-.2-.2-.5-.3-.8s-.2-.5-.3-.8c-.1-.2-.2-.5-.3-.7-.1-.2-.2-.4-.3-.5-.1.8-.1 1.6-.2 2.5 0 .9-.1 1.7-.1 2.5h-1.2c0-.6.1-1.2.1-1.8 0-.6.1-1.2.1-1.8 0-.6.1-1.2.1-1.8.1-.6.1-1.1.2-1.6h1zM216.2 89.3v-6.9h4.4v1.1h-3.2v1.7h2.8v1.1h-2.8v2h3.4v1.1h-4.6zM226.5 88.2v1.1h-4.4v-6.9h1.3v5.8h3.1zM233.3 85.8c0 .6-.1 1.1-.3 1.6-.2.4-.5.8-.8 1.1-.3.3-.8.5-1.2.7-.5.1-1 .2-1.6.2h-1c-.4 0-.7-.1-1-.1v-6.7c.3-.1.7-.1 1-.1h1c.6 0 1.1.1 1.6.2s.9.3 1.2.6c.3.3.6.7.8 1.1.2.3.3.8.3 1.4zm-4.6 2.5h.8c.8 0 1.5-.2 1.9-.6.4-.4.6-1 .6-1.8s-.2-1.4-.6-1.8-1-.6-1.9-.6h-.8v4.8zM237.4 89.5c-.5 0-.9-.1-1.2-.2-.3-.1-.6-.3-.8-.6-.2-.2-.4-.5-.5-.9s-.2-.7-.2-1.1v-4.3h1.3v4.2c0 .3 0 .6.1.8.1.2.2.4.3.5s.3.2.5.3c.2.1.4.1.6.1.2 0 .4 0 .6-.1.2-.1.3-.2.5-.3.1-.1.2-.3.3-.5s.1-.5.1-.8v-4.2h1.3v4.3c0 .4-.1.8-.2 1.1s-.3.6-.5.9c-.2.2-.5.4-.9.6s-.9.2-1.3.2zM246.4 89.3c-.2-.4-.5-.8-.8-1.2-.3-.4-.6-.9-.9-1.3-.3-.4-.6-.9-.9-1.3s-.6-.8-.9-1.1v5h-1.2v-6.9h1c.3.3.6.6.9 1l.9 1.2.9 1.2c.3.4.5.8.8 1.2v-4.6h1.2v6.9h-1zM252.4 83.3c-.7 0-1.3.2-1.6.7-.4.4-.6 1.1-.6 1.8 0 .4 0 .7.1 1 .1.3.2.6.4.8.2.2.4.4.7.5s.6.2.9.2h.6c.2 0 .3 0 .4-.1v-2.5h1.3V89c-.2.1-.5.1-.9.2s-.9.1-1.4.1c-.5 0-1-.1-1.4-.2-.4-.2-.8-.4-1.1-.7s-.5-.7-.7-1.1c-.2-.4-.2-1-.2-1.5s.1-1.1.3-1.5c.2-.4.4-.8.7-1.1.3-.3.7-.5 1.1-.7.4-.2.9-.2 1.3-.2.3 0 .6 0 .9.1.2 0 .5.1.6.1s.3.1.4.2.2.1.2.1l-.4 1c-.2-.1-.4-.2-.7-.3-.3-.1-.6-.2-.9-.2z"
        className="st1"
      />
    </g>
    <path d="M282.6 11.1v-.3h-42.8v42.9h.2z" className="st1" />
    <path
      d="m244.714 34.984 18.738-18.738 28.213 28.214-18.738 18.738zM628.7 62.4v.3h-42.9V19.8h.3z"
      className="st1"
    />
    <path
      d="m590.667 38.509 28.213-28.214 18.739 18.738-28.214 28.214z"
      className="st1"
    />
  </svg>
)
export default SvgComponent
